// This file is auto-generated by @hey-api/openapi-ts

export const AbbCmsRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "abb-cms",
      title: "Type",
      default: "abb-cms",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  title: "AbbCmsRegisters",
} as const;

export const AbbEmax2RegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "abb-emax2",
      title: "Type",
      default: "abb-emax2",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  title: "AbbEmax2Registers",
} as const;

export const AcChargingPole3Phase_InputSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "charging_pole_3phase",
      title: "Type",
      default: "charging_pole_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    pin_to_phase_mapping: {
      anyOf: [
        {
          $ref: "#/components/schemas/PinToPhaseMapping",
        },
        {
          type: "null",
        },
      ],
      description:
        "Defines how charging pole pins map to the collectors' phases. For more information see the 'Key Concepts - Site configuration' section in the documentation. Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "scheduled",
    },
  },
  type: "object",
  required: ["name", "collector", "line_current"],
  title: "AcChargingPole3Phase",
} as const;

export const AcChargingPole3Phase_OutputSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "charging_pole_3phase",
      title: "Type",
      default: "charging_pole_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    pin_to_phase_mapping: {
      anyOf: [
        {
          $ref: "#/components/schemas/PinToPhaseMapping",
        },
        {
          type: "null",
        },
      ],
      description:
        "Defines how charging pole pins map to the collectors' phases. For more information see the 'Key Concepts - Site configuration' section in the documentation. Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "scheduled",
    },
  },
  type: "object",
  required: ["name", "collector", "line_current"],
  title: "AcChargingPole3Phase",
} as const;

export const AcChargingPole3PhaseWithIoConfigSchema = {
  properties: {
    io: {
      $ref: "#/components/schemas/IoConfig",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "charging_pole_3phase",
      title: "Type",
      default: "charging_pole_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    pin_to_phase_mapping: {
      anyOf: [
        {
          $ref: "#/components/schemas/PinToPhaseMapping",
        },
        {
          type: "null",
        },
      ],
      description:
        "Defines how charging pole pins map to the collectors' phases. For more information see the 'Key Concepts - Site configuration' section in the documentation. Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "scheduled",
    },
  },
  type: "object",
  required: ["io", "name", "collector", "line_current"],
  title: "AcChargingPole3PhaseWithIoConfig",
} as const;

export const AcChargingProfile_InputSchema = {
  properties: {
    default_estimated_departure_time_delta: {
      type: "string",
      format: "duration",
      title: "Default Estimated Departure Time Delta",
      description:
        "The time a vehicle is expected to charge expressed in ISO 8601 time delta, this will be used if we receive an AC transaction with this profile_id, without an estimated departure time.",
      examples: ["PT8H"],
    },
    default_requested_min_energy: {
      type: "integer",
      title: "Default Requested Min Energy",
      description:
        "The default requested minimum energy (Wh) for AC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested minimum energy.",
      examples: [20000],
    },
    default_requested_max_energy: {
      type: "integer",
      title: "Default Requested Max Energy",
      description:
        "The default requested maximum energy (Wh) for AC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested maximum energy.",
      examples: [30000],
    },
    default_minimal_charging_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Default Minimal Charging Current",
      description:
        "The minimal charging current (in Amperes) for AC transactions with this profile. When set, this site-level minimum is applied to every AC transaction with this profile, overriding the per-transaction value. Used to compute minimum power constraints.",
      examples: [6],
    },
    default_allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Default Allow Zero Current",
      description:
        "Whether AC transactions with this profile allow zero current charging periods. When set, this site-level value is applied to every AC transaction with this profile, overriding the per-transaction value. When the transaction is linked to a driver who has registered their car in the driver app, that car's setting takes precedence over this value.",
      examples: [false],
    },
  },
  type: "object",
  required: [
    "default_estimated_departure_time_delta",
    "default_requested_min_energy",
    "default_requested_max_energy",
  ],
  title: "AcChargingProfile",
} as const;

export const AcChargingProfile_OutputSchema = {
  properties: {
    default_estimated_departure_time_delta: {
      type: "string",
      title: "Default Estimated Departure Time Delta",
      description:
        "The time a vehicle is expected to charge expressed in ISO 8601 time delta, this will be used if we receive an AC transaction with this profile_id, without an estimated departure time.",
      examples: ["PT8H"],
    },
    default_requested_min_energy: {
      type: "integer",
      title: "Default Requested Min Energy",
      description:
        "The default requested minimum energy (Wh) for AC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested minimum energy.",
      examples: [20000],
    },
    default_requested_max_energy: {
      type: "integer",
      title: "Default Requested Max Energy",
      description:
        "The default requested maximum energy (Wh) for AC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested maximum energy.",
      examples: [30000],
    },
    default_minimal_charging_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Default Minimal Charging Current",
      description:
        "The minimal charging current (in Amperes) for AC transactions with this profile. When set, this site-level minimum is applied to every AC transaction with this profile, overriding the per-transaction value. Used to compute minimum power constraints.",
      examples: [6],
    },
    default_allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Default Allow Zero Current",
      description:
        "Whether AC transactions with this profile allow zero current charging periods. When set, this site-level value is applied to every AC transaction with this profile, overriding the per-transaction value. When the transaction is linked to a driver who has registered their car in the driver app, that car's setting takes precedence over this value.",
      examples: [false],
    },
  },
  type: "object",
  required: [
    "default_estimated_departure_time_delta",
    "default_requested_min_energy",
    "default_requested_max_energy",
  ],
  title: "AcChargingProfile",
} as const;

export const AcDriverInputRequestSchema = {
  properties: {
    type: {
      type: "string",
      const: "ac",
      title: "Type",
      default: "ac",
    },
    requested_min_energy: {
      type: "integer",
      minimum: 0,
      title: "Requested Min Energy",
      description: "Requested energy in Wh",
      examples: [20000],
    },
    requested_max_energy: {
      type: "integer",
      minimum: 0,
      title: "Requested Max Energy",
      description: "Requested energy in Wh",
      examples: [20000],
    },
    estimated_departure_time: {
      type: "string",
      format: "date-time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "requested_min_energy",
    "requested_max_energy",
    "estimated_departure_time",
  ],
  title: "AcDriverInputRequest",
} as const;

export const AcDriverPreferencesOverwriteRequestSchema = {
  properties: {
    type: {
      type: "string",
      const: "ac",
      title: "Type",
      default: "ac",
    },
    requested_min_energy: {
      type: "integer",
      title: "Requested Min Energy",
    },
    requested_max_energy: {
      type: "integer",
      title: "Requested Max Energy",
    },
    estimated_departure_time: {
      type: "string",
      format: "date-time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "requested_min_energy",
    "requested_max_energy",
    "estimated_departure_time",
  ],
  title: "AcDriverPreferencesOverwriteRequest",
} as const;

export const AcMqttTransactionSchema = {
  properties: {
    assetId: {
      type: "string",
      title: "Assetid",
      description:
        "The unique identifier of the charging pole asset. This matches the name in the site configuration.",
      examples: ["charger-A1"],
    },
    transactionId: {
      type: "string",
      title: "Transactionid",
      description:
        "The unique identifier for this transaction. This is generated by the charging pole and must be globally unique (e.g. a UUID).",
      examples: ["550e8400-e29b-41d4-a716-446655440000"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
      description:
        "The timestamp when the transaction state changed (e.g. started, updated, EV suspended, stopped, etc).",
      examples: ["2025-11-05T08:48:00.000Z"],
    },
    transactionState: {
      $ref: "#/components/schemas/TransactionState",
      description:
        "The reason why the transaction message is sent (e.g. started, updated, EV suspended, stopped, etc).",
      examples: ["Started"],
    },
    startTime: {
      type: "string",
      format: "date-time",
      title: "Starttime",
      description:
        "The timestamp when the transaction started (i.e. when the vehicle was connected and charging began).",
      examples: ["2025-11-05T08:48:00.000Z"],
    },
    stopTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stoptime",
      description:
        "The timestamp when the transaction stopped (i.e. when the vehicle disconnected). This can be null/omitted if the transaction is still ongoing.",
      examples: [null, "2025-11-05T18:48:00.000Z"],
    },
    estimatedDepartureTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimateddeparturetime",
      description:
        "The estimated time when the vehicle will depart and no longer be connected to the charging pole. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. If the estimated departure time changes, an 'Update' event must be sent with the new estimated departure time. If the vehicle leaves earlier than the estimated departure time, it might not have received the requested amount of energy. If it leaves after the estimated departure time, the optimizer has less flexibility in planning the vehicle and will result in less optimal schedules. If a profile_id is passed and the corresponding profile is configured, the estimatedDepartureTime will be set to the profile's default duration after startTime if not provided in the transaction.",
      examples: ["2025-11-05T17:48:00.000Z"],
    },
    priority: {
      type: "integer",
      maximum: 10,
      minimum: 0,
      title: "Priority",
      description:
        "The priority of the transaction. This is used to determine which transactions to optimize first when there is not enough capacity to optimize all transactions. Lower values indicate higher priority.",
      examples: [5],
    },
    userId: {
      type: "string",
      title: "Userid",
      description:
        "The user identifier for this transaction. This should be the badge ID of the user.",
      default: "default",
    },
    type: {
      type: "string",
      const: "ac",
      title: "Type",
      description:
        "The type of the transaction, must be 'ac' for AC transactions",
      default: "ac",
    },
    noChargingPhases: {
      anyOf: [
        {
          type: "string",
          enum: ["3Phase", "2Phase", "1Phase"],
        },
        {
          type: "null",
        },
      ],
      title: "Nochargingphases",
      description: "The number of phases used for charging.",
      examples: ["3Phase", "2Phase", "1Phase"],
    },
    usedChargingPins: {
      anyOf: [
        {
          items: {
            type: "string",
            enum: ["pin1", "pin2", "pin3"],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Usedchargingpins",
      description:
        "The pins used for charging. This should match the `noChargingPhases` field. If `noChargingPhases` is `3Phase`, this should contain 3 pins. If `noChargingPhases` is `1Phase`, this should contain 1 pin.",
      examples: [
        ["pin1", "pin2", "pin3"],
        ["pin1", "pin2"],
      ],
    },
    maxPower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Maxpower",
      description:
        "The maximum power (in W) that the vehicle is able to charge. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. It can be measured by allowing the vehicle to charge at max power for a short period of time and then reading the power it charges at or can be estimated based on the vehicle type or number of charging phases (e.g. 3.5 kW per phase).",
      examples: [10500],
    },
    initialEnergyValue: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Initialenergyvalue",
      description:
        "The meter value of the charging pole when the transaction started (in Wh). If not sent, it will be based on `energyValue` of the energy measurements for this charging pole",
      examples: [1361389],
    },
    requestedMinEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedminenergy",
      description:
        "The minimum amount of energy (in Wh) that the vehicle needs to have charged by the estimated departure time. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. If a profile_id is passed and the corresponding profile is configured, the requestedMinEnergy will be set to the profile's default requestedMinEnergy if not provided in the transaction.",
      examples: [30000],
    },
    requestedMaxEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedmaxenergy",
      description:
        "The maximum amount of energy (in Wh) that the vehicle can accept. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. This should be greater than or equal to `requestedMinEnergy`. If you don't know the maximum or want to charge a fixed amount, you can set it equal to the requestedMinEnergy. If a profile_id is passed and the corresponding profile is configured, the requestedMaxEnergy will be set to the profile's default requestedMaxEnergy if not provided in the transaction.",
      examples: [30000],
    },
  },
  type: "object",
  required: [
    "assetId",
    "transactionId",
    "timestamp",
    "transactionState",
    "startTime",
    "priority",
  ],
  title: "AcMqttTransaction",
} as const;

export const AcTransactionSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    assetId: {
      type: "string",
      title: "Assetid",
      examples: ["charger-A1"],
    },
    transactionId: {
      type: "string",
      title: "Transactionid",
      description:
        "A unique identifier that should be provided for each transaction",
      examples: ["550e8400-e29b-41d4-a716-446655440000"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    transactionState: {
      $ref: "#/components/schemas/TransactionState",
    },
    startTime: {
      type: "string",
      format: "date-time",
      title: "Starttime",
    },
    stopTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stoptime",
    },
    estimatedDepartureTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimateddeparturetime",
    },
    priority: {
      type: "integer",
      maximum: 10,
      minimum: 0,
      title: "Priority",
      examples: [5],
    },
    profile_id: {
      type: "string",
      title: "Profile Id",
      default: "default",
      examples: ["default"],
    },
    driver_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Id",
      description:
        "Driver profile associated with the transaction. This can be used to overwrite departure time and requested energy for specific drivers.",
    },
    received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Received At",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Allow Zero Current",
      description:
        "Indicates whether the EVSE or EV linked to the transaction allows for zero current charging periods.",
      default: true,
    },
    type: {
      type: "string",
      const: "ac",
      title: "Type",
      default: "ac",
    },
    usedChargingPins: {
      anyOf: [
        {
          items: {
            type: "string",
            enum: ["pin1", "pin2", "pin3"],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Usedchargingpins",
      examples: [["pin1", "pin2", "pin3"]],
    },
    maxPower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Maxpower",
      examples: [10500],
    },
    initial_energy_value: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Initial Energy Value",
      examples: [1361389],
    },
    requestedMinEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedminenergy",
      examples: [30000],
    },
    requestedMaxEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedmaxenergy",
      examples: [30000],
    },
    minimal_charging_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Minimal Charging Current",
      default: 6,
      examples: [6],
    },
    nb_of_phases: {
      type: "integer",
      title: "Nb Of Phases",
      readOnly: true,
    },
  },
  type: "object",
  required: [
    "site_id",
    "assetId",
    "transactionId",
    "timestamp",
    "transactionState",
    "startTime",
    "priority",
    "partner_id",
    "usedChargingPins",
    "maxPower",
    "requestedMinEnergy",
    "requestedMaxEnergy",
    "nb_of_phases",
  ],
  title: "AcTransaction",
} as const;

export const ActiveSocketSchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    last_seen_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Seen At",
    },
    connected: {
      type: "boolean",
      title: "Connected",
      default: false,
    },
    max_evse_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Max Evse Id",
    },
    latest_transaction_starts: {
      items: {
        $ref: "#/components/schemas/TransactionStart",
      },
      type: "array",
      title: "Latest Transaction Starts",
    },
  },
  type: "object",
  required: ["id"],
  title: "ActiveSocket",
} as const;

export const ActiveTransactionEnergySchema = {
  properties: {
    transaction_id: {
      type: "string",
      title: "Transaction Id",
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    transaction_type: {
      $ref: "#/components/schemas/TransactionType",
    },
    badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Id",
    },
    driver_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Id",
    },
    transaction_state: {
      $ref: "#/components/schemas/TransactionState",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    ended_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Ended At",
    },
    estimated_departure_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Departure Time",
    },
    was_suspended: {
      type: "boolean",
      title: "Was Suspended",
    },
    ended_while_suspended: {
      type: "boolean",
      title: "Ended While Suspended",
    },
    energy_requested_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energy Requested Wh",
    },
    energy_delivered_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energy Delivered Wh",
    },
    missed_energy: {
      anyOf: [
        {
          $ref: "#/components/schemas/MissedEnergy",
        },
        {
          type: "null",
        },
      ],
    },
    requested_min_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min Energy",
    },
    requested_max_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Max Energy",
    },
    requested_min_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min State Of Charge",
    },
    requested_max_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Max State Of Charge",
    },
  },
  type: "object",
  required: [
    "transaction_id",
    "asset_id",
    "transaction_type",
    "badge_id",
    "driver_id",
    "transaction_state",
    "started_at",
    "ended_at",
    "estimated_departure_time",
    "was_suspended",
    "ended_while_suspended",
    "energy_requested_wh",
    "energy_delivered_wh",
    "missed_energy",
    "requested_min_energy",
    "requested_max_energy",
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
  ],
  title: "ActiveTransactionEnergy",
} as const;

export const ActiveTransactionResponseSchema = {
  properties: {
    transaction: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverAcTransactionDTO",
        },
        {
          $ref: "#/components/schemas/DriverDcTransactionDTO",
        },
      ],
      title: "Transaction",
    },
    energy_charged: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energy Charged",
    },
    current_state_of_charge: {
      anyOf: [
        {
          $ref: "#/components/schemas/CurrentStateOfCharge",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["transaction", "energy_charged"],
  title: "ActiveTransactionResponse",
} as const;

export const AdminSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    oauth_clients: {
      items: {
        $ref: "#/components/schemas/OAuthCredentials",
      },
      type: "array",
      title: "Oauth Clients",
    },
    one_time_token: {
      anyOf: [
        {
          $ref: "#/components/schemas/OneTimeToken",
        },
        {
          type: "null",
        },
      ],
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
    type: {
      type: "string",
      const: "admin",
      title: "Type",
      default: "admin",
    },
  },
  type: "object",
  required: ["oauth_clients"],
  title: "Admin",
} as const;

export const Advice_InputSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    site_id: {
      type: "string",
      title: "Site Id",
    },
    transaction_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Transaction Id",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    advice_id: {
      type: "string",
      title: "Advice Id",
    },
    status: {
      type: "string",
      const: "OptimizationFound",
      title: "Status",
      default: "OptimizationFound",
    },
    profile: {
      items: {
        $ref: "#/components/schemas/AdviceProfile-Input",
      },
      type: "array",
      title: "Profile",
    },
  },
  type: "object",
  required: ["asset_id", "site_id", "timestamp", "advice_id", "profile"],
  title: "Advice",
} as const;

export const Advice_OutputSchema = {
  properties: {
    assetId: {
      type: "string",
      title: "Assetid",
    },
    siteId: {
      type: "string",
      title: "Siteid",
    },
    transactionId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Transactionid",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    adviceId: {
      type: "string",
      title: "Adviceid",
    },
    status: {
      type: "string",
      const: "OptimizationFound",
      title: "Status",
      default: "OptimizationFound",
    },
    profile: {
      items: {
        $ref: "#/components/schemas/AdviceProfile-Output",
      },
      type: "array",
      title: "Profile",
    },
  },
  type: "object",
  required: ["assetId", "siteId", "timestamp", "adviceId", "profile"],
  title: "Advice",
} as const;

export const AdviceProfile_InputSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    power_value: {
      type: "integer",
      title: "Power Value",
    },
    current_value: {
      type: "number",
      title: "Current Value",
    },
  },
  type: "object",
  required: ["timestamp", "power_value", "current_value"],
  title: "AdviceProfile",
} as const;

export const AdviceProfile_OutputSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    powerValue: {
      type: "integer",
      title: "Powervalue",
    },
    currentValue: {
      type: "number",
      title: "Currentvalue",
    },
  },
  type: "object",
  required: ["timestamp", "powerValue", "currentValue"],
  title: "AdviceProfile",
} as const;

export const AiegDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "AIEG",
      title: "Dso",
    },
    region: {
      type: "string",
      const: "All",
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "T-MT avec terme capacitaire",
        "T-MT sans terme capacitaire",
        "MT avec terme capacitaire",
        "MT sans terme capacitaire",
        "T-BT avec terme capacitaire",
        "T-BT sans terme capacitaire",
        "BT>56kVA - heures normales",
        "BT>56kVA - heures pleines/creuses",
        "BT - heures normales",
        "BT - heures pleines/creuses",
        "BT - heures incitative",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "AiegDSOConnection",
} as const;

export const AieshDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "AIESH",
      title: "Dso",
    },
    region: {
      type: "string",
      const: "All",
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "T-MT avec terme capacitaire",
        "T-MT sans terme capacitaire",
        "MT avec terme capacitaire",
        "MT sans terme capacitaire",
        "T-BT avec terme capacitaire",
        "T-BT sans terme capacitaire",
        "BT>56kVA - heures normales",
        "BT>56kVA - heures pleines/creuses",
        "BT - heures normales",
        "BT - heures pleines/creuses",
        "BT - heures incitative",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "AieshDSOConnection",
} as const;

export const AlertParametersSchema = {
  properties: {
    device_unreachable: {
      $ref: "#/components/schemas/DeviceUnreachableAlertParameters",
    },
    device_polling_slowly: {
      $ref: "#/components/schemas/DevicePollingSlowlyAlertParameters",
    },
  },
  type: "object",
  required: ["device_unreachable", "device_polling_slowly"],
  title: "AlertParameters",
  description:
    "The thresholds and durations the controller raises its alerts with, for every device of the site.",
} as const;

export const AlertSettingsSchema = {
  properties: {
    device_unreachable: {
      $ref: "#/components/schemas/DeviceUnreachableAlertSettings",
    },
    device_polling_slowly: {
      $ref: "#/components/schemas/DevicePollingSlowlyAlertSettings",
    },
    controller_offline: {
      $ref: "#/components/schemas/ControllerOfflineAlertSettings",
    },
  },
  type: "object",
  required: ["device_unreachable", "device_polling_slowly"],
  title: "AlertSettings",
} as const;

export const AlertSubscriptionSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    channels: {
      items: {
        oneOf: [
          {
            $ref: "#/components/schemas/MailAlertChannel",
          },
        ],
        discriminator: {
          propertyName: "channel",
          mapping: {
            MAIL: "#/components/schemas/MailAlertChannel",
          },
        },
      },
      type: "array",
      title: "Channels",
    },
    site_filter: {
      $ref: "#/components/schemas/SiteFilter",
    },
    event_filter: {
      items: {
        $ref: "#/components/schemas/ValidationEventFilter",
      },
      type: "array",
      title: "Event Filter",
    },
  },
  type: "object",
  required: ["partner_id", "channels", "site_filter", "event_filter"],
  title: "AlertSubscription",
} as const;

export const AlertSubscriptionDTOSchema = {
  properties: {
    channels: {
      items: {
        oneOf: [
          {
            $ref: "#/components/schemas/MailAlertChannel",
          },
        ],
        discriminator: {
          propertyName: "channel",
          mapping: {
            MAIL: "#/components/schemas/MailAlertChannel",
          },
        },
      },
      type: "array",
      title: "Channels",
    },
    site_filter: {
      $ref: "#/components/schemas/SiteFilter",
    },
    event_filter: {
      items: {
        $ref: "#/components/schemas/ValidationEventFilter",
      },
      type: "array",
      title: "Event Filter",
    },
  },
  type: "object",
  required: ["channels", "site_filter", "event_filter"],
  title: "AlertSubscriptionDTO",
} as const;

export const AlertmanagerAlertSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ControllerAlertStatus",
    },
    labels: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Labels",
    },
    annotations: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Annotations",
    },
    startsAt: {
      type: "string",
      format: "date-time",
      title: "Startsat",
    },
    endsAt: {
      type: "string",
      format: "date-time",
      title: "Endsat",
    },
    fingerprint: {
      type: "string",
      title: "Fingerprint",
    },
  },
  type: "object",
  required: ["status", "labels", "startsAt", "endsAt", "fingerprint"],
  title: "AlertmanagerAlert",
} as const;

export const AlertmanagerWebhookPayloadSchema = {
  properties: {
    alerts: {
      items: {
        $ref: "#/components/schemas/AlertmanagerAlert",
      },
      type: "array",
      title: "Alerts",
    },
  },
  type: "object",
  required: ["alerts"],
  title: "AlertmanagerWebhookPayload",
  description: `The body Prometheus Alertmanager posts to a webhook receiver: every alert in one notification group, with
its current status.`,
} as const;

export const AlfenRegistersSchema = {
  properties: {
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Modbus connector index of the charging pole on the charger.",
    },
    type: {
      type: "string",
      const: "alfen",
      title: "Type",
      default: "alfen",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "AlfenRegisters",
} as const;

export const AlgodueUpm209RegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "algodue-upm209",
      title: "Type",
      default: "algodue-upm209",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "AlgodueUpm209Registers",
} as const;

export const AlpitronixHyperchargerRegistersSchema = {
  properties: {
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Modbus connector index of the charging pole on the charger.",
    },
    type: {
      type: "string",
      const: "alpitronix-hypercharger",
      title: "Type",
      default: "alpitronix-hypercharger",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "AlpitronixHyperchargerRegisters",
} as const;

export const AssetIOConfig_InputSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    config: {
      $ref: "#/components/schemas/StoredIoConfig-Input",
    },
    brand: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Brand",
      description:
        "Optional hardware brand of the physical device (e.g. 'Alfen'). Descriptive metadata for the dashboard; not used by the optimizer.",
      examples: ["Alfen"],
    },
    model: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Model",
      description:
        "Optional hardware model of the physical device (e.g. 'Eve Single Pro-line'). Descriptive metadata for the dashboard; not used by the optimizer.",
      examples: ["Eve Single Pro-line"],
    },
  },
  type: "object",
  required: ["asset_id", "config"],
  title: "AssetIOConfig",
} as const;

export const AssetIOConfig_OutputSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    config: {
      $ref: "#/components/schemas/StoredIoConfig-Output",
    },
    brand: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Brand",
      description:
        "Optional hardware brand of the physical device (e.g. 'Alfen'). Descriptive metadata for the dashboard; not used by the optimizer.",
      examples: ["Alfen"],
    },
    model: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Model",
      description:
        "Optional hardware model of the physical device (e.g. 'Eve Single Pro-line'). Descriptive metadata for the dashboard; not used by the optimizer.",
      examples: ["Eve Single Pro-line"],
    },
  },
  type: "object",
  required: ["asset_id", "config"],
  title: "AssetIOConfig",
} as const;

export const AssetIngressValidationConfig_InputSchema = {
  properties: {
    with_transaction_expected_measurement_interval: {
      type: "string",
      format: "duration",
      title: "With Transaction Expected Measurement Interval",
      description:
        "Expected measurement interval for the asset while it has an active transaction. Measurements arriving less frequently than this are flagged as stale by ingress validation. Note: the UCL calculation requires measurements at least every 5 minutes to produce accurate results, so this value should not exceed 5 minutes for assets that participate in the uncontrollable-load computation.",
    },
    without_transaction_expected_measurement_interval: {
      anyOf: [
        {
          type: "string",
          format: "duration",
        },
        {
          type: "null",
        },
      ],
      title: "Without Transaction Expected Measurement Interval",
      description:
        "Expected measurement interval for the asset when no transaction is active. When null, the asset is always considered valid while idle. Note: the UCL calculation requires measurements at least every 5 minutes to produce accurate results, so if this asset contributes to the uncontrollable-load computation it should still report at least every 5 minutes.",
    },
  },
  type: "object",
  title: "AssetIngressValidationConfig",
} as const;

export const AssetIngressValidationConfig_OutputSchema = {
  properties: {
    with_transaction_expected_measurement_interval: {
      type: "number",
      title: "With Transaction Expected Measurement Interval",
      description:
        "Expected measurement interval for the asset while it has an active transaction. Measurements arriving less frequently than this are flagged as stale by ingress validation. Note: the UCL calculation requires measurements at least every 5 minutes to produce accurate results, so this value should not exceed 5 minutes for assets that participate in the uncontrollable-load computation.",
    },
    without_transaction_expected_measurement_interval: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Without Transaction Expected Measurement Interval",
      description:
        "Expected measurement interval for the asset when no transaction is active. When null, the asset is always considered valid while idle. Note: the UCL calculation requires measurements at least every 5 minutes to produce accurate results, so if this asset contributes to the uncontrollable-load computation it should still report at least every 5 minutes.",
    },
  },
  type: "object",
  title: "AssetIngressValidationConfig",
} as const;

export const AssetScheduleSchema = {
  properties: {
    profile: {
      items: {
        $ref: "#/components/schemas/Profile",
      },
      type: "array",
      title: "Profile",
    },
    assetId: {
      type: "string",
      title: "Assetid",
      examples: ["charger-A1"],
    },
    siteId: {
      type: "string",
      title: "Siteid",
      examples: ["site-1"],
    },
    transaction_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Transaction Id",
      examples: ["charger-A1-42"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["profile", "assetId", "siteId", "timestamp"],
  title: "AssetSchedule",
  description:
    "Everything the optimizer decided for one asset, whatever kind of profile that takes.",
} as const;

export const AssetScheduleDTOSchema = {
  properties: {
    profile: {
      items: {
        $ref: "#/components/schemas/Profile",
      },
      type: "array",
      title: "Profile",
    },
    assetId: {
      type: "string",
      title: "Assetid",
      examples: ["charger-A1"],
    },
    siteId: {
      type: "string",
      title: "Siteid",
      examples: ["site-1"],
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["profile", "assetId", "siteId", "partner_id", "timestamp"],
  title: "AssetScheduleDTO",
  description:
    "One asset's schedule lifted out of the site schedule it was stored in.",
} as const;

export const AutelRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "autel",
      title: "Type",
      default: "autel",
    },
    connector_id: {
      type: "integer",
      maximum: 8,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which of the charger's register blocks (offset by 1000 per connector) this connector reads and writes.",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "AutelRegisters",
} as const;

export const AutoExcludedDaysWarningSchema = {
  properties: {
    excluded_days: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Excluded Days",
    },
    message: {
      type: "string",
      title: "Message",
      default:
        "Some days with data anomalies were detected and automatically excluded.",
    },
    type: {
      type: "string",
      const: "auto-excluded-days",
      title: "Type",
      default: "auto-excluded-days",
    },
  },
  type: "object",
  required: ["excluded_days"],
  title: "AutoExcludedDaysWarning",
} as const;

export const BaseModelSchema = {
  properties: {},
  type: "object",
  title: "BaseModel",
} as const;

export const BaselineWithoutBessWarningSchema = {
  properties: {
    message: {
      type: "string",
      title: "Message",
      default:
        "The benefit reporting compares scenarios with and without Pleevi EMS. Since a BESS requires an EMS, the benefits of the BESS are quantified relative to the scenario without a BESS.",
    },
    type: {
      type: "string",
      const: "bess-excluded-from-load-balancing",
      title: "Type",
      default: "bess-excluded-from-load-balancing",
    },
  },
  type: "object",
  title: "BaselineWithoutBessWarning",
} as const;

export const BatchCreateDriversDTOSchema = {
  properties: {
    drivers: {
      items: {
        $ref: "#/components/schemas/CreateDriverDTO",
      },
      type: "array",
      title: "Drivers",
    },
  },
  type: "object",
  required: ["drivers"],
  title: "BatchCreateDriversDTO",
} as const;

export const BatteryPowerFilteredMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "batteryPower.filtered:2",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    batteryStatus: {
      anyOf: [
        {
          type: "string",
          enum: ["on", "off", "other"],
        },
        {
          type: "null",
        },
      ],
      title: "Batterystatus",
    },
    frequency: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Frequency",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    stateOfCharge: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Stateofcharge",
    },
    availableEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableenergy",
    },
    ratedEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ratedenergy",
    },
    availableActivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    batteryEnergyStorageSystems: {
      anyOf: [
        {
          items: {
            additionalProperties: true,
            type: "object",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Batteryenergystoragesystems",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Errors",
    },
    scheduleCompleteUntil: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Schedulecompleteuntil",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "BatteryPowerFilteredMessage",
} as const;

export const BatteryPowerFlashMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "batteryPower.flash:1",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    frequency: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Frequency",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    availableEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableenergy",
    },
    availableActivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    stateOfCharge: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Stateofcharge",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "BatteryPowerFlashMessage",
} as const;

export const BatteryPowerMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "batteryPower:2",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    batteryStatus: {
      anyOf: [
        {
          type: "string",
          enum: ["on", "off", "other"],
        },
        {
          type: "null",
        },
      ],
      title: "Batterystatus",
    },
    energy: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Energy",
    },
    frequency: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Frequency",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    reactivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Reactivepower",
    },
    powerFactor: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Powerfactor",
    },
    stateOfCharge: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Stateofcharge",
    },
    stateOfHealth: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Stateofhealth",
    },
    availableEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableenergy",
    },
    ratedEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ratedenergy",
    },
    availableActivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    availableReactivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Availablereactivepower",
    },
    activePowerSetpoint: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Activepowersetpoint",
    },
    batteryEnergyStorageSystems: {
      anyOf: [
        {
          items: {
            additionalProperties: true,
            type: "object",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Batteryenergystoragesystems",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Errors",
    },
    scheduleCompleteUntil: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Schedulecompleteuntil",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "BatteryPowerMessage",
} as const;

export const BenefitReportSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    site_id: {
      type: "string",
      title: "Site Id",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    period: {
      $ref: "#/components/schemas/YearMonth",
    },
    computed_at: {
      type: "string",
      format: "date-time",
      title: "Computed At",
    },
    live: {
      $ref: "#/components/schemas/SiteKPIs",
    },
    load_balancing: {
      $ref: "#/components/schemas/SiteKPIs",
    },
    diff: {
      $ref: "#/components/schemas/SiteKPIs",
    },
    grid_power_chart: {
      items: {
        $ref: "#/components/schemas/GridPowerDataPoint",
      },
      type: "array",
      title: "Grid Power Chart",
    },
    warnings: {
      items: {
        anyOf: [
          {
            $ref: "#/components/schemas/KpiNotCalculatedWarning",
          },
          {
            $ref: "#/components/schemas/AutoExcludedDaysWarning",
          },
          {
            $ref: "#/components/schemas/MissingContractWarning",
          },
          {
            $ref: "#/components/schemas/DataPreprocessingWarning",
          },
          {
            $ref: "#/components/schemas/BaselineWithoutBessWarning",
          },
        ],
      },
      type: "array",
      title: "Warnings",
    },
  },
  type: "object",
  required: [
    "site_id",
    "partner_id",
    "period",
    "computed_at",
    "live",
    "load_balancing",
    "diff",
  ],
  title: "BenefitReport",
} as const;

export const BessDevice_InputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "battery_energy_storage_system",
      title: "Type",
      default: "battery_energy_storage_system",
    },
    charging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Charging Efficiency",
      description: "Charging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    discharging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Discharging Efficiency",
      description: "Discharging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    maximum_charging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Charging Power",
      description: "Maximum charging power of the battery in W.",
      examples: [50000],
    },
    maximum_discharging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Discharging Power",
      description: "Maximum discharging power of the battery in W.",
      examples: [50000],
    },
    operational_battery_capacity: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Operational Battery Capacity",
      description: "The operational battery capacity in Wh.",
      examples: [100000],
    },
    charging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Charging Priority",
      description: "Priority of charging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    discharging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Discharging Priority",
      description: "Priority of discharging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    cycle_cost_euros_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Cycle Cost Euros Per Mwh",
      description:
        "Wear cost of a full cycle, in EUR per MWh cycled: charging 1 MWh and discharging it again costs this amount once. Half is attributed to charging and half to discharging, measured at the battery terminals.",
      default: 30,
      examples: [30],
    },
    policies: {
      items: {
        $ref: "#/components/schemas/BessPolicy-Input",
      },
      type: "array",
      title: "Policies",
      description: "List of policies for the BESS device.",
      default: [],
    },
  },
  type: "object",
  required: [
    "name",
    "collector",
    "maximum_charging_power",
    "maximum_discharging_power",
    "operational_battery_capacity",
  ],
  title: "BessDevice",
} as const;

export const BessDevice_OutputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "battery_energy_storage_system",
      title: "Type",
      default: "battery_energy_storage_system",
    },
    charging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Charging Efficiency",
      description: "Charging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    discharging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Discharging Efficiency",
      description: "Discharging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    maximum_charging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Charging Power",
      description: "Maximum charging power of the battery in W.",
      examples: [50000],
    },
    maximum_discharging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Discharging Power",
      description: "Maximum discharging power of the battery in W.",
      examples: [50000],
    },
    operational_battery_capacity: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Operational Battery Capacity",
      description: "The operational battery capacity in Wh.",
      examples: [100000],
    },
    charging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Charging Priority",
      description: "Priority of charging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    discharging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Discharging Priority",
      description: "Priority of discharging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    cycle_cost_euros_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Cycle Cost Euros Per Mwh",
      description:
        "Wear cost of a full cycle, in EUR per MWh cycled: charging 1 MWh and discharging it again costs this amount once. Half is attributed to charging and half to discharging, measured at the battery terminals.",
      default: 30,
      examples: [30],
    },
    policies: {
      items: {
        $ref: "#/components/schemas/BessPolicy-Output",
      },
      type: "array",
      title: "Policies",
      description: "List of policies for the BESS device.",
      default: [],
    },
  },
  type: "object",
  required: [
    "name",
    "collector",
    "maximum_charging_power",
    "maximum_discharging_power",
    "operational_battery_capacity",
  ],
  title: "BessDevice",
} as const;

export const BessDeviceWithIoConfigSchema = {
  properties: {
    io: {
      $ref: "#/components/schemas/IoConfig",
    },
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "battery_energy_storage_system",
      title: "Type",
      default: "battery_energy_storage_system",
    },
    charging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Charging Efficiency",
      description: "Charging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    discharging_efficiency: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Discharging Efficiency",
      description: "Discharging efficiency of the battery [0 < x <= 1].",
      default: 0.95,
      examples: [0.95],
    },
    maximum_charging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Charging Power",
      description: "Maximum charging power of the battery in W.",
      examples: [50000],
    },
    maximum_discharging_power: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Maximum Discharging Power",
      description: "Maximum discharging power of the battery in W.",
      examples: [50000],
    },
    operational_battery_capacity: {
      type: "number",
      exclusiveMinimum: 0,
      title: "Operational Battery Capacity",
      description: "The operational battery capacity in Wh.",
      examples: [100000],
    },
    charging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Charging Priority",
      description: "Priority of charging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    discharging_priority: {
      type: "integer",
      maximum: 10,
      minimum: 1,
      title: "Discharging Priority",
      description: "Priority of discharging the battery. Default is 10",
      default: 10,
      examples: [5],
    },
    cycle_cost_euros_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Cycle Cost Euros Per Mwh",
      description:
        "Wear cost of a full cycle, in EUR per MWh cycled: charging 1 MWh and discharging it again costs this amount once. Half is attributed to charging and half to discharging, measured at the battery terminals.",
      default: 30,
      examples: [30],
    },
    policies: {
      items: {
        $ref: "#/components/schemas/BessPolicy-Output",
      },
      type: "array",
      title: "Policies",
      description: "List of policies for the BESS device.",
      default: [],
    },
  },
  type: "object",
  required: [
    "io",
    "name",
    "collector",
    "maximum_charging_power",
    "maximum_discharging_power",
    "operational_battery_capacity",
  ],
  title: "BessDeviceWithIoConfig",
} as const;

export const BessHysteresisChargePolicySchema = {
  properties: {
    type: {
      type: "string",
      const: "charge-hysteresis",
      title: "Type",
      default: "charge-hysteresis",
    },
    start_charging_below: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Start Charging Below",
      description:
        "The state of charge at or below which the battery starts charging.",
      examples: [10],
    },
    stop_charging_at: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Stop Charging At",
      description: "The state of charge at which the battery stops charging.",
      examples: [20],
    },
  },
  type: "object",
  required: ["start_charging_below", "stop_charging_at"],
  title: "BessHysteresisChargePolicy",
  description: `Charges the battery when the state of charge drops below \`start_charging_below\` and stops charging once it reaches \`stop_charging_at\`. This policy doesn't influence discharging.

Only executed by Pleevi Edge on the device itself. Pleevi Engine (API-first) optimizations ignore this policy, so it has no effect on Engine-only optimizations. This ensures the battery always has a certain State of Charge while allowing Pleevi Engine to optimize the charging of the remaining part of the battery.`,
} as const;

export const BessPolicy_InputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ScheduledBessPolicy-Input",
    },
    {
      $ref: "#/components/schemas/BessHysteresisChargePolicy",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "charge-hysteresis": "#/components/schemas/BessHysteresisChargePolicy",
      schedule: "#/components/schemas/ScheduledBessPolicy-Input",
    },
  },
} as const;

export const BessPolicy_OutputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ScheduledBessPolicy-Output",
    },
    {
      $ref: "#/components/schemas/BessHysteresisChargePolicy",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "charge-hysteresis": "#/components/schemas/BessHysteresisChargePolicy",
      schedule: "#/components/schemas/ScheduledBessPolicy-Output",
    },
  },
} as const;

export const BiddingZoneSchema = {
  type: "string",
  enum: [
    "DE_50HZ",
    "AL",
    "DE_AMPRION",
    "AT",
    "BY",
    "BE",
    "BA",
    "BG",
    "CZ_DE_SK",
    "HR",
    "CWE",
    "CY",
    "CZ",
    "DE_AT_LU",
    "DE_LU",
    "DK",
    "DK_1",
    "DK_1_NO_1",
    "DK_2",
    "DK_CA",
    "EE",
    "FI",
    "MK",
    "FR",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE_SEM",
    "IE",
    "IT",
    "IT_SACO_AC",
    "IT_CALA",
    "IT_SACO_DC",
    "IT_BRNN",
    "IT_CNOR",
    "IT_CSUD",
    "IT_FOGN",
    "IT_GR",
    "IT_MACRO_NORTH",
    "IT_MACRO_SOUTH",
    "IT_MALTA",
    "IT_NORD",
    "IT_NORD_AT",
    "IT_NORD_CH",
    "IT_NORD_FR",
    "IT_NORD_SI",
    "IT_PRGP",
    "IT_ROSN",
    "IT_SARD",
    "IT_SICI",
    "IT_SUD",
    "RU_KGD",
    "LV",
    "LT",
    "LU",
    "LU_BZN",
    "MT",
    "ME",
    "GB",
    "GE",
    "GB_IFA",
    "GB_IFA2",
    "GB_ELECLINK",
    "UK",
    "NL",
    "NO_1",
    "NO_1A",
    "NO_2",
    "NO_2_NSL",
    "NO_2A",
    "NO_3",
    "NO_4",
    "NO_5",
    "NO",
    "PL_CZ",
    "PL",
    "PT",
    "MD",
    "RO",
    "RU",
    "SE_1",
    "SE_2",
    "SE_3",
    "SE_4",
    "RS",
    "SK",
    "SI",
    "GB_NIR",
    "ES",
    "SE",
    "CH",
    "DE_TENNET",
    "DE_TRANSNET",
    "TR",
    "UA",
    "UA_DOBTPP",
    "UA_BEI",
    "UA_IPS",
    "XK",
    "DE_AMP_LU",
  ],
  title: "BiddingZone",
} as const;

export const Body_clientLoginSchema = {
  properties: {
    grant_type: {
      type: "string",
      enum: ["client_credentials"],
      title: "Grant Type",
      examples: ["client_credentials"],
    },
  },
  type: "object",
  title: "Body_clientLogin",
} as const;

export const BrandingSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    primary_color: {
      $ref: "#/components/schemas/HSLColor",
    },
    primary_foreground_color: {
      $ref: "#/components/schemas/HSLColor",
    },
    primary_glow_color: {
      $ref: "#/components/schemas/HSLColor",
    },
    secondary_color: {
      $ref: "#/components/schemas/HSLColor",
    },
    secondary_foreground_color: {
      $ref: "#/components/schemas/HSLColor",
    },
    logo_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Logo Url",
    },
    external_whitelabel: {
      type: "boolean",
      title: "External Whitelabel",
      default: false,
    },
    driver_app_urls: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverAppUrls",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "name",
    "primary_color",
    "primary_foreground_color",
    "primary_glow_color",
    "secondary_color",
    "secondary_foreground_color",
  ],
  title: "Branding",
} as const;

export const BucketSecondsSchema = {
  type: "integer",
  enum: [900, 3600, 86400],
  title: "BucketSeconds",
} as const;

export const CarloGavazziEm24RegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "carlo-gavazzi-em24",
      title: "Type",
      default: "carlo-gavazzi-em24",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "CarloGavazziEm24Registers",
} as const;

export const ChargerConnectorSchema = {
  properties: {
    name: {
      type: "string",
      minLength: 1,
      title: "Name",
      description: "The asset ID of this charging connector.",
    },
    pin_to_phase_mapping: {
      anyOf: [
        {
          $ref: "#/components/schemas/PinToPhaseMapping",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["name"],
  title: "ChargerConnector",
} as const;

export const ChargingPointSchema = {
  properties: {
    identifier: {
      type: "string",
      title: "Identifier",
    },
    currentType: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Currenttype",
    },
    errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Errors",
    },
    isCharging: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Ischarging",
    },
    vehicleConnected: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Vehicleconnected",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    voltage: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Voltage",
    },
    current: {
      anyOf: [
        {
          additionalProperties: {
            anyOf: [
              {},
              {
                type: "number",
              },
            ],
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Current",
    },
    energyConsumed: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energyconsumed",
    },
    energyProduced: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energyproduced",
    },
    power: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Power",
    },
  },
  type: "object",
  required: ["identifier"],
  title: "ChargingPoint",
} as const;

export const ChargingProfileSchema = {
  properties: {
    type: {
      type: "string",
      const: "charging",
      title: "Type",
      default: "charging",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    powerValue: {
      type: "integer",
      title: "Powervalue",
      examples: [7000],
    },
    currentValue: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Currentvalue",
      examples: [10.43478260869565],
    },
  },
  type: "object",
  required: ["timestamp", "powerValue"],
  title: "ChargingProfile",
} as const;

export const ChargingStrategySchema = {
  type: "string",
  enum: ["load-balancing", "scheduled"],
  title: "ChargingStrategy",
} as const;

export const CharxRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "charx",
      title: "Type",
      default: "charx",
    },
    connector_id: {
      type: "integer",
      maximum: 65,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which of the charger's register blocks (offset by 1000 per charging point) this pole reads and writes.",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "CharxRegisters",
} as const;

export const Collector_InputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case. The root collector is exempt: it is the grid connection, whose phases are the reference frame every other mapping is expressed against, so the controller always treats it as the identity and it may only be left unset or declared as the identity.",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["main_collector"],
    },
    children: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/Collector-Input",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Children",
      description:
        "The children of this collector. This is used to create a tree structure.",
      default: [],
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [400],
    },
    safe_line_current: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Safe Line Current",
      description:
        "An optional, safer line current in Ampere used by the optimizer instead of `line_current` when set.",
      examples: [300],
    },
    min_phase_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Phase Current",
      description:
        "An optional lower bound in Ampere per phase. Set it to `0` on the main collector to forbid injection into the grid.",
      examples: [0],
    },
    phase_voltage: {
      type: "integer",
      title: "Phase Voltage",
      description: "The phase voltage is in Volt.",
      examples: [230],
    },
    commodity: {
      type: "string",
      title: "Commodity",
      default: "electricity",
      examples: ["electricity"],
    },
    "1P_3P": {
      $ref: "#/components/schemas/CollectorType",
      description:
        "Specifies whether the collector is single-phase (`1P`) or three-phase (`3P`).",
      default: "3P",
    },
  },
  type: "object",
  required: ["name", "line_current", "phase_voltage"],
  title: "Collector",
} as const;

export const Collector_OutputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case. The root collector is exempt: it is the grid connection, whose phases are the reference frame every other mapping is expressed against, so the controller always treats it as the identity and it may only be left unset or declared as the identity.",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["main_collector"],
    },
    children: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/Collector-Output",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Children",
      description:
        "The children of this collector. This is used to create a tree structure.",
      default: [],
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [400],
    },
    safe_line_current: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Safe Line Current",
      description:
        "An optional, safer line current in Ampere used by the optimizer instead of `line_current` when set.",
      examples: [300],
    },
    min_phase_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Phase Current",
      description:
        "An optional lower bound in Ampere per phase. Set it to `0` on the main collector to forbid injection into the grid.",
      examples: [0],
    },
    phase_voltage: {
      type: "integer",
      title: "Phase Voltage",
      description: "The phase voltage is in Volt.",
      examples: [230],
    },
    commodity: {
      type: "string",
      title: "Commodity",
      default: "electricity",
      examples: ["electricity"],
    },
    "1P_3P": {
      $ref: "#/components/schemas/CollectorType",
      description:
        "Specifies whether the collector is single-phase (`1P`) or three-phase (`3P`).",
      default: "3P",
    },
    nb_of_phases: {
      type: "integer",
      title: "Nb Of Phases",
      readOnly: true,
    },
  },
  type: "object",
  required: ["name", "line_current", "phase_voltage", "nb_of_phases"],
  title: "Collector",
} as const;

export const CollectorTypeSchema = {
  type: "string",
  enum: ["1P", "3P"],
  title: "CollectorType",
} as const;

export const CollectorWithIoConfigSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case. The root collector is exempt: it is the grid connection, whose phases are the reference frame every other mapping is expressed against, so the controller always treats it as the identity and it may only be left unset or declared as the identity.",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["main_collector"],
    },
    children: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/CollectorWithIoConfig",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Children",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [400],
    },
    safe_line_current: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Safe Line Current",
      description:
        "An optional, safer line current in Ampere used by the optimizer instead of `line_current` when set.",
      examples: [300],
    },
    min_phase_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Phase Current",
      description:
        "An optional lower bound in Ampere per phase. Set it to `0` on the main collector to forbid injection into the grid.",
      examples: [0],
    },
    phase_voltage: {
      type: "integer",
      title: "Phase Voltage",
      description: "The phase voltage is in Volt.",
      examples: [230],
    },
    commodity: {
      type: "string",
      title: "Commodity",
      default: "electricity",
      examples: ["electricity"],
    },
    "1P_3P": {
      $ref: "#/components/schemas/CollectorType",
      description:
        "Specifies whether the collector is single-phase (`1P`) or three-phase (`3P`).",
      default: "3P",
    },
    io: {
      $ref: "#/components/schemas/IoConfig",
    },
    nb_of_phases: {
      type: "integer",
      title: "Nb Of Phases",
      readOnly: true,
    },
  },
  type: "object",
  required: ["name", "line_current", "phase_voltage", "io", "nb_of_phases"],
  title: "CollectorWithIoConfig",
} as const;

export const CompleteUserRegistrationDTOSchema = {
  properties: {
    token: {
      type: "string",
      title: "Token",
    },
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    password: {
      type: "string",
      minLength: 8,
      title: "Password",
    },
  },
  type: "object",
  required: ["token", "email", "password"],
  title: "CompleteUserRegistrationDTO",
} as const;

export const ConfigurationAddedSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
  },
  type: "object",
  title: "ConfigurationAdded",
} as const;

export const ConfigurationBuilder_InputSchema = {
  properties: {
    site_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteConfiguration-Input",
        },
        {
          type: "null",
        },
      ],
    },
    io_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/IOConfiguration-Input",
        },
        {
          type: "null",
        },
      ],
    },
    optimization_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/OptimizationConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    contract: {
      anyOf: [
        {
          $ref: "#/components/schemas/EnergyProviderContract-Input",
        },
        {
          type: "null",
        },
      ],
    },
    revenue: {
      anyOf: [
        {
          $ref: "#/components/schemas/RevenueConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    dso: {
      anyOf: [
        {
          $ref: "#/components/schemas/DSOConnection",
        },
        {
          type: "null",
        },
      ],
    },
    ingress_validation: {
      $ref: "#/components/schemas/SiteIngressValidationConfig-Input",
    },
  },
  type: "object",
  title: "ConfigurationBuilder",
} as const;

export const ConfigurationBuilder_OutputSchema = {
  properties: {
    site_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteConfiguration-Output",
        },
        {
          type: "null",
        },
      ],
    },
    io_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/IOConfiguration-Output",
        },
        {
          type: "null",
        },
      ],
    },
    optimization_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/OptimizationConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    contract: {
      anyOf: [
        {
          $ref: "#/components/schemas/EnergyProviderContract-Output",
        },
        {
          type: "null",
        },
      ],
    },
    revenue: {
      anyOf: [
        {
          $ref: "#/components/schemas/RevenueConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    dso: {
      anyOf: [
        {
          $ref: "#/components/schemas/DSOConnection",
        },
        {
          type: "null",
        },
      ],
    },
    ingress_validation: {
      $ref: "#/components/schemas/SiteIngressValidationConfig-Output",
    },
    forecasting_configuration: {
      $ref: "#/components/schemas/ForecastingConfiguration",
      readOnly: true,
    },
    ucl_calculation_active: {
      type: "boolean",
      title: "Ucl Calculation Active",
      readOnly: true,
    },
  },
  type: "object",
  required: ["forecasting_configuration", "ucl_calculation_active"],
  title: "ConfigurationBuilder",
} as const;

export const ConfigurationCompleteSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    missing_assets: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Missing Assets",
      default: [],
      examples: [["charger-A1", "PV_panel_1"]],
    },
  },
  type: "object",
  title: "ConfigurationComplete",
} as const;

export const Connection_InputSchema = {
  properties: {
    mqtt: {
      anyOf: [
        {
          $ref: "#/components/schemas/MQTTConfig-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "Connection",
} as const;

export const ConnectorAssetMappingSchema = {
  properties: {
    evse_id: {
      type: "integer",
      title: "Evse Id",
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    confidence: {
      type: "number",
      title: "Confidence",
    },
    nb_matching_transactions: {
      type: "integer",
      title: "Nb Matching Transactions",
    },
    nb_considered_transactions: {
      type: "integer",
      title: "Nb Considered Transactions",
    },
  },
  type: "object",
  required: [
    "evse_id",
    "asset_id",
    "confidence",
    "nb_matching_transactions",
    "nb_considered_transactions",
  ],
  title: "ConnectorAssetMapping",
} as const;

export const ContinuousScheduleSchema = {
  properties: {
    frequency: {
      type: "string",
      const: "continuous",
      title: "Frequency",
      default: "continuous",
    },
  },
  type: "object",
  title: "ContinuousSchedule",
  description: "Schedule that is active at every timestep.",
} as const;

export const ControllerAlertDTOSchema = {
  properties: {
    alert_id: {
      type: "string",
      title: "Alert Id",
      description: "The identifier of this alert.",
    },
    controller_id: {
      type: "string",
      title: "Controller Id",
      description: "The controller that raised the alert.",
    },
    alert_name: {
      type: "string",
      title: "Alert Name",
      description:
        "What kind of alert this is: DeviceUnreachable, DevicePollingSlowly or ControllerOffline.",
      examples: ["DeviceUnreachable"],
    },
    asset_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Asset Id",
      description: "The asset the alert is about, if it is about one.",
      examples: ["LR34_001"],
    },
    status: {
      $ref: "#/components/schemas/ControllerAlertStatus",
      description: "Whether the alert is still firing or has been resolved.",
    },
    summary: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Summary",
      description: "A one-line summary of the alert.",
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
      description: "What the alert means and what to check.",
    },
    labels: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Labels",
      description: "Every label the controller attached to the alert.",
    },
    annotations: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Annotations",
      description:
        "Every annotation the controller attached to the alert, as last reported. Besides `summary` and `description`, `value` is what the alert measured (the average poll time in seconds, or the share of the time a device was connected), and the settings the alert was raised with: `duration_seconds`, and for a slow device `threshold_seconds` and `averaging_window_seconds`.",
      examples: [
        {
          averaging_window_seconds: "300",
          duration_seconds: "900",
          threshold_seconds: "1.5",
          value: "1.8",
        },
      ],
    },
    starts_at: {
      type: "string",
      format: "date-time",
      title: "Starts At",
      description: "When the alert started firing.",
    },
    ends_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Ends At",
      description: "When the alert was resolved, if it has been.",
    },
    last_reported_at: {
      type: "string",
      format: "date-time",
      title: "Last Reported At",
      description:
        "When the controller last reported this alert. A firing alert is reported again every hour, so an older time means the controller stopped reporting.",
    },
    is_stale: {
      type: "boolean",
      title: "Is Stale",
      description:
        "Whether this alert is firing but has not been reported for two hours. The controller may have lost track of it, for instance after a power cut, and may never report it resolved.",
    },
    is_subscribed: {
      type: "boolean",
      title: "Is Subscribed",
      description:
        "Whether the site is notified of this alert, by its current alert settings. Every alert is recorded, but only an admin is listed the alerts the site is not subscribed to.",
    },
  },
  type: "object",
  required: [
    "alert_id",
    "controller_id",
    "alert_name",
    "asset_id",
    "status",
    "summary",
    "description",
    "labels",
    "annotations",
    "starts_at",
    "ends_at",
    "last_reported_at",
    "is_stale",
    "is_subscribed",
  ],
  title: "ControllerAlertDTO",
} as const;

export const ControllerAlertStatusSchema = {
  type: "string",
  enum: ["firing", "resolved"],
  title: "ControllerAlertStatus",
} as const;

export const ControllerConfigurationSchema = {
  properties: {
    controller_mode: {
      type: "string",
      enum: ["read_only", "active"],
      title: "Controller Mode",
      default: "read_only",
    },
    phase_permutation_mode: {
      type: "string",
      enum: ["worst_case", "use_topology"],
      title: "Phase Permutation Mode",
      default: "worst_case",
    },
    topology: {
      $ref: "#/components/schemas/ControllerTopology",
    },
    grid_limits: {
      anyOf: [
        {
          $ref: "#/components/schemas/GridPowerLimits",
        },
        {
          type: "null",
        },
      ],
      description:
        "The apparent power the root collector is steered and tripped at, derived from the site's grid connection, or from the root collector's own ratings when the site configures none. The controller turns them into the line currents of the moment at the voltage it measures, and they only ever narrow the root collector's own line currents. Absent only for a site without a collector.",
    },
    alert_parameters: {
      anyOf: [
        {
          $ref: "#/components/schemas/AlertParameters",
        },
        {
          type: "null",
        },
      ],
      description:
        "The thresholds and durations of the alerts the controller raises, when it is served its configuration.",
    },
  },
  type: "object",
  required: ["topology"],
  title: "ControllerConfiguration",
} as const;

export const ControllerConfigurationStatusSchema = {
  properties: {
    configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/ControllerConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    validation_errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Validation Errors",
    },
    configured_correctly: {
      type: "boolean",
      title: "Configured Correctly",
      readOnly: true,
    },
  },
  type: "object",
  required: ["configuration", "validation_errors", "configured_correctly"],
  title: "ControllerConfigurationStatus",
  description: `What a controller asking for its configuration right now would be served, or the reasons
that request fails. Dashboard-facing: it reports every problem at once instead of the first
one, so an operator sees the whole picture without fixing them one round trip at a time.`,
} as const;

export const ControllerOfflineAlertSettingsSchema = {
  properties: {
    subscribed: {
      type: "boolean",
      title: "Subscribed",
      description:
        "Whether the site is notified when its controller has not been heard from for 15 minutes. The API records the controller as offline either way.",
      examples: [true],
    },
  },
  type: "object",
  required: ["subscribed"],
  title: "ControllerOfflineAlertSettings",
} as const;

export const ControllerTokenResponseSchema = {
  properties: {
    jti: {
      type: "string",
      title: "Jti",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    site_id: {
      type: "string",
      title: "Site Id",
    },
    controller_id: {
      type: "string",
      title: "Controller Id",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    created_by: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Created By",
    },
    revoked_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Revoked At",
    },
  },
  type: "object",
  required: ["jti", "partner_id", "site_id", "controller_id", "created_at"],
  title: "ControllerTokenResponse",
} as const;

export const ControllerTopologySchema = {
  properties: {
    device_list: {
      items: {
        $ref: "#/components/schemas/DeviceWithIoConfig",
      },
      type: "array",
      title: "Device List",
    },
    collector_list: {
      items: {
        $ref: "#/components/schemas/CollectorWithIoConfig",
      },
      type: "array",
      title: "Collector List",
    },
  },
  type: "object",
  required: ["device_list", "collector_list"],
  title: "ControllerTopology",
} as const;

export const ControllerTransactionEventSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    transaction_id: {
      type: "string",
      title: "Transaction Id",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    type: {
      $ref: "#/components/schemas/TransactionType",
      description:
        "Whether the transaction runs on an AC or a DC charging pole.",
      default: "ac",
    },
    event: {
      oneOf: [
        {
          $ref: "#/components/schemas/_StartedEvent",
        },
        {
          $ref: "#/components/schemas/_MeasuredChargingDetailsEvent",
        },
        {
          $ref: "#/components/schemas/_BatteryCapacityMeasuredEvent",
        },
        {
          $ref: "#/components/schemas/_SuspendedEvEvent",
        },
        {
          $ref: "#/components/schemas/_RestartedChargingEvent",
        },
        {
          $ref: "#/components/schemas/_EndedEvent",
        },
      ],
      title: "Event",
      discriminator: {
        propertyName: "kind",
        mapping: {
          battery_capacity_measured:
            "#/components/schemas/_BatteryCapacityMeasuredEvent",
          ended: "#/components/schemas/_EndedEvent",
          measured_charging_details:
            "#/components/schemas/_MeasuredChargingDetailsEvent",
          restarted_charging: "#/components/schemas/_RestartedChargingEvent",
          started: "#/components/schemas/_StartedEvent",
          suspended_ev: "#/components/schemas/_SuspendedEvEvent",
        },
      },
    },
  },
  type: "object",
  required: ["asset_id", "transaction_id", "timestamp", "event"],
  title: "ControllerTransactionEvent",
  description:
    "Event emitted by the local controller on the `transaction-events` topic.",
} as const;

export const CreateControllerTokenAsAdminDTOSchema = {
  properties: {
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    site_id: {
      type: "string",
      title: "Site Id",
    },
    controller_id: {
      type: "string",
      title: "Controller Id",
    },
  },
  type: "object",
  required: ["partner_id", "site_id", "controller_id"],
  title: "CreateControllerTokenAsAdminDTO",
} as const;

export const CreateControllerTokenResponseSchema = {
  properties: {
    access_token: {
      type: "string",
      title: "Access Token",
    },
    token: {
      $ref: "#/components/schemas/ControllerTokenResponse",
    },
  },
  type: "object",
  required: ["access_token", "token"],
  title: "CreateControllerTokenResponse",
} as const;

export const CreateDriverDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    badge_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Badge Ids",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
    },
    profile: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverProfileSchedule-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["email", "partner_id", "site_ids"],
  title: "CreateDriverDTO",
} as const;

export const CreateForecastingTaskSchema = {
  properties: {
    task_id: {
      type: "string",
      title: "Task Id",
      examples: ["ForecastTrainingTask"],
    },
    interval: {
      anyOf: [
        {
          type: "string",
          pattern: "^P(T?\\d+.*)$",
        },
        {
          type: "null",
        },
      ],
      title: "Interval",
      examples: ["P1DT"],
    },
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    forecasted_asset: {
      type: "string",
      title: "Forecasted Asset",
      examples: ["PV@main_collector"],
    },
    scheduled_at: {
      type: "string",
      format: "date-time",
      title: "Scheduled At",
    },
  },
  type: "object",
  required: [
    "task_id",
    "site_id",
    "partner_id",
    "forecasted_asset",
    "scheduled_at",
  ],
  title: "CreateForecastingTask",
} as const;

export const CreateMeasurementDTOSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
      examples: ["charger-A1"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    energyValue: {
      type: "number",
      title: "Energyvalue",
      examples: [1030404],
    },
    powerValue: {
      type: "number",
      title: "Powervalue",
      examples: [7000],
    },
    currentStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Currentstateofcharge",
    },
    energyPositive: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energypositive",
    },
    energyNegative: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energynegative",
    },
  },
  type: "object",
  required: ["site_id", "asset_id", "timestamp", "energyValue", "powerValue"],
  title: "CreateMeasurementDTO",
} as const;

export const CreateOcppConfigurationDTOSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    forward_url: {
      type: "string",
      title: "Forward Url",
    },
    mode: {
      $ref: "#/components/schemas/OcppBrokerMode",
      default: "transaction_linking",
    },
    forward_url_overrides: {
      items: {
        $ref: "#/components/schemas/ForwardUrlOverride",
      },
      type: "array",
      title: "Forward Url Overrides",
    },
  },
  type: "object",
  required: ["site_id", "forward_url"],
  title: "CreateOcppConfigurationDTO",
} as const;

export const CreatePartnerDTOSchema = {
  properties: {
    partner_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Partner Id",
    },
    name: {
      type: "string",
      title: "Name",
    },
    connections: {
      anyOf: [
        {
          $ref: "#/components/schemas/Connection-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["partner_id", "name"],
  title: "CreatePartnerDTO",
} as const;

export const CreateProfileDTOSchema = {
  properties: {
    profile_id: {
      type: "string",
      title: "Profile Id",
      examples: ["profile-ev-fleet"],
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ac: {
      anyOf: [
        {
          $ref: "#/components/schemas/AcChargingProfile-Input",
        },
        {
          type: "null",
        },
      ],
    },
    dc: {
      anyOf: [
        {
          $ref: "#/components/schemas/DcChargingProfile-Input",
        },
        {
          type: "null",
        },
      ],
    },
    override_transaction_input: {
      type: "boolean",
      title: "Override Transaction Input",
      default: false,
    },
    apply_to: {
      $ref: "#/components/schemas/ProfileApplyTo",
    },
  },
  type: "object",
  required: ["profile_id"],
  title: "CreateProfileDTO",
} as const;

export const CreatePxcTokenRequestSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
  },
  type: "object",
  required: ["name", "partner_id"],
  title: "CreatePxcTokenRequest",
} as const;

export const CreatePxcTokenResponseSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    token: {
      type: "string",
      title: "Token",
    },
  },
  type: "object",
  required: ["name", "token"],
  title: "CreatePxcTokenResponse",
} as const;

export const CreateTransactionDTOSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
      description: "The ID of the site where the transaction is taking place.",
      examples: ["site-1"],
    },
    assetId: {
      type: "string",
      title: "Assetid",
      examples: ["charger-A1"],
    },
    transactionId: {
      type: "string",
      title: "Transactionid",
      description:
        "A unique identifier that should be provided for each transaction. This identifier should be the same for all transactions within the same charging session.",
      examples: ["550e8400-e29b-41d4-a716-446655440000"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    transactionState: {
      $ref: "#/components/schemas/TransactionState",
    },
    startTime: {
      type: "string",
      format: "date-time",
      title: "Starttime",
    },
    stopTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stoptime",
    },
    noChargingPhases: {
      anyOf: [
        {
          type: "string",
          enum: ["3Phase", "2Phase", "1Phase"],
        },
        {
          type: "null",
        },
      ],
      title: "Nochargingphases",
      examples: ["3Phase"],
    },
    usedChargingPins: {
      anyOf: [
        {
          items: {
            type: "string",
            enum: ["pin1", "pin2", "pin3"],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Usedchargingpins",
      examples: [["pin1", "pin2", "pin3"]],
    },
    maxPower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Maxpower",
      examples: [10500],
    },
    requestedMinEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedminenergy",
      examples: [30000],
    },
    requestedMaxEnergy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requestedmaxenergy",
      examples: [30000],
    },
    estimatedDepartureTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimateddeparturetime",
    },
    priority: {
      type: "integer",
      maximum: 10,
      minimum: 0,
      title: "Priority",
      examples: [5],
    },
    profile_id: {
      type: "string",
      title: "Profile Id",
      description:
        "The profile ID to use for this transaction. This is used to apply default values for requested energy and estimated departure time.",
      default: "default",
      examples: ["default"],
    },
    initial_energy_value: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Initial Energy Value",
      examples: [1361389],
    },
    minimal_charging_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Minimal Charging Current",
      description:
        "The minimal charging current in Amperes that the charging station must support. Used to calculate minimum power constraints.",
      default: 6,
      examples: [6],
    },
    allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Allow Zero Current",
      description:
        "Indicates whether the EVSE or EV linked to the transaction allows for zero current charging periods.",
      default: true,
    },
  },
  type: "object",
  required: [
    "site_id",
    "assetId",
    "transactionId",
    "timestamp",
    "transactionState",
    "startTime",
    "usedChargingPins",
    "maxPower",
    "requestedMinEnergy",
    "requestedMaxEnergy",
    "priority",
  ],
  title: "CreateTransactionDTO",
} as const;

export const CurrentStateOfChargeSchema = {
  properties: {
    state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    estimated: {
      type: "boolean",
      title: "Estimated",
    },
  },
  type: "object",
  required: ["state_of_charge", "estimated"],
  title: "CurrentStateOfCharge",
} as const;

export const CurtailmentModeSchema = {
  type: "string",
  enum: ["none", "continuous"],
  title: "CurtailmentMode",
} as const;

export const CustomResponseMessageSchema = {
  properties: {
    status_code: {
      type: "integer",
      title: "Status Code",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["status_code", "message"],
  title: "CustomResponseMessage",
} as const;

export const DSOConnectionSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/FluviusDSOConnection",
    },
    {
      $ref: "#/components/schemas/AiegDSOConnection",
    },
    {
      $ref: "#/components/schemas/AieshDSOConnection",
    },
    {
      $ref: "#/components/schemas/OresDSOConnection",
    },
    {
      $ref: "#/components/schemas/ResaDSOConnection",
    },
    {
      $ref: "#/components/schemas/RewDSOConnection",
    },
    {
      $ref: "#/components/schemas/SibelgaDSOConnection",
    },
    {
      $ref: "#/components/schemas/GermanDSOConnection",
    },
    {
      $ref: "#/components/schemas/DutchDSOConnection",
    },
    {
      $ref: "#/components/schemas/OtherDutchDSOConnection",
    },
  ],
  discriminator: {
    propertyName: "dso",
    mapping: {
      AIEG: "#/components/schemas/AiegDSOConnection",
      AIESH: "#/components/schemas/AieshDSOConnection",
      Enexis: "#/components/schemas/DutchDSOConnection",
      Fluvius: "#/components/schemas/FluviusDSOConnection",
      German: "#/components/schemas/GermanDSOConnection",
      Liander: "#/components/schemas/DutchDSOConnection",
      ORES: "#/components/schemas/OresDSOConnection",
      "Other Dutch DSO": "#/components/schemas/OtherDutchDSOConnection",
      RESA: "#/components/schemas/ResaDSOConnection",
      REW: "#/components/schemas/RewDSOConnection",
      Sibelga: "#/components/schemas/SibelgaDSOConnection",
      Stedin: "#/components/schemas/DutchDSOConnection",
    },
  },
} as const;

export const DataPreprocessingWarningSchema = {
  properties: {
    message: {
      type: "string",
      title: "Message",
    },
    type: {
      type: "string",
      const: "data-preprocessing",
      title: "Type",
      default: "data-preprocessing",
    },
  },
  type: "object",
  required: ["message"],
  title: "DataPreprocessingWarning",
} as const;

export const DateScheduleSchema = {
  properties: {
    frequency: {
      type: "string",
      const: "once",
      title: "Frequency",
      default: "once",
    },
    date_times: {
      items: {
        type: "string",
        format: "date-time",
      },
      type: "array",
      minItems: 1,
      title: "Date Times",
      description:
        "List of specific date-times in ISO 8601 format with timezone",
      examples: ["2023-12-25T09:00:00+01:00", "2024-01-01T00:00:00+01:00"],
    },
  },
  type: "object",
  required: ["date_times"],
  title: "DateSchedule",
  description: "Schedule that runs on specific dates at a specific time.",
} as const;

export const DayAheadPricesSchema = {
  properties: {
    type: {
      $ref: "#/components/schemas/EntsoeQueryType",
      default: "day_ahead_prices",
    },
    data: {
      items: {
        $ref: "#/components/schemas/TimeSeriesPoint",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["data"],
  title: "DayAheadPrices",
} as const;

export const DayAheadPricesWithForecastSchema = {
  properties: {
    actual: {
      items: {
        $ref: "#/components/schemas/TimeSeriesPoint",
      },
      type: "array",
      title: "Actual",
    },
    forecast: {
      items: {
        $ref: "#/components/schemas/TimeSeriesPoint",
      },
      type: "array",
      title: "Forecast",
    },
  },
  type: "object",
  required: ["actual", "forecast"],
  title: "DayAheadPricesWithForecast",
} as const;

export const DayNightBeEnergyContractSchema = {
  properties: {
    day_offtake_cost_per_mwh: {
      type: "number",
      title: "Day Offtake Cost Per Mwh",
    },
    night_offtake_cost_per_mwh: {
      type: "number",
      title: "Night Offtake Cost Per Mwh",
    },
    day_injection_cost_per_mwh: {
      type: "number",
      title: "Day Injection Cost Per Mwh",
    },
    night_injection_cost_per_mwh: {
      type: "number",
      title: "Night Injection Cost Per Mwh",
    },
    contract_type: {
      type: "string",
      const: "day_night_be",
      title: "Contract Type",
      default: "day_night_be",
    },
  },
  type: "object",
  required: [
    "day_offtake_cost_per_mwh",
    "night_offtake_cost_per_mwh",
    "day_injection_cost_per_mwh",
    "night_injection_cost_per_mwh",
  ],
  title: "DayNightBeEnergyContract",
} as const;

export const DayOfWeekSchema = {
  type: "string",
  enum: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  title: "DayOfWeek",
} as const;

export const DcChargingPole_InputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "dc_charging_pole",
      title: "Type",
      default: "dc_charging_pole",
    },
    max_power: {
      type: "integer",
      title: "Max Power",
      description:
        "The maximum power in Watt for the charging pole itself / connection to the charging pole.",
      examples: [250000],
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "load-balancing",
    },
  },
  type: "object",
  required: ["name", "collector", "max_power"],
  title: "DcChargingPole",
} as const;

export const DcChargingPole_OutputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "dc_charging_pole",
      title: "Type",
      default: "dc_charging_pole",
    },
    max_power: {
      type: "integer",
      title: "Max Power",
      description:
        "The maximum power in Watt for the charging pole itself / connection to the charging pole.",
      examples: [250000],
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "load-balancing",
    },
  },
  type: "object",
  required: ["name", "collector", "max_power"],
  title: "DcChargingPole",
} as const;

export const DcChargingPoleWithIoConfigSchema = {
  properties: {
    io: {
      $ref: "#/components/schemas/IoConfig",
    },
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "dc_charging_pole",
      title: "Type",
      default: "dc_charging_pole",
    },
    max_power: {
      type: "integer",
      title: "Max Power",
      description:
        "The maximum power in Watt for the charging pole itself / connection to the charging pole.",
      examples: [250000],
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "load-balancing",
    },
  },
  type: "object",
  required: ["io", "name", "collector", "max_power"],
  title: "DcChargingPoleWithIoConfig",
} as const;

export const DcChargingProfile_InputSchema = {
  properties: {
    default_estimated_departure_time_delta: {
      type: "string",
      format: "duration",
      title: "Default Estimated Departure Time Delta",
      description:
        "The time a vehicle is expected to charge expressed in ISO 8601 time delta, this will be used if we receive a DC transaction with this profile_id, without an estimated departure time.",
      examples: ["PT8H"],
    },
    default_requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Default Requested Min State Of Charge",
      description:
        "The default requested minimum state of charge (in percentage) for DC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested minimum state of charge.",
      examples: [80],
    },
    default_requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Default Requested Max State Of Charge",
      description:
        "The default requested maximum state of charge (in percentage) for DC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested maximum state of charge.",
      examples: [100],
    },
  },
  type: "object",
  required: [
    "default_estimated_departure_time_delta",
    "default_requested_min_state_of_charge",
    "default_requested_max_state_of_charge",
  ],
  title: "DcChargingProfile",
} as const;

export const DcChargingProfile_OutputSchema = {
  properties: {
    default_estimated_departure_time_delta: {
      type: "string",
      title: "Default Estimated Departure Time Delta",
      description:
        "The time a vehicle is expected to charge expressed in ISO 8601 time delta, this will be used if we receive a DC transaction with this profile_id, without an estimated departure time.",
      examples: ["PT8H"],
    },
    default_requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Default Requested Min State Of Charge",
      description:
        "The default requested minimum state of charge (in percentage) for DC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested minimum state of charge.",
      examples: [80],
    },
    default_requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Default Requested Max State Of Charge",
      description:
        "The default requested maximum state of charge (in percentage) for DC transactions with this profile, this will be used if we receive a transaction with this profile_id, without a requested maximum state of charge.",
      examples: [100],
    },
  },
  type: "object",
  required: [
    "default_estimated_departure_time_delta",
    "default_requested_min_state_of_charge",
    "default_requested_max_state_of_charge",
  ],
  title: "DcChargingProfile",
} as const;

export const DcDriverInputRequestSchema = {
  properties: {
    type: {
      type: "string",
      const: "dc",
      title: "Type",
      default: "dc",
    },
    requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Min State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Max State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    estimated_departure_time: {
      type: "string",
      format: "date-time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
    "estimated_departure_time",
  ],
  title: "DcDriverInputRequest",
} as const;

export const DcDriverPreferencesOverwriteRequestSchema = {
  properties: {
    type: {
      type: "string",
      const: "dc",
      title: "Type",
      default: "dc",
    },
    requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Min State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Max State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    estimated_departure_time: {
      type: "string",
      format: "date-time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
    "estimated_departure_time",
  ],
  title: "DcDriverPreferencesOverwriteRequest",
} as const;

export const DcMqttTransactionSchema = {
  properties: {
    assetId: {
      type: "string",
      title: "Assetid",
      description:
        "The unique identifier of the charging pole asset. This matches the name in the site configuration.",
      examples: ["charger-A1"],
    },
    transactionId: {
      type: "string",
      title: "Transactionid",
      description:
        "The unique identifier for this transaction. This is generated by the charging pole and must be globally unique (e.g. a UUID).",
      examples: ["550e8400-e29b-41d4-a716-446655440000"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
      description:
        "The timestamp when the transaction state changed (e.g. started, updated, EV suspended, stopped, etc).",
      examples: ["2025-11-05T08:48:00.000Z"],
    },
    transactionState: {
      $ref: "#/components/schemas/TransactionState",
      description:
        "The reason why the transaction message is sent (e.g. started, updated, EV suspended, stopped, etc).",
      examples: ["Started"],
    },
    startTime: {
      type: "string",
      format: "date-time",
      title: "Starttime",
      description:
        "The timestamp when the transaction started (i.e. when the vehicle was connected and charging began).",
      examples: ["2025-11-05T08:48:00.000Z"],
    },
    stopTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stoptime",
      description:
        "The timestamp when the transaction stopped (i.e. when the vehicle disconnected). This can be null/omitted if the transaction is still ongoing.",
      examples: [null, "2025-11-05T18:48:00.000Z"],
    },
    estimatedDepartureTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimateddeparturetime",
      description:
        "The estimated time when the vehicle will depart and no longer be connected to the charging pole. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. If the estimated departure time changes, an 'Update' event must be sent with the new estimated departure time. If the vehicle leaves earlier than the estimated departure time, it might not have received the requested amount of energy. If it leaves after the estimated departure time, the optimizer has less flexibility in planning the vehicle and will result in less optimal schedules. If a profile_id is passed and the corresponding profile is configured, the estimatedDepartureTime will be set to the profile's default duration after startTime if not provided in the transaction.",
      examples: ["2025-11-05T17:48:00.000Z"],
    },
    priority: {
      type: "integer",
      maximum: 10,
      minimum: 0,
      title: "Priority",
      description:
        "The priority of the transaction. This is used to determine which transactions to optimize first when there is not enough capacity to optimize all transactions. Lower values indicate higher priority.",
      examples: [5],
    },
    userId: {
      type: "string",
      title: "Userid",
      description:
        "The user identifier for this transaction. This should be the badge ID of the user.",
      default: "default",
    },
    type: {
      type: "string",
      const: "dc",
      title: "Type",
      description:
        "The type of the transaction, must be 'dc' for DC transactions",
    },
    powerCurveId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Powercurveid",
      description:
        "The id of the DC power curve (power to state of charge), as configured through the API / the portal, that this vehicle follows. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be measured beforehand by draining the battery of the vehicle to almost zero and allowing it to charge at max power until its fully charged, continously noting the power it uses.",
      examples: ["bus2024-my-brand"],
    },
    batteryCapacity: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Batterycapacity",
      description:
        "The (current) full capacity of the battery (in Wh). i.e. this should be the energy in the battery if the state of charge is 100%. If the battery is degraded, the battery_capacity should be decreased reflecting this degradation. If there is a difference between technical capacity (what theoretically the capacity is) and operationl capacity (what it actually is in practice), the operational is preferred. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event.",
      examples: [400000],
    },
    initialStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Initialstateofcharge",
      description:
        "The initial state of charge (in percentage) of the vehicle when it arrived. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event or the latest value can be sent through an energyMeasurement's currentStateOfCharge.",
      examples: [42.28],
    },
    requestedMinStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requestedminstateofcharge",
      description:
        "The minimum state of charge (in percentage) that the vehicle needs to have by the estimated departure time. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event.",
      examples: [95],
    },
    requestedMaxStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requestedmaxstateofcharge",
      description:
        "The maximum state of charge (in percentage) that the vehicle can charge to. This can be null/omitted if not yet known but is required for the transaction to be included for optimization. It can be added later through an 'Update' event. This should be greater than or equal to `requestedMinStateOfCharge`. If you don't know the maximum or want to charge a fixed amount, you can set it equal to the requestedMinEnergy. If we can fully charge the vehicle, this should be equal to the batteryCapacity.",
      examples: [100],
    },
    vehicleId: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vehicleid",
      description:
        "An optional identifier for the vehicle associated with this transaction.",
    },
  },
  type: "object",
  required: [
    "assetId",
    "transactionId",
    "timestamp",
    "transactionState",
    "startTime",
    "priority",
    "type",
    "powerCurveId",
  ],
  title: "DcMqttTransaction",
} as const;

export const DcTransactionSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    assetId: {
      type: "string",
      title: "Assetid",
      examples: ["charger-A1"],
    },
    transactionId: {
      type: "string",
      title: "Transactionid",
      description:
        "A unique identifier that should be provided for each transaction",
      examples: ["550e8400-e29b-41d4-a716-446655440000"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    transactionState: {
      $ref: "#/components/schemas/TransactionState",
    },
    startTime: {
      type: "string",
      format: "date-time",
      title: "Starttime",
    },
    stopTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stoptime",
    },
    estimatedDepartureTime: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimateddeparturetime",
    },
    priority: {
      type: "integer",
      maximum: 10,
      minimum: 0,
      title: "Priority",
      examples: [5],
    },
    profile_id: {
      type: "string",
      title: "Profile Id",
      default: "default",
      examples: ["default"],
    },
    driver_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Id",
      description:
        "Driver profile associated with the transaction. This can be used to overwrite departure time and requested energy for specific drivers.",
    },
    received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Received At",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Allow Zero Current",
      description:
        "Indicates whether the EVSE or EV linked to the transaction allows for zero current charging periods.",
      default: true,
    },
    type: {
      type: "string",
      const: "dc",
      title: "Type",
      default: "dc",
    },
    power_curve_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Power Curve Id",
      examples: ["bus2024-my-brand"],
    },
    battery_capacity: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity",
      examples: [400000],
    },
    initial_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Initial State Of Charge",
    },
    requested_min_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min State Of Charge",
    },
    requested_max_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Max State Of Charge",
    },
    vehicle_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vehicle Id",
    },
  },
  type: "object",
  required: [
    "site_id",
    "assetId",
    "transactionId",
    "timestamp",
    "transactionState",
    "startTime",
    "priority",
    "partner_id",
  ],
  title: "DcTransaction",
} as const;

export const Device_InputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/AcChargingPole3Phase-Input",
    },
    {
      $ref: "#/components/schemas/DcChargingPole-Input",
    },
    {
      $ref: "#/components/schemas/ForecastedThreePhaseDevice-Input",
    },
    {
      $ref: "#/components/schemas/BessDevice-Input",
    },
    {
      $ref: "#/components/schemas/DoubleCharger-Input",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      battery_energy_storage_system: "#/components/schemas/BessDevice-Input",
      charging_pole_3phase: "#/components/schemas/AcChargingPole3Phase-Input",
      dc_charging_pole: "#/components/schemas/DcChargingPole-Input",
      double_charger: "#/components/schemas/DoubleCharger-Input",
      forecasted_series_3phase:
        "#/components/schemas/ForecastedThreePhaseDevice-Input",
    },
  },
} as const;

export const Device_OutputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/AcChargingPole3Phase-Output",
    },
    {
      $ref: "#/components/schemas/DcChargingPole-Output",
    },
    {
      $ref: "#/components/schemas/ForecastedThreePhaseDevice-Output",
    },
    {
      $ref: "#/components/schemas/BessDevice-Output",
    },
    {
      $ref: "#/components/schemas/DoubleCharger-Output",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      battery_energy_storage_system: "#/components/schemas/BessDevice-Output",
      charging_pole_3phase: "#/components/schemas/AcChargingPole3Phase-Output",
      dc_charging_pole: "#/components/schemas/DcChargingPole-Output",
      double_charger: "#/components/schemas/DoubleCharger-Output",
      forecasted_series_3phase:
        "#/components/schemas/ForecastedThreePhaseDevice-Output",
    },
  },
} as const;

export const DeviceForecastTypeSchema = {
  type: "string",
  enum: ["pv", "load", "calculated_ucl", "aggregated_pv"],
  title: "DeviceForecastType",
} as const;

export const DeviceInfoSchema = {
  properties: {
    model_name: {
      type: "string",
      minLength: 1,
      title: "Model Name",
    },
    serial_numbers: {
      $ref: "#/components/schemas/SerialNumbers",
    },
  },
  type: "object",
  required: ["model_name", "serial_numbers"],
  title: "DeviceInfo",
} as const;

export const DevicePollingSlowlyAlertParametersSchema = {
  properties: {
    threshold_seconds: {
      type: "number",
      maximum: 60,
      exclusiveMinimum: 0,
      title: "Threshold Seconds",
      description:
        "The average time, in seconds, one modbus poll of a device may take before the device counts as responding slowly.",
      examples: [1],
    },
    averaging_window_seconds: {
      type: "integer",
      maximum: 3600,
      minimum: 60,
      title: "Averaging Window Seconds",
      description: "The period, in seconds, the poll time is averaged over.",
      examples: [300],
    },
    duration_seconds: {
      type: "integer",
      maximum: 86400,
      minimum: 0,
      title: "Duration Seconds",
      description:
        "How long, in seconds, the average poll time must stay above the threshold before the device counts as responding slowly.",
      examples: [600],
    },
  },
  type: "object",
  required: [
    "threshold_seconds",
    "averaging_window_seconds",
    "duration_seconds",
  ],
  title: "DevicePollingSlowlyAlertParameters",
} as const;

export const DevicePollingSlowlyAlertSettingsSchema = {
  properties: {
    threshold_seconds: {
      type: "number",
      maximum: 60,
      exclusiveMinimum: 0,
      title: "Threshold Seconds",
      description:
        "The average time, in seconds, one modbus poll of a device may take before the device counts as responding slowly.",
      examples: [1],
    },
    averaging_window_seconds: {
      type: "integer",
      maximum: 3600,
      minimum: 60,
      title: "Averaging Window Seconds",
      description: "The period, in seconds, the poll time is averaged over.",
      examples: [300],
    },
    duration_seconds: {
      type: "integer",
      maximum: 86400,
      minimum: 0,
      title: "Duration Seconds",
      description:
        "How long, in seconds, the average poll time must stay above the threshold before the device counts as responding slowly.",
      examples: [600],
    },
    subscribed: {
      type: "boolean",
      title: "Subscribed",
      description:
        "Whether the site is notified of a device that responds slowly. The controller checks every device either way, so the alert is recorded even when the site is not subscribed.",
      examples: [true],
    },
    asset_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
          minItems: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Asset Ids",
      description:
        "The devices, by asset id, the site is notified about when they respond slowly. Every device of the site when null, including devices added later.",
      examples: [["LSB_EV_AC1_1", "BESS"]],
    },
  },
  type: "object",
  required: [
    "threshold_seconds",
    "averaging_window_seconds",
    "duration_seconds",
    "subscribed",
  ],
  title: "DevicePollingSlowlyAlertSettings",
} as const;

export const DeviceTypeSchema = {
  type: "string",
  enum: [
    "charging_pole_3phase",
    "dc_charging_pole",
    "battery_energy_storage_system",
    "forecasted_series_3phase",
    "double_charger",
  ],
  title: "DeviceType",
} as const;

export const DeviceUnreachableAlertParametersSchema = {
  properties: {
    duration_seconds: {
      type: "integer",
      maximum: 86400,
      minimum: 0,
      title: "Duration Seconds",
      description:
        "How long, in seconds, the controller must have been connected to a device for less than half of every minute before the device counts as unreachable.",
      examples: [300],
    },
  },
  type: "object",
  required: ["duration_seconds"],
  title: "DeviceUnreachableAlertParameters",
} as const;

export const DeviceUnreachableAlertSettingsSchema = {
  properties: {
    duration_seconds: {
      type: "integer",
      maximum: 86400,
      minimum: 0,
      title: "Duration Seconds",
      description:
        "How long, in seconds, the controller must have been connected to a device for less than half of every minute before the device counts as unreachable.",
      examples: [300],
    },
    subscribed: {
      type: "boolean",
      title: "Subscribed",
      description:
        "Whether the site is notified of a device the controller cannot reach. The controller checks every device either way, so the alert is recorded even when the site is not subscribed.",
      examples: [true],
    },
    asset_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
          minItems: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Asset Ids",
      description:
        "The devices, by asset id, the site is notified about when they are unreachable. Every device of the site when null, including devices added later.",
      examples: [["LSB_EV_AC1_1", "BESS"]],
    },
  },
  type: "object",
  required: ["duration_seconds", "subscribed"],
  title: "DeviceUnreachableAlertSettings",
} as const;

export const DeviceWithIoConfigSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ForecastedThreePhaseDeviceWithIoConfig",
    },
    {
      $ref: "#/components/schemas/AcChargingPole3PhaseWithIoConfig",
    },
    {
      $ref: "#/components/schemas/DcChargingPoleWithIoConfig",
    },
    {
      $ref: "#/components/schemas/BessDeviceWithIoConfig",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      battery_energy_storage_system:
        "#/components/schemas/BessDeviceWithIoConfig",
      charging_pole_3phase:
        "#/components/schemas/AcChargingPole3PhaseWithIoConfig",
      dc_charging_pole: "#/components/schemas/DcChargingPoleWithIoConfig",
      forecasted_series_3phase:
        "#/components/schemas/ForecastedThreePhaseDeviceWithIoConfig",
    },
  },
} as const;

export const DoubleCharger_InputSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "double_charger",
      title: "Type",
      default: "double_charger",
    },
    connectors: {
      items: {
        $ref: "#/components/schemas/ChargerConnector",
      },
      type: "array",
      maxItems: 255,
      minItems: 1,
      title: "Connectors",
      description:
        "Charging connectors in hardware order. Connector IDs are assigned from 1 in this order.",
    },
    line_current: {
      type: "integer",
      exclusiveMinimum: 0,
      title: "Line Current",
      description: "The line current in Ampere shared by all connectors.",
      examples: [32],
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "scheduled",
    },
  },
  type: "object",
  required: ["name", "collector", "connectors", "line_current"],
  title: "DoubleCharger",
} as const;

export const DoubleCharger_OutputSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "double_charger",
      title: "Type",
      default: "double_charger",
    },
    connectors: {
      items: {
        $ref: "#/components/schemas/ChargerConnector",
      },
      type: "array",
      maxItems: 255,
      minItems: 1,
      title: "Connectors",
      description:
        "Charging connectors in hardware order. Connector IDs are assigned from 1 in this order.",
    },
    line_current: {
      type: "integer",
      exclusiveMinimum: 0,
      title: "Line Current",
      description: "The line current in Ampere shared by all connectors.",
      examples: [32],
    },
    strategy: {
      $ref: "#/components/schemas/ChargingStrategy",
      default: "scheduled",
    },
  },
  type: "object",
  required: ["name", "collector", "connectors", "line_current"],
  title: "DoubleCharger",
} as const;

export const DriverAcProfile_InputSchema = {
  properties: {
    expected_arrival_time: {
      anyOf: [
        {
          type: "string",
          format: "time",
        },
        {
          type: "null",
        },
      ],
      title: "Expected Arrival Time",
      description: "Expected arrival time at the charging location",
    },
    requested_min_energy: {
      type: "integer",
      title: "Requested Min Energy",
      description: "Requested minimum energy in Wh",
    },
    requested_max_energy: {
      type: "integer",
      title: "Requested Max Energy",
      description: "Requested maximum energy in Wh",
    },
    estimated_departure_time: {
      type: "string",
      format: "time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "expected_arrival_time",
    "requested_min_energy",
    "requested_max_energy",
    "estimated_departure_time",
  ],
  title: "DriverAcProfile",
} as const;

export const DriverAcProfile_OutputSchema = {
  properties: {
    expected_arrival_time: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Expected Arrival Time",
      description: "Expected arrival time at the charging location",
    },
    requested_min_energy: {
      type: "integer",
      title: "Requested Min Energy",
      description: "Requested minimum energy in Wh",
    },
    requested_max_energy: {
      type: "integer",
      title: "Requested Max Energy",
      description: "Requested maximum energy in Wh",
    },
    estimated_departure_time: {
      type: "string",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "expected_arrival_time",
    "requested_min_energy",
    "requested_max_energy",
    "estimated_departure_time",
  ],
  title: "DriverAcProfile",
} as const;

export const DriverAcTransactionDTOSchema = {
  properties: {
    type: {
      type: "string",
      const: "ac",
      title: "Type",
      default: "ac",
    },
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
    },
    estimated_departure_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Departure Time",
    },
    requested_min_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min Energy",
      examples: [20000],
    },
    requested_max_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Max Energy",
      examples: [30000],
    },
  },
  type: "object",
  required: [
    "start_time",
    "estimated_departure_time",
    "requested_min_energy",
    "requested_max_energy",
  ],
  title: "DriverAcTransactionDTO",
} as const;

export const DriverAppUrlsSchema = {
  properties: {
    production: {
      type: "string",
      title: "Production",
    },
    staging: {
      type: "string",
      title: "Staging",
    },
    sandbox: {
      type: "string",
      title: "Sandbox",
    },
  },
  type: "object",
  required: ["production", "staging", "sandbox"],
  title: "DriverAppUrls",
} as const;

export const DriverCarSchema = {
  properties: {
    unique_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Unique Code",
    },
    make: {
      type: "string",
      title: "Make",
    },
    model: {
      type: "string",
      title: "Model",
    },
    year: {
      type: "integer",
      title: "Year",
    },
    trim: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Trim",
    },
    variant: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant",
    },
    ac_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ac Max Power Kw",
    },
    dc_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Dc Max Power Kw",
    },
    battery_capacity_kwh_gross: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Gross",
    },
    battery_capacity_kwh_net: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Net",
    },
    range_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Range Km",
    },
    allow_zero_current: {
      type: "boolean",
      title: "Allow Zero Current",
      default: true,
    },
  },
  type: "object",
  required: ["make", "model", "year"],
  title: "DriverCar",
} as const;

export const DriverDcProfile_InputSchema = {
  properties: {
    expected_arrival_time: {
      anyOf: [
        {
          type: "string",
          format: "time",
        },
        {
          type: "null",
        },
      ],
      title: "Expected Arrival Time",
      description: "Expected arrival time at the charging location",
    },
    requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Min State Of Charge",
      description: "Requested minimum state of charge in percentage",
      examples: [85.49],
    },
    requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Max State Of Charge",
      description: "Requested maximum state of charge in percentage",
      examples: [85.49],
    },
    estimated_departure_time: {
      type: "string",
      format: "time",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "expected_arrival_time",
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
    "estimated_departure_time",
  ],
  title: "DriverDcProfile",
} as const;

export const DriverDcProfile_OutputSchema = {
  properties: {
    expected_arrival_time: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Expected Arrival Time",
      description: "Expected arrival time at the charging location",
    },
    requested_min_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Min State Of Charge",
      description: "Requested minimum state of charge in percentage",
      examples: [85.49],
    },
    requested_max_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Requested Max State Of Charge",
      description: "Requested maximum state of charge in percentage",
      examples: [85.49],
    },
    estimated_departure_time: {
      type: "string",
      title: "Estimated Departure Time",
    },
  },
  type: "object",
  required: [
    "expected_arrival_time",
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
    "estimated_departure_time",
  ],
  title: "DriverDcProfile",
} as const;

export const DriverDcTransactionDTOSchema = {
  properties: {
    type: {
      type: "string",
      const: "dc",
      title: "Type",
      default: "dc",
    },
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
    },
    estimated_departure_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Departure Time",
    },
    requested_min_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min State Of Charge",
    },
    requested_max_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Requested Max State Of Charge",
    },
    initial_state_of_charge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Initial State Of Charge",
    },
    battery_capacity: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity",
    },
  },
  type: "object",
  required: [
    "start_time",
    "estimated_departure_time",
    "requested_min_state_of_charge",
    "requested_max_state_of_charge",
    "initial_state_of_charge",
    "battery_capacity",
  ],
  title: "DriverDcTransactionDTO",
} as const;

export const DriverProfile_InputSchema = {
  properties: {
    ac: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverAcProfile-Input",
        },
        {
          type: "null",
        },
      ],
      description: "Defaults applied to AC charging sessions.",
    },
    dc: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverDcProfile-Input",
        },
        {
          type: "null",
        },
      ],
      description: "Defaults applied to DC charging sessions.",
    },
  },
  type: "object",
  title: "DriverProfile",
} as const;

export const DriverProfile_OutputSchema = {
  properties: {
    ac: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverAcProfile-Output",
        },
        {
          type: "null",
        },
      ],
      description: "Defaults applied to AC charging sessions.",
    },
    dc: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverDcProfile-Output",
        },
        {
          type: "null",
        },
      ],
      description: "Defaults applied to DC charging sessions.",
    },
  },
  type: "object",
  title: "DriverProfile",
} as const;

export const DriverProfileSchedule_InputSchema = {
  properties: {
    default: {
      $ref: "#/components/schemas/DriverProfile-Input",
      description: "Charging profile used on weekdays without an exception.",
    },
    exceptions: {
      additionalProperties: {
        $ref: "#/components/schemas/DriverProfile-Input",
      },
      propertyNames: {
        $ref: "#/components/schemas/DayOfWeek",
      },
      type: "object",
      title: "Exceptions",
      description:
        "Weekday overrides, keyed by Monday, Tuesday, Wednesday, Thursday, Friday, Saturday or Sunday (case-sensitive), not by site ID. Each override replaces the entire default profile for that day; fields are not merged. Profiles apply to the driver across all linked sites.",
    },
    timezone: {
      type: "string",
      title: "Timezone",
      description:
        "Timezone used to interpret weekdays and profile times, e.g. Europe/Brussels.",
    },
  },
  type: "object",
  required: ["default", "timezone"],
  title: "DriverProfileSchedule",
  examples: [
    {
      default: {
        ac: {
          estimated_departure_time: "17:00:00",
          expected_arrival_time: "08:00:00",
          requested_max_energy: 20000,
          requested_min_energy: 5000,
        },
      },
      exceptions: {
        Friday: {
          ac: {
            estimated_departure_time: "12:00:00",
            expected_arrival_time: "08:00:00",
            requested_max_energy: 10000,
            requested_min_energy: 5000,
          },
        },
      },
      timezone: "Europe/Brussels",
    },
  ],
} as const;

export const DriverProfileSchedule_OutputSchema = {
  properties: {
    default: {
      $ref: "#/components/schemas/DriverProfile-Output",
      description: "Charging profile used on weekdays without an exception.",
    },
    exceptions: {
      additionalProperties: {
        $ref: "#/components/schemas/DriverProfile-Output",
      },
      propertyNames: {
        $ref: "#/components/schemas/DayOfWeek",
      },
      type: "object",
      title: "Exceptions",
      description:
        "Weekday overrides, keyed by Monday, Tuesday, Wednesday, Thursday, Friday, Saturday or Sunday (case-sensitive), not by site ID. Each override replaces the entire default profile for that day; fields are not merged. Profiles apply to the driver across all linked sites.",
    },
    timezone: {
      type: "string",
      title: "Timezone",
      description:
        "Timezone used to interpret weekdays and profile times, e.g. Europe/Brussels.",
    },
  },
  type: "object",
  required: ["default", "timezone"],
  title: "DriverProfileSchedule",
  examples: [
    {
      default: {
        ac: {
          estimated_departure_time: "17:00:00",
          expected_arrival_time: "08:00:00",
          requested_max_energy: 20000,
          requested_min_energy: 5000,
        },
      },
      exceptions: {
        Friday: {
          ac: {
            estimated_departure_time: "12:00:00",
            expected_arrival_time: "08:00:00",
            requested_max_energy: 10000,
            requested_min_energy: 5000,
          },
        },
      },
      timezone: "Europe/Brussels",
    },
  ],
} as const;

export const DriverResponseSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
    },
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    badge_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Badge Ids",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
    },
    profile: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverProfileSchedule-Output",
        },
        {
          type: "null",
        },
      ],
    },
    car: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverCar",
        },
        {
          type: "null",
        },
      ],
    },
    has_seen_onboarding: {
      type: "boolean",
      title: "Has Seen Onboarding",
      default: false,
    },
    has_password: {
      type: "boolean",
      title: "Has Password",
      default: false,
    },
    email_notifications_enabled: {
      type: "boolean",
      title: "Email Notifications Enabled",
      default: true,
    },
  },
  type: "object",
  required: ["_id", "email", "partner_id", "site_ids"],
  title: "DriverResponse",
} as const;

export const DriverScheduleResponseSchema = {
  properties: {
    schedule: {
      $ref: "#/components/schemas/AssetScheduleDTO",
    },
    transaction: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverAcTransactionDTO",
        },
        {
          $ref: "#/components/schemas/DriverDcTransactionDTO",
        },
        {
          type: "null",
        },
      ],
      title: "Transaction",
    },
  },
  type: "object",
  required: ["schedule", "transaction"],
  title: "DriverScheduleResponse",
} as const;

export const DriverSummarySchema = {
  properties: {
    driver_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Id",
    },
    badge_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Badge Ids",
    },
    transaction_count: {
      type: "integer",
      title: "Transaction Count",
    },
    suspended_transaction_count: {
      type: "integer",
      title: "Suspended Transaction Count",
    },
    delivered_over_95_pct_count: {
      type: "integer",
      title: "Delivered Over 95 Pct Count",
    },
    average_driver_comfort_score: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Average Driver Comfort Score",
    },
    average_net_driver_score: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Average Net Driver Score",
    },
    average_flexibility: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Average Flexibility",
    },
    median_flexibility: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Median Flexibility",
    },
    average_duration_hours: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Average Duration Hours",
    },
    average_requested_duration_hours: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Average Requested Duration Hours",
    },
    suspended_requested_energy_wh: {
      type: "number",
      title: "Suspended Requested Energy Wh",
    },
    suspended_delivered_energy_wh: {
      type: "number",
      title: "Suspended Delivered Energy Wh",
    },
  },
  type: "object",
  required: [
    "driver_id",
    "badge_ids",
    "transaction_count",
    "suspended_transaction_count",
    "delivered_over_95_pct_count",
    "average_driver_comfort_score",
    "average_net_driver_score",
    "average_flexibility",
    "median_flexibility",
    "average_duration_hours",
    "average_requested_duration_hours",
    "suspended_requested_energy_wh",
    "suspended_delivered_energy_wh",
  ],
  title: "DriverSummary",
} as const;

export const DutchDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      enum: ["Liander", "Stedin", "Enexis"],
      title: "Dso",
    },
    connection_category: {
      type: "string",
      enum: [
        "Kleinverbruik <= 3x25A",
        "Kleinverbruik 3x25A - 3x35A",
        "Kleinverbruik 3x35A - 3x50A",
        "Kleinverbruik 3x50A - 3x63A",
        "Kleinverbruik 3x63A - 3x80A",
        "LS",
        "Transformatie MS/LS",
        "MS",
        "MS-Transport",
        "Transformatie HS/MS",
        "TS",
      ],
      title: "Connection Category",
    },
    contracted_offtake_kw: {
      type: "number",
      minimum: 0,
      title: "Contracted Offtake Kw",
    },
    contracted_injection_kw: {
      type: "number",
      minimum: 0,
      title: "Contracted Injection Kw",
    },
    expected_yearly_offtake_mwh: {
      type: "number",
      minimum: 0,
      title: "Expected Yearly Offtake Mwh",
    },
  },
  type: "object",
  required: [
    "dso",
    "connection_category",
    "contracted_offtake_kw",
    "contracted_injection_kw",
    "expected_yearly_offtake_mwh",
  ],
  title: "DutchDSOConnection",
  description:
    "A connection to one of the large Dutch DSOs, priced from their published tariff sheet.",
} as const;

export const DynamicEnergyContractSchema = {
  properties: {
    offtake_day_ahead_coefficient: {
      type: "number",
      title: "Offtake Day Ahead Coefficient",
    },
    offtake_cost_per_mwh: {
      type: "number",
      title: "Offtake Cost Per Mwh",
    },
    injection_day_ahead_coefficient: {
      type: "number",
      title: "Injection Day Ahead Coefficient",
    },
    injection_cost_per_mwh: {
      type: "number",
      title: "Injection Cost Per Mwh",
    },
    day_ahead_bidding_zone: {
      $ref: "#/components/schemas/BiddingZone",
    },
    offtake_absolute_day_ahead_coefficient: {
      type: "number",
      title: "Offtake Absolute Day Ahead Coefficient",
      default: 0,
    },
    injection_absolute_day_ahead_coefficient: {
      type: "number",
      title: "Injection Absolute Day Ahead Coefficient",
      default: 0,
    },
    contract_type: {
      type: "string",
      const: "dynamic",
      title: "Contract Type",
      default: "dynamic",
    },
  },
  type: "object",
  required: [
    "offtake_day_ahead_coefficient",
    "offtake_cost_per_mwh",
    "injection_day_ahead_coefficient",
    "injection_cost_per_mwh",
    "day_ahead_bidding_zone",
  ],
  title: "DynamicEnergyContract",
} as const;

export const EVPowerMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "evPower:2",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    currentType: {
      type: "string",
      enum: ["ac", "dc", "mixed"],
      title: "Currenttype",
    },
    power: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Power",
    },
    energyConsumed: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energyconsumed",
    },
    energyProduced: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energyproduced",
    },
    errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Errors",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    stations: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/Station",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Stations",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
    "currentType",
  ],
  title: "EVPowerMessage",
} as const;

export const EaseeOcppVendorSchema = {
  properties: {
    type: {
      type: "string",
      const: "easee",
      title: "Type",
      default: "easee",
    },
  },
  type: "object",
  title: "EaseeOcppVendor",
} as const;

export const ElecnovaBcqRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "elecnova-bcq",
      title: "Type",
      default: "elecnova-bcq",
    },
  },
  type: "object",
  title: "ElecnovaBcqRegisters",
} as const;

export const EndedGhostTransactionResponseSchema = {
  properties: {
    stop_time: {
      type: "string",
      format: "date-time",
      title: "Stop Time",
    },
  },
  type: "object",
  required: ["stop_time"],
  title: "EndedGhostTransactionResponse",
} as const;

export const EnergyProviderContract_InputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/FixedEnergyContract",
    },
    {
      $ref: "#/components/schemas/DynamicEnergyContract",
    },
    {
      $ref: "#/components/schemas/DayNightBeEnergyContract",
    },
  ],
  discriminator: {
    propertyName: "contract_type",
    mapping: {
      day_night_be: "#/components/schemas/DayNightBeEnergyContract",
      dynamic: "#/components/schemas/DynamicEnergyContract",
      fixed: "#/components/schemas/FixedEnergyContract",
    },
  },
} as const;

export const EnergyProviderContract_OutputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/FixedEnergyContract",
    },
    {
      $ref: "#/components/schemas/DynamicEnergyContract",
    },
    {
      $ref: "#/components/schemas/DayNightBeEnergyContract",
    },
  ],
  discriminator: {
    propertyName: "contract_type",
    mapping: {
      day_night_be: "#/components/schemas/DayNightBeEnergyContract",
      dynamic: "#/components/schemas/DynamicEnergyContract",
      fixed: "#/components/schemas/FixedEnergyContract",
    },
  },
} as const;

export const EntsoeQueryTypeSchema = {
  type: "string",
  enum: [
    "day_ahead_prices",
    "load_forecast",
    "generation_forecast",
    "wind_and_solar_forecast",
    "crossborder_flows",
  ],
  title: "EntsoeQueryType",
} as const;

export const EtrelInchRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "etrel-inch",
      title: "Type",
      default: "etrel-inch",
    },
    connector_id: {
      type: "integer",
      maximum: 2,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which of the charger's register blocks (offset by 100 per connector) this connector reads and writes: 1 on an INCH Home or INCH Pro and for the first connector of an INCH DUO, 2 for the DUO's second connector.",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "EtrelInchRegisters",
} as const;

export const EvMakeSchema = {
  properties: {
    slug: {
      type: "string",
      title: "Slug",
    },
    name: {
      type: "string",
      title: "Name",
    },
  },
  type: "object",
  required: ["slug", "name"],
  title: "EvMake",
} as const;

export const EvModelSchema = {
  properties: {
    slug: {
      type: "string",
      title: "Slug",
    },
    name: {
      type: "string",
      title: "Name",
    },
  },
  type: "object",
  required: ["slug", "name"],
  title: "EvModel",
} as const;

export const EvVariantSchema = {
  properties: {
    trim_slug: {
      type: "string",
      title: "Trim Slug",
    },
    trim_name: {
      type: "string",
      title: "Trim Name",
    },
    variant_slug: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant Slug",
    },
    variant_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant Name",
    },
    year: {
      type: "integer",
      title: "Year",
    },
    unique_code: {
      type: "string",
      title: "Unique Code",
    },
  },
  type: "object",
  required: ["trim_slug", "trim_name", "year", "unique_code"],
  title: "EvVariant",
} as const;

export const EvVehicleSchema = {
  properties: {
    unique_code: {
      type: "string",
      title: "Unique Code",
    },
    make_name: {
      type: "string",
      title: "Make Name",
    },
    make_slug: {
      type: "string",
      title: "Make Slug",
    },
    model_name: {
      type: "string",
      title: "Model Name",
    },
    model_slug: {
      type: "string",
      title: "Model Slug",
    },
    year: {
      type: "integer",
      title: "Year",
    },
    trim_name: {
      type: "string",
      title: "Trim Name",
    },
    trim_slug: {
      type: "string",
      title: "Trim Slug",
    },
    variant_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant Name",
    },
    variant_slug: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant Slug",
    },
    ac_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ac Max Power Kw",
    },
    dc_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Dc Max Power Kw",
    },
    battery_capacity_kwh_gross: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Gross",
    },
    battery_capacity_kwh_net: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Net",
    },
    range_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Range Km",
    },
    allow_zero_current: {
      type: "boolean",
      title: "Allow Zero Current",
      default: true,
    },
  },
  type: "object",
  required: [
    "unique_code",
    "make_name",
    "make_slug",
    "model_name",
    "model_slug",
    "year",
    "trim_name",
    "trim_slug",
  ],
  title: "EvVehicle",
} as const;

export const FailedMessageSchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    site_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Site Id",
    },
    asset_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Asset Id",
    },
    topic: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Topic",
    },
    reason: {
      $ref: "#/components/schemas/FailureReason",
    },
    type: {
      $ref: "#/components/schemas/MessageType",
    },
    payload: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Payload",
      description: "The message exactly as we received it over MQTT.",
    },
    parsing_errors: {
      items: {
        $ref: "#/components/schemas/ParsingError",
      },
      type: "array",
      title: "Parsing Errors",
      description:
        "Field-level reasons the message was rejected. Empty when the failure was not a validation error.",
    },
    error: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error",
      description:
        "The unparsed error, for failures that carry no field-level detail.",
    },
    received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Received At",
    },
  },
  type: "object",
  required: [
    "id",
    "site_id",
    "asset_id",
    "topic",
    "reason",
    "type",
    "payload",
    "parsing_errors",
    "error",
    "received_at",
  ],
  title: "FailedMessage",
} as const;

export const FailureReasonSchema = {
  type: "string",
  enum: [
    "VALIDATION_ERROR",
    "PARSE_NON_VALIDATION_ERROR",
    "DATABASE_ERROR",
    "UNKNOWN_ERROR",
    "EVENT_LOG_CAPPED",
  ],
  title: "FailureReason",
} as const;

export const FixedEnergyContractSchema = {
  properties: {
    fixed_offtake_cost_per_mwh: {
      type: "number",
      title: "Fixed Offtake Cost Per Mwh",
    },
    fixed_injection_cost_per_mwh: {
      type: "number",
      title: "Fixed Injection Cost Per Mwh",
    },
    contract_type: {
      type: "string",
      const: "fixed",
      title: "Contract Type",
      default: "fixed",
    },
  },
  type: "object",
  required: ["fixed_offtake_cost_per_mwh", "fixed_injection_cost_per_mwh"],
  title: "FixedEnergyContract",
} as const;

export const FluviusDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "Fluvius",
      title: "Dso",
    },
    region: {
      type: "string",
      enum: [
        "Imewo",
        "West",
        "Antwerpen",
        "Midden-Vlaanderen",
        "Zenne-Dijle",
        "Halle-Vilvoorde",
        "Kempen",
        "Limburg",
      ],
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "Low Voltage Network",
        "<= 1 kV Distribution Cabine",
        "1-26 kV-net",
        "1-26 kV-post",
        "26-36 kV-net",
        "26-36 kV-post",
      ],
      title: "Connection Type",
    },
    toegangsvermogen: {
      type: "number",
      title: "Toegangsvermogen",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type", "toegangsvermogen"],
  title: "FluviusDSOConnection",
} as const;

export const ForecastTypeSiteConfigurationSchema = {
  type: "string",
  enum: ["pv", "load"],
  title: "ForecastTypeSiteConfiguration",
} as const;

export const ForecastedDeviceSchema = {
  properties: {
    device_id: {
      type: "string",
      title: "Device Id",
      examples: ["PV@main_collector"],
    },
    parent_collector_id: {
      type: "string",
      title: "Parent Collector Id",
      examples: ["main_collector"],
    },
    train_window: {
      type: "number",
      title: "Train Window",
      default: 90,
      examples: [90],
    },
    sample_size: {
      type: "number",
      title: "Sample Size",
      default: 900,
      examples: [900],
    },
    time_field: {
      type: "string",
      title: "Time Field",
      examples: ["timestamp"],
    },
    forecasted_field: {
      type: "string",
      title: "Forecasted Field",
      examples: ["powerValue"],
    },
    training_interval: {
      anyOf: [
        {
          type: "string",
          pattern: "^P(T?\\d+.*)$",
        },
        {
          type: "null",
        },
      ],
      title: "Training Interval",
      examples: ["P1DT"],
    },
    active: {
      type: "boolean",
      title: "Active",
      default: true,
    },
    forecast_type: {
      $ref: "#/components/schemas/DeviceForecastType",
      default: "pv",
    },
  },
  type: "object",
  required: [
    "device_id",
    "parent_collector_id",
    "time_field",
    "forecasted_field",
  ],
  title: "ForecastedDevice",
} as const;

export const ForecastedThreePhaseDevice_InputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "forecasted_series_3phase",
      title: "Type",
      default: "forecasted_series_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    forecast_type: {
      $ref: "#/components/schemas/ForecastTypeSiteConfiguration",
      description: "Defines the type of forecast to be used for this device.",
    },
    should_be_aggregated: {
      type: "boolean",
      title: "Should Be Aggregated",
      default: false,
    },
    curtailment_mode: {
      $ref: "#/components/schemas/CurtailmentMode",
      description:
        "How the controller may curtail this device's production to respect the grid minimum. NONE never curtails; CONTINUOUS curtails to any level. Only relevant for PV devices.",
      default: "none",
    },
  },
  type: "object",
  required: ["name", "collector", "line_current", "forecast_type"],
  title: "ForecastedThreePhaseDevice",
} as const;

export const ForecastedThreePhaseDevice_OutputSchema = {
  properties: {
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "forecasted_series_3phase",
      title: "Type",
      default: "forecasted_series_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    forecast_type: {
      $ref: "#/components/schemas/ForecastTypeSiteConfiguration",
      description: "Defines the type of forecast to be used for this device.",
    },
    should_be_aggregated: {
      type: "boolean",
      title: "Should Be Aggregated",
      default: false,
    },
    curtailment_mode: {
      $ref: "#/components/schemas/CurtailmentMode",
      description:
        "How the controller may curtail this device's production to respect the grid minimum. NONE never curtails; CONTINUOUS curtails to any level. Only relevant for PV devices.",
      default: "none",
    },
  },
  type: "object",
  required: ["name", "collector", "line_current", "forecast_type"],
  title: "ForecastedThreePhaseDevice",
} as const;

export const ForecastedThreePhaseDeviceWithIoConfigSchema = {
  properties: {
    io: {
      $ref: "#/components/schemas/IoConfig",
    },
    phase_permutations: {
      anyOf: [
        {
          $ref: "#/components/schemas/PhasePermutation",
        },
        {
          type: "null",
        },
      ],
      description:
        "Specify the phase mapping between this asset (`child`) and its parent collector (`parent`). Leave unset when the wiring is unknown; phase-aware control (`use_topology`) requires every asset's mapping to be declared, so a single unset mapping makes the controller fall back to the worst case.",
    },
    name: {
      type: "string",
      title: "Name",
      description:
        "The name of the device itself. This value will be used as the asset ID in the rest of the API.",
      examples: ["LR34_001"],
    },
    collector: {
      type: "string",
      title: "Collector",
      description:
        "The name of the collector to which this device is connected.",
      examples: ["main_collector"],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
        },
        {
          type: "null",
        },
      ],
      description:
        "Overrides the site-level ingress validation config for this asset. When set, controls how often measurements are expected during active and inactive transactions. When null, the site-level configuration is used.",
    },
    type: {
      type: "string",
      const: "forecasted_series_3phase",
      title: "Type",
      default: "forecasted_series_3phase",
    },
    line_current: {
      type: "integer",
      title: "Line Current",
      description: "The line current in Ampere.",
      examples: [32],
    },
    forecast_type: {
      $ref: "#/components/schemas/ForecastTypeSiteConfiguration",
      description: "Defines the type of forecast to be used for this device.",
    },
    should_be_aggregated: {
      type: "boolean",
      title: "Should Be Aggregated",
      default: false,
    },
    curtailment_mode: {
      $ref: "#/components/schemas/CurtailmentMode",
      description:
        "How the controller may curtail this device's production to respect the grid minimum. NONE never curtails; CONTINUOUS curtails to any level. Only relevant for PV devices.",
      default: "none",
    },
  },
  type: "object",
  required: ["io", "name", "collector", "line_current", "forecast_type"],
  title: "ForecastedThreePhaseDeviceWithIoConfig",
} as const;

export const ForecastersCountSchema = {
  properties: {
    pv_forecasters: {
      type: "integer",
      title: "Pv Forecasters",
      default: 0,
    },
    ucl_forecasters: {
      type: "integer",
      title: "Ucl Forecasters",
      default: 0,
    },
  },
  type: "object",
  title: "ForecastersCount",
} as const;

export const ForecastingConfigurationSchema = {
  properties: {
    forecasted_devices: {
      items: {
        $ref: "#/components/schemas/ForecastedDevice",
      },
      type: "array",
      title: "Forecasted Devices",
    },
  },
  type: "object",
  required: ["forecasted_devices"],
  title: "ForecastingConfiguration",
} as const;

export const ForwardUrlOverrideSchema = {
  properties: {
    forward_url: {
      type: "string",
      title: "Forward Url",
    },
    socket_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Socket Ids",
    },
  },
  type: "object",
  required: ["forward_url", "socket_ids"],
  title: "ForwardUrlOverride",
} as const;

export const FroniusInverterRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "fronius-inverter",
      title: "Type",
      default: "fronius-inverter",
    },
    slave_id: {
      type: "integer",
      maximum: 247,
      minimum: 1,
      title: "Slave Id",
      description:
        "Modbus unit id of this inverter. A Symo GEN24 answers on 1; behind a Datamanager 2.0 the unit id is the inverter number, with inverter 00 reachable on 100.",
    },
  },
  type: "object",
  required: ["slave_id"],
  title: "FroniusInverterRegisters",
} as const;

export const FroniusSmartMeterRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "fronius-smart-meter",
      title: "Type",
      default: "fronius-smart-meter",
    },
    slave_id: {
      type: "integer",
      maximum: 247,
      minimum: 1,
      title: "Slave Id",
      description:
        "Modbus unit id the inverter publishes its Fronius Smart Meter on: 240 behind a Datamanager 2.0, and 200 upwards (default 200) on a Symo GEN24.",
    },
  },
  type: "object",
  required: ["reference_frame", "slave_id"],
  title: "FroniusSmartMeterRegisters",
} as const;

export const GermanDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "German",
      title: "Dso",
    },
    dso_name: {
      type: "string",
      title: "Dso Name",
    },
    metering_type: {
      type: "string",
      enum: ["RLM", "SLP"],
      title: "Metering Type",
    },
    leistungspreis_per_kw_per_year: {
      type: "number",
      title: "Leistungspreis Per Kw Per Year",
    },
    arbeitspreis_per_mwh: {
      type: "number",
      title: "Arbeitspreis Per Mwh",
    },
    grid_fixed_yearly_price: {
      type: "number",
      title: "Grid Fixed Yearly Price",
    },
    stromsteuer_per_mwh: {
      type: "number",
      title: "Stromsteuer Per Mwh",
    },
    konzessionsabgabe_per_mwh: {
      type: "number",
      title: "Konzessionsabgabe Per Mwh",
    },
    levies_per_mwh: {
      type: "number",
      title: "Levies Per Mwh",
    },
  },
  type: "object",
  required: [
    "dso",
    "dso_name",
    "metering_type",
    "leistungspreis_per_kw_per_year",
    "arbeitspreis_per_mwh",
    "grid_fixed_yearly_price",
    "stromsteuer_per_mwh",
    "konzessionsabgabe_per_mwh",
    "levies_per_mwh",
  ],
  title: "GermanDSOConnection",
  description:
    "A German grid connection carrying its own Netzentgelt and tax rates.",
} as const;

export const GetProfileDTOSchema = {
  properties: {
    profile_id: {
      type: "string",
      title: "Profile Id",
      examples: ["profile-ev-fleet"],
    },
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ac: {
      anyOf: [
        {
          $ref: "#/components/schemas/AcChargingProfile-Output",
        },
        {
          type: "null",
        },
      ],
    },
    dc: {
      anyOf: [
        {
          $ref: "#/components/schemas/DcChargingProfile-Output",
        },
        {
          type: "null",
        },
      ],
    },
    override_transaction_input: {
      type: "boolean",
      title: "Override Transaction Input",
      default: false,
    },
    apply_to: {
      $ref: "#/components/schemas/ProfileApplyTo",
    },
  },
  type: "object",
  required: ["profile_id", "site_id"],
  title: "GetProfileDTO",
} as const;

export const GlobalForecastingTaskKindSchema = {
  type: "string",
  enum: [
    "day_ahead_forecasting",
    "imbalance_price_training",
    "imbalance_price_prediction",
  ],
  title: "GlobalForecastingTaskKind",
} as const;

export const GrandfatheredSiteReportSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    site_name: {
      type: "string",
      title: "Site Name",
    },
    active: {
      type: "boolean",
      title: "Active",
    },
    activated_at: {
      items: {
        type: "string",
        format: "date-time",
      },
      type: "array",
      title: "Activated At",
    },
    last_deactivated_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Deactivated At",
    },
    nb_ac_charging_stations: {
      type: "integer",
      title: "Nb Ac Charging Stations",
    },
    nb_dc_charging_stations: {
      type: "integer",
      title: "Nb Dc Charging Stations",
    },
    ac_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["small", "medium", "large", "extra_large", "custom"],
        },
        {
          type: "null",
        },
      ],
      title: "Ac Tier",
    },
    dc_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["small", "medium", "large", "extra_large", "custom"],
        },
        {
          type: "null",
        },
      ],
      title: "Dc Tier",
    },
    has_ocpp_config: {
      type: "boolean",
      title: "Has Ocpp Config",
    },
    ocpp_broker_fee: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Ocpp Broker Fee",
    },
    has_drivers: {
      type: "boolean",
      title: "Has Drivers",
    },
    driver_app_fee: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Driver App Fee",
    },
  },
  type: "object",
  required: [
    "site_id",
    "site_name",
    "active",
    "activated_at",
    "last_deactivated_at",
    "nb_ac_charging_stations",
    "nb_dc_charging_stations",
    "ac_tier",
    "dc_tier",
    "has_ocpp_config",
    "ocpp_broker_fee",
    "has_drivers",
    "driver_app_fee",
  ],
  title: "GrandfatheredSiteReport",
} as const;

export const GridConnectionSchema = {
  properties: {
    connection_offtake_limit: {
      type: "number",
      minimum: 0,
      title: "Connection Offtake Limit",
      description:
        "The apparent power in kVA the DSO connection allows the site to take from the grid. `0` for a site that is not connected to the grid.",
      examples: [400],
    },
    connection_injection_limit: {
      type: "number",
      minimum: 0,
      title: "Connection Injection Limit",
      description:
        "The apparent power in kVA the DSO connection allows the site to inject into the grid. Set it to `0` to forbid injection.",
      examples: [400],
    },
  },
  type: "object",
  required: ["connection_offtake_limit", "connection_injection_limit"],
  title: "GridConnection",
} as const;

export const GridPowerDataPointSchema = {
  properties: {
    time_of_day: {
      type: "number",
      title: "Time Of Day",
    },
    live_kw: {
      type: "number",
      title: "Live Kw",
    },
    load_balancing_kw: {
      type: "number",
      title: "Load Balancing Kw",
    },
  },
  type: "object",
  required: ["time_of_day", "live_kw", "load_balancing_kw"],
  title: "GridPowerDataPoint",
} as const;

export const GridPowerLimitsSchema = {
  properties: {
    offtake_trip_limit: {
      type: "number",
      minimum: 0,
      title: "Offtake Trip Limit",
      description:
        "The apparent power in kVA the grid connection must not take more than. Above it the controller cuts the grid offtake it allows until the line has recovered.",
    },
    offtake_steer_limit: {
      type: "number",
      minimum: 0,
      title: "Offtake Steer Limit",
      description:
        "The apparent power in kVA the controller steers the grid offtake at.",
    },
    injection_trip_limit: {
      type: "number",
      minimum: 0,
      title: "Injection Trip Limit",
      description:
        "The apparent power in kVA the grid connection must not inject more than. Beyond it the controller cuts the grid injection it allows until the line has recovered. Never below a little injection, so a meter reading around zero does not count as tripping on a connection that allows little or no injection.",
    },
    injection_steer_limit: {
      type: "number",
      title: "Injection Steer Limit",
      description:
        "The apparent power in kVA the controller steers the grid injection at. `0` when the grid connection may not inject at all.",
    },
  },
  type: "object",
  required: [
    "offtake_trip_limit",
    "offtake_steer_limit",
    "injection_trip_limit",
    "injection_steer_limit",
  ],
  title: "GridPowerLimits",
} as const;

export const GridProfileSchema = {
  properties: {
    type: {
      type: "string",
      const: "grid",
      title: "Type",
      default: "grid",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    minCurrent: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Mincurrent",
      examples: [-400],
    },
    minCurrentConsumptionOnly: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Mincurrentconsumptiononly",
      examples: [0],
    },
    maxCurrent: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Maxcurrent",
      examples: [400],
    },
  },
  type: "object",
  required: ["timestamp"],
  title: "GridProfile",
  description: `The window the grid connection must stay within for one timestep.

Per-phase current and not power, so the controller can apply it to the line
directly. \`None\` on a side leaves that side to the controller configuration.

\`minCurrentConsumptionOnly\` is the lower bound consumption alone has to
reach; it sits at or above \`minCurrent\`, which production is curtailed for.`,
} as const;

export const HSLColorSchema = {
  properties: {
    hue: {
      type: "number",
      maximum: 360,
      minimum: 0,
      title: "Hue",
    },
    saturation: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Saturation",
    },
    lightness: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Lightness",
    },
  },
  type: "object",
  required: ["hue", "saturation", "lightness"],
  title: "HSLColor",
} as const;

export const HTTPValidationErrorSchema = {
  properties: {
    detail: {
      items: {
        $ref: "#/components/schemas/ValidationError",
      },
      type: "array",
      title: "Detail",
    },
  },
  type: "object",
  title: "HTTPValidationError",
} as const;

export const HuaweiSmartLoggerRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "huawei-smart-logger",
      title: "Type",
      default: "huawei-smart-logger",
    },
  },
  type: "object",
  title: "HuaweiSmartLoggerRegisters",
} as const;

export const IOConfiguration_InputSchema = {
  properties: {
    asset_io_config: {
      items: {
        $ref: "#/components/schemas/AssetIOConfig-Input",
      },
      type: "array",
      title: "Asset Io Config",
    },
    controller_mode: {
      type: "string",
      enum: ["read_only", "active"],
      title: "Controller Mode",
      default: "read_only",
    },
    phase_permutation_mode: {
      type: "string",
      enum: ["worst_case", "use_topology"],
      title: "Phase Permutation Mode",
      default: "worst_case",
    },
  },
  type: "object",
  required: ["asset_io_config"],
  title: "IOConfiguration",
} as const;

export const IOConfiguration_OutputSchema = {
  properties: {
    asset_io_config: {
      items: {
        $ref: "#/components/schemas/AssetIOConfig-Output",
      },
      type: "array",
      title: "Asset Io Config",
    },
    controller_mode: {
      type: "string",
      enum: ["read_only", "active"],
      title: "Controller Mode",
      default: "read_only",
    },
    phase_permutation_mode: {
      type: "string",
      enum: ["worst_case", "use_topology"],
      title: "Phase Permutation Mode",
      default: "worst_case",
    },
  },
  type: "object",
  required: ["asset_io_config"],
  title: "IOConfiguration",
} as const;

export const IdentityResponseSchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    type: {
      type: "string",
      enum: ["user", "admin", "site_owner"],
      title: "Type",
    },
    client_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Client Ids",
    },
    partner_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Partner Id",
    },
    site_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Site Ids",
    },
    registration_completed: {
      type: "boolean",
      title: "Registration Completed",
      default: true,
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
  },
  type: "object",
  required: ["id", "type", "client_ids"],
  title: "IdentityResponse",
  description:
    "An identity as exposed over the API, without credential hashes.",
} as const;

export const ImbalancePriceInsightSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    actual_price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Actual Price",
    },
    latest_prediction: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Prediction",
    },
    bands: {
      items: {
        $ref: "#/components/schemas/ImbalancePricePredictionBand",
      },
      type: "array",
      title: "Bands",
    },
    minute_forecasts: {
      items: {
        $ref: "#/components/schemas/ImbalancePriceMinuteForecast",
      },
      type: "array",
      title: "Minute Forecasts",
      default: [],
    },
    latest_minute_forecast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Minute Forecast",
    },
  },
  type: "object",
  required: ["timestamp", "actual_price", "latest_prediction", "bands"],
  title: "ImbalancePriceInsight",
} as const;

export const ForecasterKindSchema = {
  type: "string",
  enum: ["per_minute", "step"],
  title: "ForecasterKind",
} as const;

export const ForecasterSpecSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    label: {
      type: "string",
      title: "Label",
    },
    kind: {
      $ref: "#/components/schemas/ForecasterKind",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["name", "label", "kind", "description"],
  title: "ForecasterSpec",
} as const;

export const PlannerSetupSpecSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    label: {
      type: "string",
      title: "Label",
    },
    role: {
      $ref: "#/components/schemas/SetupRole",
    },
    running: {
      type: "string",
      title: "Running",
    },
    future: {
      type: "string",
      title: "Future",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["name", "label", "role", "running", "future", "description"],
  title: "PlannerSetupSpec",
} as const;

export const SetupRoleSchema = {
  type: "string",
  enum: ["baseline", "ceiling", "ours", "candidate"],
  title: "SetupRole",
} as const;

export const BootstrapIntervalSchema = {
  properties: {
    difference: {
      type: "number",
      title: "Difference",
    },
    ci05: {
      type: "number",
      title: "Ci05",
    },
    ci95: {
      type: "number",
      title: "Ci95",
    },
    p_positive: {
      type: "number",
      title: "P Positive",
    },
    days: {
      type: "integer",
      title: "Days",
    },
  },
  type: "object",
  required: ["difference", "ci05", "ci95", "p_positive", "days"],
  title: "BootstrapInterval",
  description:
    "Day-block bootstrap (1,000 resamples of whole days) of the summed daily difference.",
} as const;

export const DailyMetricsRowSchema = {
  properties: {
    day: {
      type: "string",
      title: "Day",
    },
    provisional: {
      type: "boolean",
      title: "Provisional",
    },
    per_minute_version: {
      $ref: "#/components/schemas/PerMinuteForecasterVersion",
    },
    step_version: {
      $ref: "#/components/schemas/StepForecasterVersion",
    },
    coverage: {
      $ref: "#/components/schemas/EvaluationCoverage",
    },
    value: {
      items: {
        $ref: "#/components/schemas/PlannerValue",
      },
      type: "array",
      title: "Value",
    },
  },
  type: "object",
  required: [
    "day",
    "provisional",
    "per_minute_version",
    "step_version",
    "coverage",
    "value",
  ],
  title: "DailyMetricsRow",
} as const;

export const EvaluationCoverageSchema = {
  properties: {
    quarter_hours: {
      type: "integer",
      title: "Quarter Hours",
    },
    settled_quarter_hours: {
      type: "integer",
      title: "Settled Quarter Hours",
    },
    minutes: {
      type: "integer",
      title: "Minutes",
    },
    minute_forecasts: {
      type: "integer",
      title: "Minute Forecasts",
    },
    expected_price_forecasts: {
      type: "integer",
      title: "Expected Price Forecasts",
    },
    live_estimates: {
      type: "integer",
      title: "Live Estimates",
    },
    step_forecasts: {
      type: "integer",
      title: "Step Forecasts",
    },
    per_step_model_forecasts: {
      type: "integer",
      title: "Per Step Model Forecasts",
    },
  },
  type: "object",
  required: [
    "quarter_hours",
    "settled_quarter_hours",
    "minutes",
    "minute_forecasts",
    "expected_price_forecasts",
    "live_estimates",
    "step_forecasts",
    "per_step_model_forecasts",
  ],
  title: "EvaluationCoverage",
} as const;

export const ImbalanceForecastMetricsReportSchema = {
  properties: {
    source: {
      type: "string",
      title: "Source",
    },
    forecasters: {
      items: {
        $ref: "#/components/schemas/ForecasterSpec",
      },
      type: "array",
      title: "Forecasters",
    },
    setups: {
      items: {
        $ref: "#/components/schemas/PlannerSetupSpec",
      },
      type: "array",
      title: "Setups",
    },
    first_day: {
      type: "string",
      title: "First Day",
    },
    last_day: {
      type: "string",
      title: "Last Day",
    },
    days: {
      items: {
        $ref: "#/components/schemas/DailyMetricsRow",
      },
      type: "array",
      title: "Days",
    },
    headline: {
      items: {
        $ref: "#/components/schemas/ValueGroup",
      },
      type: "array",
      title: "Headline",
    },
    whole_range: {
      items: {
        $ref: "#/components/schemas/ValueGroup",
      },
      type: "array",
      title: "Whole Range",
    },
    monthly: {
      items: {
        $ref: "#/components/schemas/ValueGroup",
      },
      type: "array",
      title: "Monthly",
    },
    minute_errors: {
      items: {
        $ref: "#/components/schemas/MinuteErrorRow",
      },
      type: "array",
      title: "Minute Errors",
    },
    quantile_calibration: {
      items: {
        $ref: "#/components/schemas/QuantileCalibrationRow",
      },
      type: "array",
      title: "Quantile Calibration",
    },
    step_errors: {
      items: {
        $ref: "#/components/schemas/StepErrorRow",
      },
      type: "array",
      title: "Step Errors",
    },
    rank_correlation: {
      items: {
        $ref: "#/components/schemas/RankCorrelationRow",
      },
      type: "array",
      title: "Rank Correlation",
    },
    markers: {
      items: {
        $ref: "#/components/schemas/VersionMarker",
      },
      type: "array",
      title: "Markers",
    },
  },
  type: "object",
  required: [
    "source",
    "forecasters",
    "setups",
    "first_day",
    "last_day",
    "days",
    "headline",
    "whole_range",
    "monthly",
    "minute_errors",
    "quantile_calibration",
    "step_errors",
    "rank_correlation",
    "markers",
  ],
  title: "ImbalanceForecastMetricsReport",
} as const;

export const MinuteErrorRowSchema = {
  properties: {
    per_minute_version: {
      $ref: "#/components/schemas/PerMinuteForecasterVersion",
    },
    minute: {
      type: "integer",
      title: "Minute",
    },
    forecast: {
      type: "string",
      title: "Forecast",
    },
    n: {
      type: "integer",
      title: "N",
    },
    mae: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Mae",
    },
    rmse: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Rmse",
    },
    bias: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bias",
    },
    top_5pct_mae: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Top 5Pct Mae",
    },
    top_5pct_bias: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Top 5Pct Bias",
    },
    bottom_5pct_mae: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bottom 5Pct Mae",
    },
    bottom_5pct_bias: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bottom 5Pct Bias",
    },
    spikes: {
      additionalProperties: {
        $ref: "#/components/schemas/SpikeScores",
      },
      type: "object",
      title: "Spikes",
    },
  },
  type: "object",
  required: [
    "per_minute_version",
    "minute",
    "forecast",
    "n",
    "mae",
    "rmse",
    "bias",
    "top_5pct_mae",
    "top_5pct_bias",
    "bottom_5pct_mae",
    "bottom_5pct_bias",
    "spikes",
  ],
  title: "MinuteErrorRow",
} as const;

export const PerMinuteForecasterVersionSchema = {
  type: "string",
  enum: ["median_only", "with_expected_price", "mixed", "none", "research"],
  title: "PerMinuteForecasterVersion",
} as const;

export const PlannerValueSchema = {
  properties: {
    setup: {
      type: "string",
      title: "Setup",
    },
    cycling_cost: {
      type: "number",
      title: "Cycling Cost",
    },
    gross_revenue: {
      type: "number",
      title: "Gross Revenue",
    },
    net_revenue: {
      type: "number",
      title: "Net Revenue",
    },
    discharged_mwh: {
      type: "number",
      title: "Discharged Mwh",
    },
    charged_mwh: {
      type: "number",
      title: "Charged Mwh",
    },
    start_soc_mwh: {
      type: "number",
      title: "Start Soc Mwh",
    },
    end_soc_mwh: {
      type: "number",
      title: "End Soc Mwh",
    },
    active_minutes: {
      type: "integer",
      title: "Active Minutes",
    },
  },
  type: "object",
  required: [
    "setup",
    "cycling_cost",
    "gross_revenue",
    "net_revenue",
    "discharged_mwh",
    "charged_mwh",
    "start_soc_mwh",
    "end_soc_mwh",
    "active_minutes",
  ],
  title: "PlannerValue",
} as const;

export const QuantileCalibrationRowSchema = {
  properties: {
    per_minute_version: {
      $ref: "#/components/schemas/PerMinuteForecasterVersion",
    },
    forecaster: {
      type: "string",
      title: "Forecaster",
    },
    level: {
      type: "string",
      title: "Level",
    },
    minute: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Minute",
    },
    n: {
      type: "integer",
      title: "N",
    },
    share_below: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Share Below",
    },
  },
  type: "object",
  required: [
    "per_minute_version",
    "forecaster",
    "level",
    "minute",
    "n",
    "share_below",
  ],
  title: "QuantileCalibrationRow",
} as const;

export const RankCorrelationRowSchema = {
  properties: {
    step_version: {
      $ref: "#/components/schemas/StepForecasterVersion",
    },
    forecaster: {
      type: "string",
      title: "Forecaster",
    },
    steps: {
      type: "integer",
      title: "Steps",
    },
    vintages: {
      type: "integer",
      title: "Vintages",
    },
    mean_correlation: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Mean Correlation",
    },
  },
  type: "object",
  required: [
    "step_version",
    "forecaster",
    "steps",
    "vintages",
    "mean_correlation",
  ],
  title: "RankCorrelationRow",
} as const;

export const SetupValueSummarySchema = {
  properties: {
    setup: {
      type: "string",
      title: "Setup",
    },
    days: {
      type: "integer",
      title: "Days",
    },
    net_revenue: {
      type: "number",
      title: "Net Revenue",
    },
    gross_revenue: {
      type: "number",
      title: "Gross Revenue",
    },
    per_mw_year: {
      type: "number",
      title: "Per Mw Year",
    },
    share_of_ceiling: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Share Of Ceiling",
    },
    mwh_moved: {
      type: "number",
      title: "Mwh Moved",
    },
    cycles_per_day: {
      type: "number",
      title: "Cycles Per Day",
    },
    difference_to_baseline: {
      anyOf: [
        {
          $ref: "#/components/schemas/BootstrapInterval",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "setup",
    "days",
    "net_revenue",
    "gross_revenue",
    "per_mw_year",
    "share_of_ceiling",
    "mwh_moved",
    "cycles_per_day",
    "difference_to_baseline",
  ],
  title: "SetupValueSummary",
} as const;

export const SpikeScoresSchema = {
  properties: {
    precision: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Precision",
    },
    recall: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Recall",
    },
    f1: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "F1",
    },
    true_positives: {
      type: "integer",
      title: "True Positives",
    },
    false_positives: {
      type: "integer",
      title: "False Positives",
    },
    false_negatives: {
      type: "integer",
      title: "False Negatives",
    },
  },
  type: "object",
  required: [
    "precision",
    "recall",
    "f1",
    "true_positives",
    "false_positives",
    "false_negatives",
  ],
  title: "SpikeScores",
} as const;

export const StepErrorRowSchema = {
  properties: {
    step_version: {
      $ref: "#/components/schemas/StepForecasterVersion",
    },
    forecaster: {
      type: "string",
      title: "Forecaster",
    },
    step: {
      type: "integer",
      title: "Step",
    },
    n: {
      type: "integer",
      title: "N",
    },
    mae: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Mae",
    },
    rmse: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Rmse",
    },
    bias: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bias",
    },
    day_ahead_mae: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Day Ahead Mae",
    },
    day_ahead_rmse: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Day Ahead Rmse",
    },
    day_ahead_bias: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Day Ahead Bias",
    },
    sign_accuracy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sign Accuracy",
    },
    large_spread_compared: {
      type: "integer",
      title: "Large Spread Compared",
    },
    large_spread_sign_accuracy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Large Spread Sign Accuracy",
    },
  },
  type: "object",
  required: [
    "step_version",
    "forecaster",
    "step",
    "n",
    "mae",
    "rmse",
    "bias",
    "day_ahead_mae",
    "day_ahead_rmse",
    "day_ahead_bias",
    "sign_accuracy",
    "large_spread_compared",
    "large_spread_sign_accuracy",
  ],
  title: "StepErrorRow",
} as const;

export const StepForecasterVersionSchema = {
  type: "string",
  enum: ["pooled", "per_step", "mixed", "none", "research"],
  title: "StepForecasterVersion",
} as const;

export const ValueGroupSchema = {
  properties: {
    label: {
      type: "string",
      title: "Label",
    },
    first_day: {
      type: "string",
      title: "First Day",
    },
    last_day: {
      type: "string",
      title: "Last Day",
    },
    per_minute_version: {
      $ref: "#/components/schemas/PerMinuteForecasterVersion",
    },
    step_version: {
      $ref: "#/components/schemas/StepForecasterVersion",
    },
    cycling_cost: {
      type: "number",
      title: "Cycling Cost",
    },
    days: {
      type: "integer",
      title: "Days",
    },
    provisional_days: {
      type: "integer",
      title: "Provisional Days",
    },
    setups: {
      items: {
        $ref: "#/components/schemas/SetupValueSummary",
      },
      type: "array",
      title: "Setups",
    },
  },
  type: "object",
  required: [
    "label",
    "first_day",
    "last_day",
    "per_minute_version",
    "step_version",
    "cycling_cost",
    "days",
    "provisional_days",
    "setups",
  ],
  title: "ValueGroup",
  description:
    "One number per setup over days that share a forecaster version (never mixed).",
} as const;

export const VersionMarkerSchema = {
  properties: {
    day: {
      type: "string",
      title: "Day",
    },
    forecaster: {
      type: "string",
      title: "Forecaster",
    },
    label: {
      type: "string",
      title: "Label",
    },
  },
  type: "object",
  required: ["day", "forecaster", "label"],
  title: "VersionMarker",
} as const;

export const ImbalancePriceMinuteForecastSchema = {
  properties: {
    minute: {
      type: "integer",
      title: "Minute",
    },
    forecasted_at: {
      type: "string",
      format: "date-time",
      title: "Forecasted At",
    },
    valid_from: {
      type: "string",
      format: "date-time",
      title: "Valid From",
    },
    predicted_price: {
      type: "number",
      title: "Predicted Price",
    },
    predicted_price_quantiles: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Predicted Price Quantiles",
    },
  },
  type: "object",
  required: ["minute", "forecasted_at", "valid_from", "predicted_price"],
  title: "ImbalancePriceMinuteForecast",
} as const;

export const ImbalancePricePredictionBandSchema = {
  properties: {
    hours_before: {
      type: "integer",
      title: "Hours Before",
    },
    lower: {
      type: "number",
      title: "Lower",
    },
    upper: {
      type: "number",
      title: "Upper",
    },
  },
  type: "object",
  required: ["hours_before", "lower", "upper"],
  title: "ImbalancePricePredictionBand",
} as const;

export const IngressStatus_InputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    receiving_measurement_data: {
      $ref: "#/components/schemas/ReceivingMeasurements",
      default: {
        status: "OK",
        not_receiving_data_from: [],
        all_assets: false,
      },
    },
  },
  type: "object",
  title: "IngressStatus",
} as const;

export const IngressStatus_OutputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    receiving_measurement_data: {
      $ref: "#/components/schemas/ReceivingMeasurements",
      default: {
        status: "OK",
        not_receiving_data_from: [],
        all_assets: false,
      },
    },
  },
  type: "object",
  title: "IngressStatus",
} as const;

export const InviteAdminDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    origin: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Origin",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    type: {
      type: "string",
      const: "admin",
      title: "Type",
      default: "admin",
    },
  },
  type: "object",
  required: ["email"],
  title: "InviteAdminDTO",
} as const;

export const InvitePartnerUserDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    partner_id: {
      anyOf: [
        {
          type: "string",
          minLength: 3,
        },
        {
          type: "null",
        },
      ],
      title: "Partner Id",
    },
    origin: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Origin",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    type: {
      type: "string",
      const: "user",
      title: "Type",
      default: "user",
    },
  },
  type: "object",
  required: ["email"],
  title: "InvitePartnerUserDTO",
} as const;

export const InviteSiteOwnerDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    partner_id: {
      anyOf: [
        {
          type: "string",
          minLength: 3,
        },
        {
          type: "null",
        },
      ],
      title: "Partner Id",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      minItems: 1,
      title: "Site Ids",
    },
    origin: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Origin",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    type: {
      type: "string",
      const: "site_owner",
      title: "Type",
      default: "site_owner",
    },
  },
  type: "object",
  required: ["email", "site_ids"],
  title: "InviteSiteOwnerDTO",
} as const;

export const InvoicingOverviewSchema = {
  properties: {
    partners: {
      items: {
        $ref: "#/components/schemas/PartnerInvoicingReport",
      },
      type: "array",
      title: "Partners",
    },
    total_monthly_price: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Total Monthly Price",
    },
  },
  type: "object",
  required: ["partners", "total_monthly_price"],
  title: "InvoicingOverview",
} as const;

export const IoConfigSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ModbusTcpIoConfig",
    },
    {
      $ref: "#/components/schemas/P1MeterIoConfig",
    },
    {
      $ref: "#/components/schemas/VirtualIoConfig",
    },
    {
      $ref: "#/components/schemas/OcppIoConfig-Output",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "modbus-tcp": "#/components/schemas/ModbusTcpIoConfig",
      ocpp: "#/components/schemas/OcppIoConfig-Output",
      "p1-meter": "#/components/schemas/P1MeterIoConfig",
      virtual: "#/components/schemas/VirtualIoConfig",
    },
  },
} as const;

export const JanitzaUmg604ProRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "janitza-umg604pro",
      title: "Type",
      default: "janitza-umg604pro",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "JanitzaUmg604ProRegisters",
} as const;

export const JwtAdminAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "admin_access",
      title: "Type",
      default: "admin_access",
    },
    admin_id: {
      type: "string",
      title: "Admin Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
  },
  type: "object",
  required: ["admin_id", "client_id"],
  title: "JwtAdminAccessToken",
} as const;

export const JwtAdminDriverAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "admin_driver_access",
      title: "Type",
      default: "admin_driver_access",
    },
    admin_id: {
      type: "string",
      title: "Admin Id",
    },
    driver_id: {
      type: "string",
      title: "Driver Id",
    },
  },
  type: "object",
  required: ["admin_id", "driver_id"],
  title: "JwtAdminDriverAccessToken",
} as const;

export const JwtAdminPartnerAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "admin_partner_access",
      title: "Type",
      default: "admin_partner_access",
    },
    admin_id: {
      type: "string",
      title: "Admin Id",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
  },
  type: "object",
  required: ["admin_id", "partner_id"],
  title: "JwtAdminPartnerAccessToken",
} as const;

export const JwtDriverAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "driver_access",
      title: "Type",
      default: "driver_access",
    },
    driver_id: {
      type: "string",
      title: "Driver Id",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
    },
    badge_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Badge Ids",
    },
  },
  type: "object",
  required: ["driver_id", "site_ids"],
  title: "JwtDriverAccessToken",
} as const;

export const JwtPartnerAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "partner_access",
      title: "Type",
      default: "partner_access",
    },
    user_id: {
      type: "string",
      title: "User Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
  },
  type: "object",
  required: ["user_id", "client_id", "partner_id"],
  title: "JwtPartnerAccessToken",
} as const;

export const JwtSiteOwnerAccessTokenSchema = {
  properties: {
    type: {
      type: "string",
      const: "site_owner_access",
      title: "Type",
      default: "site_owner_access",
    },
    owner_id: {
      type: "string",
      title: "Owner Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
  },
  type: "object",
  required: ["owner_id", "client_id", "site_ids", "partner_id"],
  title: "JwtSiteOwnerAccessToken",
} as const;

export const KempowerRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "kempower",
      title: "Type",
      default: "kempower",
    },
    connector_id: {
      type: "integer",
      maximum: 36,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which of the charger's register blocks (offset by 1000 per connector) this connector reads and writes. Kempower reserves three connectors per satellite, so this is (satellite number - 1) * 3 + connector number, not the number shown on the satellite's display.",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "KempowerRegisters",
} as const;

export const KpiNotCalculatedWarningSchema = {
  properties: {
    kpi_name: {
      type: "string",
      title: "Kpi Name",
    },
    simulation_slug: {
      type: "string",
      title: "Simulation Slug",
    },
    message: {
      type: "string",
      title: "Message",
      default: "A KPI could not be calculated, so it has been set to 0.",
    },
    type: {
      type: "string",
      const: "kpi-not-calculated",
      title: "Type",
      default: "kpi-not-calculated",
    },
  },
  type: "object",
  required: ["kpi_name", "simulation_slug"],
  title: "KpiNotCalculatedWarning",
} as const;

export const LinkedOcppStartSchema = {
  properties: {
    badge_id: {
      type: "string",
      title: "Badge Id",
    },
    ocpp_transaction_id: {
      type: "string",
      title: "Ocpp Transaction Id",
    },
    ocpp_message_id: {
      type: "string",
      title: "Ocpp Message Id",
    },
  },
  type: "object",
  required: ["badge_id", "ocpp_transaction_id", "ocpp_message_id"],
  title: "LinkedOcppStart",
} as const;

export const LocationSchema = {
  properties: {
    name: {
      type: "string",
      title: "Name",
      examples: ["Brussels Office"],
    },
    coordinates: {
      prefixItems: [
        {
          type: "number",
        },
        {
          type: "number",
        },
        {
          type: "number",
        },
      ],
      type: "array",
      maxItems: 3,
      minItems: 3,
      title: "Coordinates",
      examples: [[50.8503, 4.3517, 0]],
    },
  },
  type: "object",
  required: ["name", "coordinates"],
  title: "Location",
} as const;

export const LoginResponseModelSchema = {
  properties: {
    token_type: {
      type: "string",
      const: "bearer",
      title: "Token Type",
      default: "bearer",
    },
    access_token: {
      type: "string",
      title: "Access Token",
      examples: ["your_access_token"],
    },
    type: {
      anyOf: [
        {
          type: "string",
          const: "partner_access",
        },
        {
          type: "string",
          const: "admin_access",
        },
        {
          type: "string",
          const: "admin_partner_access",
        },
        {
          type: "string",
          const: "driver_access",
        },
        {
          type: "string",
          const: "admin_driver_access",
        },
        {
          type: "string",
          const: "site_owner_access",
        },
      ],
      title: "Type",
    },
    expires_in: {
      type: "integer",
      title: "Expires In",
      examples: [3600],
    },
    user: {
      anyOf: [
        {
          $ref: "#/components/schemas/JwtPartnerAccessToken",
        },
        {
          $ref: "#/components/schemas/JwtAdminAccessToken",
        },
        {
          $ref: "#/components/schemas/JwtAdminPartnerAccessToken",
        },
        {
          $ref: "#/components/schemas/JwtDriverAccessToken",
        },
        {
          $ref: "#/components/schemas/JwtAdminDriverAccessToken",
        },
        {
          $ref: "#/components/schemas/JwtSiteOwnerAccessToken",
        },
      ],
      title: "User",
    },
  },
  type: "object",
  required: ["access_token", "type", "expires_in", "user"],
  title: "LoginResponseModel",
  examples: [
    {
      access_token: "your_access_token",
      expires_in: 3600,
      type: "bearer",
    },
  ],
} as const;

export const LoginWithPasswordDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    password: {
      type: "string",
      title: "Password",
    },
  },
  type: "object",
  required: ["email", "password"],
  title: "LoginWithPasswordDTO",
} as const;

export const MQTTConfig_InputSchema = {
  properties: {
    host: {
      type: "string",
      title: "Host",
    },
    topic: {
      type: "integer",
      title: "Topic",
    },
    username: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Username",
    },
    password: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Password",
    },
    tls: {
      type: "boolean",
      title: "Tls",
      default: false,
    },
    client_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Id",
    },
  },
  type: "object",
  required: ["host", "topic"],
  title: "MQTTConfig",
} as const;

export const MailAlertChannelSchema = {
  properties: {
    channel: {
      type: "string",
      const: "MAIL",
      title: "Channel",
      default: "MAIL",
    },
    email: {
      type: "string",
      title: "Email",
      examples: ["alerts@partner.example"],
    },
  },
  type: "object",
  required: ["email"],
  title: "MailAlertChannel",
} as const;

export const MappedConnectorSchema = {
  properties: {
    socket_id: {
      type: "string",
      title: "Socket Id",
    },
    evse_id: {
      type: "integer",
      title: "Evse Id",
    },
  },
  type: "object",
  required: ["socket_id", "evse_id"],
  title: "MappedConnector",
} as const;

export const MeasurementSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    source: {
      $ref: "#/components/schemas/MeasurementSource",
    },
    energyValue: {
      type: "number",
      title: "Energyvalue",
      examples: [1030404],
    },
    powerValue: {
      type: "number",
      title: "Powervalue",
      examples: [7000],
    },
    received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Received At",
    },
    currentStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Currentstateofcharge",
    },
    energyPositive: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energypositive",
    },
    energyNegative: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energynegative",
    },
    isCurtailed: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Iscurtailed",
    },
    uncurtailedPowerValue: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Uncurtailedpowervalue",
    },
  },
  type: "object",
  required: ["timestamp", "source", "energyValue", "powerValue"],
  title: "Measurement",
} as const;

export const MeasurementSourceSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
      examples: ["site-1"],
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
      examples: ["charger-A1"],
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
  },
  type: "object",
  required: ["site_id", "asset_id", "partner_id"],
  title: "MeasurementSource",
} as const;

export const MennekesEcuRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "mennekes-ecu",
      title: "Type",
      default: "mennekes-ecu",
    },
  },
  type: "object",
  title: "MennekesEcuRegisters",
} as const;

export const MessageTypeSchema = {
  type: "string",
  enum: [
    "MEASUREMENT",
    "TRANSACTION",
    "TRANSACTION_EVENT",
    "TRANSACTION_EVENT_DROPPED",
    "UNKNOWN",
  ],
  title: "MessageType",
} as const;

export const MeterPowerFlashMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "meterPower.flash:1",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "MeterPowerFlashMessage",
} as const;

export const MeterPowerMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "meterPower:2",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    voltage: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Voltage",
    },
    current: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Current",
    },
    threePhaseConnectionType: {
      anyOf: [
        {
          type: "string",
          enum: ["wye", "delta"],
        },
        {
          type: "null",
        },
      ],
      title: "Threephaseconnectiontype",
    },
    activePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    reactivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Reactivepower",
    },
    apparentPower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Apparentpower",
    },
    powerFactor: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Powerfactor",
    },
    frequency: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Frequency",
    },
    activeEnergyConsumed: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Activeenergyconsumed",
    },
    activeEnergyDelivered: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Activeenergydelivered",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "MeterPowerMessage",
} as const;

export const MissedEnergySchema = {
  properties: {
    left_early_wh: {
      type: "number",
      title: "Left Early Wh",
    },
    other_wh: {
      type: "number",
      title: "Other Wh",
    },
  },
  type: "object",
  required: ["left_early_wh", "other_wh"],
  title: "MissedEnergy",
} as const;

export const MissingContractWarningSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    message: {
      type: "string",
      title: "Message",
      default:
        "No energy contract was found, so the simulation uses a default energy contract. You are invited to update this in your settings.",
    },
    type: {
      type: "string",
      const: "missing-contract",
      title: "Type",
      default: "missing-contract",
    },
  },
  type: "object",
  required: ["site_id"],
  title: "MissingContractWarning",
} as const;

export const ModbusRegisterCatalogSchema = {
  properties: {
    registers: {
      additionalProperties: {
        type: "string",
        enum: [
          "alfen",
          "abb-cms",
          "pqube-3",
          "abb-emax2",
          "siemens-pac2200",
          "socomec-countis",
          "sungrow-ems300cp",
          "elecnova-bcq",
          "janitza-umg604pro",
          "shelly-3em",
          "schneider-powertag",
          "schneider-pm3200-iem3000",
          "schneider-pm5100",
          "phoenix-contact-empro",
          "phoenix-contact-empro-xm",
          "carlo-gavazzi-em24",
          "algodue-upm209",
          "xemex-smart-connect",
          "alpitronix-hypercharger",
          "sungrow-idc480e-c",
          "pluon-dc",
          "autel",
          "charx",
          "etrel-inch",
          "mennekes-ecu",
          "kempower",
          "huawei-smart-logger",
          "sma-data-manager",
          "sma-sunny-tripower-core2",
          "fronius-inverter",
          "fronius-smart-meter",
          "unsupported",
        ],
      },
      type: "object",
      title: "Registers",
      description:
        "The Modbus register driver each supported device is read with, keyed by the device's identity — '<device_type>|<brand>|<model>', where device_type is a site-configuration DeviceType value or 'collector' for a meter. An identity absent from the map is read with 'unsupported'.",
    },
  },
  type: "object",
  required: ["registers"],
  title: "ModbusRegisterCatalog",
} as const;

export const ModbusTcpIoConfigSchema = {
  properties: {
    type: {
      type: "string",
      const: "modbus-tcp",
      title: "Type",
      default: "modbus-tcp",
    },
    ip: {
      type: "string",
      format: "ipvanyaddress",
      title: "Ip",
    },
    port: {
      type: "integer",
      maximum: 65535,
      minimum: 0,
      title: "Port",
    },
    registers: {
      $ref: "#/components/schemas/Registers",
    },
  },
  type: "object",
  required: ["ip", "port", "registers"],
  title: "ModbusTcpIoConfig",
} as const;

export const MqttMeasurementSchema = {
  properties: {
    assetId: {
      type: "string",
      title: "Assetid",
      description:
        "The unique identifier of the asset. This matches the name in the site configuration. This can be a metered device such as a charging pole or a battery, a subcollector meter or any (virtual) device supplying energy data (metered, estimated or calculated).",
      examples: ["charger-A1"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
      description: "The timestamp when the measurement was taken",
    },
    energyValue: {
      type: "number",
      title: "Energyvalue",
      description:
        "The net energy (in Wh) that has been delivered/received by the asset up to the timestamp. For producing assets such as PV, a positive value means produced energy. For all other assets, a positive value means consumed energy. When energyPositive and energyNegative are defined, this should equal energyPositive - energyNegative. This can be a cumulative value that indicates the meter value across the lifetime of the meter (e.g. for a charging pole that keeps increasing across transactions). For charging poles, it can also be a relative one, that only includes the energy charged since the start of the transaction.",
      examples: [1030404],
    },
    powerValue: {
      type: "number",
      title: "Powervalue",
      description:
        "The power (in W) measured at the timestamp for this asset. For producing assets such as PV, a positive value means produced power. For all other assets, a positive value means consumed power.",
      examples: [7000],
    },
    currentStateOfCharge: {
      anyOf: [
        {
          type: "number",
          maximum: 100,
          minimum: 0,
          description: "State of Charge in percentage (0-100%)",
          examples: [85.49],
        },
        {
          type: "null",
        },
      ],
      title: "Currentstateofcharge",
      description:
        "State of charge of the battery in percentage. Can be null / omitted if not available or if there is no battery connected to this asset. For charging poles, this should be the state of charge of the connected EV.",
      examples: [85.49],
    },
    energyPositive: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energypositive",
      description:
        "The positive energy (in Wh) measured by the asset up to the timestamp. For producing assets such as PV, this is the produced energy. For all other assets, this is the consumed energy. Can be null / omitted if the device does not report a signed energy breakdown.",
      examples: [1030404],
    },
    energyNegative: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Energynegative",
      description:
        "The negative energy (in Wh) measured by the asset up to the timestamp. For producing assets such as PV, this is the consumed energy. For all other assets, this is the produced/exported energy. Can be null / omitted if the device does not report a signed energy breakdown.",
      examples: [20404],
    },
    isCurtailed: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Iscurtailed",
      description:
        "Whether the controller was holding this asset below what it could deliver at the timestamp. Only needs to be reported for assets the controller can curtail (e.g. PV inverters); should be omitted for every other asset and for controllers that do not report it. A curtailed measurement understates what the asset would have produced, so forecasters need to take this into account, otherwise the forecast will learn the curtailed value instead of what would have been possible without curtailment.",
      examples: [true],
    },
    uncurtailedPowerValue: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Uncurtailedpowervalue",
      description:
        "The power (in W) the asset could have delivered at the timestamp if nothing had been holding it back, in the same sign convention as powerValue. Only needs to be reported by controllers steering an asset that can tell what it is giving up (e.g. a PV plant that meters its available power); should be omitted for every other asset. While isCurtailed is true this is what the asset would have done when it would not have been curtailed by the controller.",
      examples: [9000],
    },
  },
  type: "object",
  required: ["assetId", "timestamp", "energyValue", "powerValue"],
  title: "MqttMeasurement",
} as const;

export const MqttMessageFromTelegrafSchema = {
  properties: {
    fields: {
      $ref: "#/components/schemas/TelegrafFields",
    },
    name: {
      type: "string",
      title: "Name",
    },
    tags: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Tags",
    },
    timestamp: {
      type: "integer",
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["fields", "name", "tags", "timestamp"],
  title: "MqttMessageFromTelegraf",
} as const;

export const MqttRequestFromTelegrafSchema = {
  properties: {
    metrics: {
      items: {
        $ref: "#/components/schemas/MqttMessageFromTelegraf",
      },
      type: "array",
      title: "Metrics",
    },
  },
  type: "object",
  required: ["metrics"],
  title: "MqttRequestFromTelegraf",
} as const;

export const MqttTokenRequestSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
  },
  type: "object",
  required: ["site_id"],
  title: "MqttTokenRequest",
} as const;

export const MqttTokenResponseModelSchema = {
  properties: {
    access_token: {
      type: "string",
      title: "Access Token",
    },
    expires_in: {
      type: "integer",
      title: "Expires In",
    },
  },
  type: "object",
  required: ["access_token", "expires_in"],
  title: "MqttTokenResponseModel",
} as const;

export const MqttTransactionSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/AcMqttTransaction",
    },
    {
      $ref: "#/components/schemas/DcMqttTransaction",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      ac: "#/components/schemas/AcMqttTransaction",
      dc: "#/components/schemas/DcMqttTransaction",
    },
  },
} as const;

export const NumberOfAssetsSchema = {
  properties: {
    nb_ac_charging_stations: {
      type: "integer",
      title: "Nb Ac Charging Stations",
      default: 0,
    },
    nb_dc_charging_stations: {
      type: "integer",
      title: "Nb Dc Charging Stations",
      default: 0,
    },
    nb_pv_forecasters: {
      type: "integer",
      title: "Nb Pv Forecasters",
      default: 0,
    },
    nb_ucl_forecasters: {
      type: "integer",
      title: "Nb Ucl Forecasters",
      default: 0,
    },
    nb_bess: {
      type: "integer",
      title: "Nb Bess",
      default: 0,
    },
  },
  type: "object",
  title: "NumberOfAssets",
} as const;

export const NumberOfSitesSchema = {
  properties: {
    small: {
      type: "integer",
      title: "Small",
      default: 0,
    },
    medium: {
      type: "integer",
      title: "Medium",
      default: 0,
    },
    large: {
      type: "integer",
      title: "Large",
      default: 0,
    },
    extra_large: {
      type: "integer",
      title: "Extra Large",
      default: 0,
    },
    custom: {
      type: "integer",
      title: "Custom",
      default: 0,
    },
  },
  type: "object",
  title: "NumberOfSites",
} as const;

export const OAuthCredentialsSchema = {
  properties: {
    client_id: {
      type: "string",
      title: "Client Id",
    },
    hashed_client_secret: {
      type: "string",
      title: "Hashed Client Secret",
    },
  },
  type: "object",
  required: ["client_id", "hashed_client_secret"],
  title: "OAuthCredentials",
} as const;

export const OcppBrokerModeSchema = {
  type: "string",
  enum: ["transaction_linking", "smart"],
  title: "OcppBrokerMode",
} as const;

export const OcppConfigurationSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    site_id: {
      type: "string",
      title: "Site Id",
    },
    forward_url: {
      type: "string",
      title: "Forward Url",
    },
    mode: {
      $ref: "#/components/schemas/OcppBrokerMode",
      default: "transaction_linking",
    },
    socket_to_asset_map: {
      additionalProperties: {
        items: {
          type: "string",
        },
        type: "array",
      },
      type: "object",
      title: "Socket To Asset Map",
    },
    forward_url_overrides: {
      items: {
        $ref: "#/components/schemas/ForwardUrlOverride",
      },
      type: "array",
      title: "Forward Url Overrides",
    },
  },
  type: "object",
  required: ["partner_id", "site_id", "forward_url"],
  title: "OcppConfiguration",
} as const;

export const OcppIoConfig_InputSchema = {
  properties: {
    type: {
      type: "string",
      const: "ocpp",
      title: "Type",
      default: "ocpp",
    },
    charge_point_id: {
      type: "string",
      title: "Charge Point Id",
    },
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which socket of the charge point this asset is, as the charge point itself labels it in `connectorId`. Connector 0 addresses the charge point as a whole and is never an asset.",
    },
    upstream_ocpp_url: {
      type: "string",
      title: "Upstream Ocpp Url",
    },
    vendor: {
      $ref: "#/components/schemas/OcppVendor",
    },
  },
  type: "object",
  required: ["charge_point_id", "connector_id", "upstream_ocpp_url", "vendor"],
  title: "OcppIoConfig",
} as const;

export const OcppIoConfig_OutputSchema = {
  properties: {
    type: {
      type: "string",
      const: "ocpp",
      title: "Type",
      default: "ocpp",
    },
    charge_point_id: {
      type: "string",
      title: "Charge Point Id",
    },
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Which socket of the charge point this asset is, as the charge point itself labels it in `connectorId`. Connector 0 addresses the charge point as a whole and is never an asset.",
    },
    upstream_ocpp_url: {
      type: "string",
      title: "Upstream Ocpp Url",
    },
    vendor: {
      $ref: "#/components/schemas/OcppVendor",
    },
  },
  type: "object",
  required: ["charge_point_id", "connector_id", "upstream_ocpp_url", "vendor"],
  title: "OcppIoConfig",
} as const;

export const OcppMessageEntrySchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
      description:
        "When the broker received the message, not the charger's own clock.",
    },
    sender: {
      type: "string",
      enum: ["charging_pole", "cpms"],
      title: "Sender",
    },
    socket_id: {
      type: "string",
      title: "Socket Id",
      description: "The charge point id the charger connected with.",
    },
    connection_id: {
      type: "string",
      title: "Connection Id",
    },
    subprotocol: {
      type: "string",
      title: "Subprotocol",
    },
    message_type: {
      type: "string",
      enum: ["call", "call_result", "call_error", "unparsable"],
      title: "Message Type",
    },
    message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Message Id",
    },
    action: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Action",
      description:
        "The OCPP action. For call results and call errors this is the action of the call they answer.",
    },
    payload: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Payload",
    },
    error_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Code",
    },
    error_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Description",
    },
    raw: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Raw",
    },
    connector_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Connector Id",
      description:
        "The connector (OCPP 1.6) or EVSE (OCPP 2.x) of the request this message is part of.",
    },
    asset_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Asset Id",
      description: "The asset the socket-to-asset map links the connector to.",
    },
  },
  type: "object",
  required: [
    "id",
    "timestamp",
    "sender",
    "socket_id",
    "connection_id",
    "subprotocol",
    "message_type",
  ],
  title: "OcppMessageEntry",
} as const;

export const OcppMessageViewSchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
      description:
        "When the broker received the message, not the charger's own clock.",
    },
    sender: {
      type: "string",
      enum: ["charging_pole", "cpms"],
      title: "Sender",
    },
    socket_id: {
      type: "string",
      title: "Socket Id",
      description: "The charge point id the charger connected with.",
    },
    connection_id: {
      type: "string",
      title: "Connection Id",
    },
    subprotocol: {
      type: "string",
      title: "Subprotocol",
    },
    message_type: {
      type: "string",
      enum: ["call", "call_result", "call_error", "unparsable"],
      title: "Message Type",
    },
    message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Message Id",
    },
    action: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Action",
      description:
        "The OCPP action. For call results and call errors this is the action of the call they answer.",
    },
    payload: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Payload",
    },
    error_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Code",
    },
    error_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Description",
    },
    raw: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Raw",
    },
    connector_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Connector Id",
      description:
        "The connector (OCPP 1.6) or EVSE (OCPP 2.x) of the request this message is part of.",
    },
    asset_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Asset Id",
      description: "The asset the socket-to-asset map links the connector to.",
    },
    counterpart: {
      anyOf: [
        {
          $ref: "#/components/schemas/OcppMessageEntry",
        },
        {
          type: "null",
        },
      ],
      description:
        "The response to this call, or the call this response answers.",
    },
  },
  type: "object",
  required: [
    "id",
    "timestamp",
    "sender",
    "socket_id",
    "connection_id",
    "subprotocol",
    "message_type",
  ],
  title: "OcppMessageView",
} as const;

export const OcppStartCandidateSchema = {
  properties: {
    message_id: {
      type: "string",
      title: "Message Id",
    },
    action: {
      type: "string",
      title: "Action",
    },
    socket_id: {
      type: "string",
      title: "Socket Id",
    },
    subprotocol: {
      type: "string",
      title: "Subprotocol",
    },
    received_at: {
      type: "string",
      format: "date-time",
      title: "Received At",
      description: "When the broker received the start message.",
    },
    charger_started_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Charger Started At",
      description:
        "The start time reported by the charger. This is the time used for matching.",
    },
    offset_seconds: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Offset Seconds",
      description:
        "charger_started_at minus the transaction start time. Matching allows the configured window.",
    },
    evse_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Evse Id",
    },
    resolved_asset_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Resolved Asset Id",
    },
    id_token: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id Token",
    },
    authorization_status: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Authorization Status",
    },
    ocpp_transaction_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ocpp Transaction Id",
    },
    is_linked: {
      type: "boolean",
      title: "Is Linked",
      description: "This start is the one currently linked to the transaction.",
    },
    problems: {
      items: {
        $ref: "#/components/schemas/OcppStartProblem",
      },
      type: "array",
      title: "Problems",
    },
  },
  type: "object",
  required: [
    "message_id",
    "action",
    "socket_id",
    "subprotocol",
    "received_at",
    "charger_started_at",
    "offset_seconds",
    "evse_id",
    "resolved_asset_id",
    "id_token",
    "authorization_status",
    "ocpp_transaction_id",
    "is_linked",
    "problems",
  ],
  title: "OcppStartCandidate",
} as const;

export const OcppStartProblemSchema = {
  type: "string",
  enum: [
    "socket_not_mapped",
    "connector_missing",
    "connector_not_mapped",
    "different_asset",
    "id_token_missing",
    "no_response",
    "response_is_error",
    "charger_timestamp_invalid",
    "outside_match_window",
  ],
  title: "OcppStartProblem",
} as const;

export const OcppVendorSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/EaseeOcppVendor",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      easee: "#/components/schemas/EaseeOcppVendor",
    },
  },
} as const;

export const OneTimeTokenSchema = {
  properties: {
    value: {
      type: "string",
      minLength: 6,
      title: "Value",
    },
    ttl: {
      type: "integer",
      exclusiveMinimum: 0,
      title: "Ttl",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    origin: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Origin",
    },
  },
  type: "object",
  required: ["value", "ttl", "created_at"],
  title: "OneTimeToken",
} as const;

export const OptimizationConfigurationSchema = {
  properties: {
    peak_minimization: {
      anyOf: [
        {
          $ref: "#/components/schemas/PeakMinimization",
        },
        {
          type: "null",
        },
      ],
      default: {
        active: false,
      },
    },
    negative_peak_minimization: {
      anyOf: [
        {
          $ref: "#/components/schemas/PeakMinimization",
        },
        {
          type: "null",
        },
      ],
      default: {
        active: false,
      },
    },
    cost_minimization_active: {
      type: "boolean",
      title: "Cost Minimization Active",
      description:
        "Boolean field that indicates if cost minimization (energy price optimization) is activated or not.",
      default: true,
    },
    planning_frequency: {
      type: "string",
      const: "PT15M",
      title: "Planning Frequency",
      description:
        "The planned frequency at which a site will be optimized. Should follow the python timedelta notation. Currently this field is disabled as we only support 15 minutes long optimization configuration. Notation is in Pandas Timedelta notation.",
      default: "PT15M",
    },
    planning_horizon: {
      type: "string",
      enum: [
        "PT2H",
        "PT4H",
        "PT6H",
        "PT8H",
        "PT10H",
        "PT12H",
        "PT15H",
        "PT18H",
        "P1D",
        "P2D",
        "P3D",
      ],
      title: "Planning Horizon",
      description:
        "The planning horizon for which the optimization will be done. Should follow the ISO-8601 duration notation.",
      default: "P1D",
    },
  },
  type: "object",
  title: "OptimizationConfiguration",
} as const;

export const OresDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "ORES",
      title: "Dso",
    },
    region: {
      type: "string",
      enum: [
        "Brabant Wallon",
        "Est",
        "Hainaut",
        "Luxembourg",
        "Mouscron",
        "Namur",
        "Verviers",
      ],
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "T-MT avec terme capacitaire",
        "T-MT sans terme capacitaire",
        "MT avec terme capacitaire",
        "MT sans terme capacitaire",
        "T-BT avec terme capacitaire",
        "T-BT sans terme capacitaire",
        "BT>56kVA - heures normales",
        "BT>56kVA - heures pleines/creuses",
        "BT - heures normales",
        "BT - heures pleines/creuses",
        "BT - heures incitative",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "OresDSOConnection",
} as const;

export const OtherDutchDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "Other Dutch DSO",
      title: "Dso",
    },
    dso_name: {
      type: "string",
      title: "Dso Name",
    },
    contracted_offtake_kw: {
      type: "number",
      minimum: 0,
      title: "Contracted Offtake Kw",
    },
    contracted_injection_kw: {
      type: "number",
      minimum: 0,
      title: "Contracted Injection Kw",
    },
    expected_yearly_offtake_mwh: {
      type: "number",
      minimum: 0,
      title: "Expected Yearly Offtake Mwh",
    },
    price_per_kw_contracted_per_year: {
      type: "number",
      minimum: 0,
      title: "Price Per Kw Contracted Per Year",
    },
    price_per_kw_max_per_month: {
      type: "number",
      minimum: 0,
      title: "Price Per Kw Max Per Month",
    },
    grid_energy_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Grid Energy Per Mwh",
    },
    grid_fixed_yearly_price: {
      type: "number",
      minimum: 0,
      title: "Grid Fixed Yearly Price",
    },
  },
  type: "object",
  required: [
    "dso",
    "dso_name",
    "contracted_offtake_kw",
    "contracted_injection_kw",
    "expected_yearly_offtake_mwh",
    "price_per_kw_contracted_per_year",
    "price_per_kw_max_per_month",
    "grid_energy_per_mwh",
    "grid_fixed_yearly_price",
  ],
  title: "OtherDutchDSOConnection",
  description: `A connection to a smaller Dutch DSO (Westland Infra, Coteq, Rendo, a closed distribution system, ...),
carrying the rates from its own tariff sheet.`,
} as const;

export const P1MeterIoConfigSchema = {
  properties: {
    type: {
      type: "string",
      const: "p1-meter",
      title: "Type",
      default: "p1-meter",
    },
    meter_number: {
      type: "string",
      title: "Meter Number",
    },
  },
  type: "object",
  required: ["meter_number"],
  title: "P1MeterIoConfig",
} as const;

export const PaginatedResponse_BenefitReport_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/BenefitReport",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[BenefitReport]",
} as const;

export const PaginatedResponse_ControllerAlertDTO_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/ControllerAlertDTO",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[ControllerAlertDTO]",
} as const;

export const PaginatedResponse_FailedMessage_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/FailedMessage",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[FailedMessage]",
} as const;

export const PaginatedResponse_GetProfileDTO_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/GetProfileDTO",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[GetProfileDTO]",
} as const;

export const PaginatedResponse_OcppMessageView_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/OcppMessageView",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[OcppMessageView]",
} as const;

export const PaginatedResponse_Site_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/Site",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[Site]",
} as const;

export const PaginatedResponse_TaskListItemDTO_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/TaskListItemDTO",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[TaskListItemDTO]",
} as const;

export const PaginatedResponse_TransactionViewDTO_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/TransactionViewDTO",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[TransactionViewDTO]",
} as const;

export const PaginatedResponse_Transaction_Schema = {
  properties: {
    data: {
      items: {
        $ref: "#/components/schemas/Transaction",
      },
      type: "array",
      title: "Data",
    },
    page_size: {
      type: "integer",
      title: "Page Size",
    },
    end_cursor: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "End Cursor",
      description: "Cursor to retrieve the next page of results.",
    },
    has_next_page: {
      type: "boolean",
      title: "Has Next Page",
      default: false,
    },
  },
  type: "object",
  required: ["data", "page_size"],
  title: "PaginatedResponse[Transaction]",
} as const;

export const ParsingErrorSchema = {
  properties: {
    location: {
      type: "string",
      title: "Location",
      description:
        "Path to the offending field inside the message, e.g. 'measurements.0.power'.",
    },
    message: {
      type: "string",
      title: "Message",
      description: "Why that field was rejected.",
    },
  },
  type: "object",
  required: ["location", "message"],
  title: "ParsingError",
} as const;

export const Partner_InputSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Partner Id",
    },
    name: {
      type: "string",
      title: "Name",
    },
    connections: {
      anyOf: [
        {
          $ref: "#/components/schemas/Connection-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["partner_id", "name"],
  title: "Partner",
} as const;

export const Partner_OutputSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Partner Id",
    },
    name: {
      type: "string",
      title: "Name",
    },
    connections: {
      anyOf: [
        {
          $ref: "#/components/schemas/pleevi_identity__models__Partner__Connection-Output",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["partner_id", "name"],
  title: "Partner",
} as const;

export const PartnerBillingReportSchema = {
  properties: {
    nb_sites: {
      $ref: "#/components/schemas/NumberOfSites",
    },
    nb_paid_forecasters: {
      $ref: "#/components/schemas/ForecastersCount",
    },
    sites: {
      items: {
        $ref: "#/components/schemas/SiteBillingReport",
      },
      type: "array",
      title: "Sites",
    },
  },
  type: "object",
  required: ["nb_sites", "nb_paid_forecasters", "sites"],
  title: "PartnerBillingReport",
} as const;

export const PartnerInvoicingReportSchema = {
  properties: {
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    sites: {
      items: {
        $ref: "#/components/schemas/SiteInvoicingReport",
      },
      type: "array",
      title: "Sites",
    },
    grandfathered_sites: {
      items: {
        $ref: "#/components/schemas/GrandfatheredSiteReport",
      },
      type: "array",
      title: "Grandfathered Sites",
    },
    total_monthly_price: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Total Monthly Price",
    },
  },
  type: "object",
  required: ["partner_id", "total_monthly_price"],
  title: "PartnerInvoicingReport",
} as const;

export const PatchDriverDTOSchema = {
  properties: {
    email: {
      anyOf: [
        {
          type: "string",
          format: "email",
        },
        {
          type: "null",
        },
      ],
      title: "Email",
    },
    badge_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Ids",
    },
    site_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Site Ids",
    },
    email_notifications_enabled: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Email Notifications Enabled",
    },
    profile: {
      anyOf: [
        {
          $ref: "#/components/schemas/DriverProfileSchedule-Input",
        },
        {
          type: "null",
        },
      ],
      description:
        "Replace the complete charging profile schedule. Include default, timezone and all exceptions you want to retain. Omitted exceptions become an empty map. Nested fields are not merged. Omitting profile or sending null leaves the existing profile unchanged; null does not delete it. Charging preferences are validated against the driver's car when available.",
    },
  },
  type: "object",
  title: "PatchDriverDTO",
} as const;

export const PeakMinimizationSchema = {
  properties: {
    active: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Active",
      description:
        "Boolean field that indicates if the peak minimization is activated or not.",
      default: false,
    },
    peak_limit: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Peak Limit",
      description: `Specifies a line under which the peak price does not apply.
        The value specified will be applied to all the phases of the collector separately.
        By default the peak_limit is set to 0.`,
      examples: [100000],
    },
  },
  type: "object",
  title: "PeakMinimization",
} as const;

export const PendingAssetIOConfigSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    config: {
      $ref: "#/components/schemas/PendingIoConfig",
    },
    brand: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Brand",
    },
    model: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Model",
    },
  },
  type: "object",
  required: ["asset_id", "config"],
  title: "PendingAssetIOConfig",
} as const;

export const PendingIoConfigSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/PendingModbusTcpIoConfig",
    },
    {
      $ref: "#/components/schemas/P1MeterIoConfig",
    },
    {
      $ref: "#/components/schemas/VirtualIoConfig",
    },
    {
      $ref: "#/components/schemas/OcppIoConfig-Input",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "modbus-tcp": "#/components/schemas/PendingModbusTcpIoConfig",
      ocpp: "#/components/schemas/OcppIoConfig-Input",
      "p1-meter": "#/components/schemas/P1MeterIoConfig",
      virtual: "#/components/schemas/VirtualIoConfig",
    },
  },
} as const;

export const PendingModbusTcpIoConfigSchema = {
  properties: {
    type: {
      type: "string",
      const: "modbus-tcp",
      title: "Type",
      default: "modbus-tcp",
    },
    ip: {
      type: "string",
      format: "ipvanyaddress",
      title: "Ip",
    },
    port: {
      type: "integer",
      maximum: 65535,
      minimum: 0,
      title: "Port",
    },
    registers: {
      $ref: "#/components/schemas/PendingRegisters",
    },
  },
  type: "object",
  required: ["ip", "port"],
  title: "PendingModbusTcpIoConfig",
} as const;

export const PendingRegistersSchema = {
  properties: {
    type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "alfen",
            "abb-cms",
            "pqube-3",
            "abb-emax2",
            "siemens-pac2200",
            "socomec-countis",
            "sungrow-ems300cp",
            "elecnova-bcq",
            "janitza-umg604pro",
            "shelly-3em",
            "schneider-powertag",
            "schneider-pm3200-iem3000",
            "schneider-pm5100",
            "phoenix-contact-empro",
            "phoenix-contact-empro-xm",
            "carlo-gavazzi-em24",
            "algodue-upm209",
            "xemex-smart-connect",
            "alpitronix-hypercharger",
            "sungrow-idc480e-c",
            "pluon-dc",
            "autel",
            "charx",
            "etrel-inch",
            "mennekes-ecu",
            "kempower",
            "huawei-smart-logger",
            "sma-data-manager",
            "sma-sunny-tripower-core2",
            "fronius-inverter",
            "fronius-smart-meter",
            "unsupported",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Type",
    },
    connector_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Connector Id",
    },
    reference_frame: {
      anyOf: [
        {
          type: "string",
          enum: ["consumer", "producer"],
          description:
            "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
        },
        {
          type: "null",
        },
      ],
      title: "Reference Frame",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Slave Id",
    },
  },
  type: "object",
  title: "PendingRegisters",
} as const;

export const PhasePermutationSchema = {
  properties: {
    parent: {
      items: {
        type: "string",
        enum: ["L1", "L2", "L3"],
      },
      type: "array",
      title: "Parent",
    },
    child: {
      items: {
        type: "string",
        enum: ["L1", "L2", "L3"],
      },
      type: "array",
      title: "Child",
    },
  },
  type: "object",
  required: ["parent", "child"],
  title: "PhasePermutation",
} as const;

export const PhoenixContactEmproRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "phoenix-contact-empro",
      title: "Type",
      default: "phoenix-contact-empro",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "PhoenixContactEmproRegisters",
} as const;

export const PhoenixContactEmproXmRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "phoenix-contact-empro-xm",
      title: "Type",
      default: "phoenix-contact-empro-xm",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "PhoenixContactEmproXmRegisters",
} as const;

export const PinToPhaseMappingSchema = {
  properties: {
    pin_list: {
      items: {
        type: "string",
        enum: ["pin1", "pin2", "pin3"],
      },
      type: "array",
      title: "Pin List",
    },
    phase_list: {
      items: {
        type: "string",
        enum: ["L1", "L2", "L3"],
      },
      type: "array",
      title: "Phase List",
    },
  },
  type: "object",
  required: ["pin_list", "phase_list"],
  title: "PinToPhaseMapping",
} as const;

export const PluonDcRegistersSchema = {
  properties: {
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Modbus connector index of the charging pole on the charger.",
    },
    type: {
      type: "string",
      const: "pluon-dc",
      title: "Type",
      default: "pluon-dc",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "PluonDcRegisters",
} as const;

export const PoliciesUpdatedSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
      examples: ["charger-A1"],
    },
    transaction_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Transaction Id",
      examples: ["charger-A1-42"],
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    policies: {
      items: {
        $ref: "#/components/schemas/Policy",
      },
      type: "array",
      title: "Policies",
    },
    apply_until: {
      type: "string",
      format: "date-time",
      title: "Apply Until",
    },
  },
  type: "object",
  required: ["asset_id", "created_at", "policies", "apply_until"],
  title: "PoliciesUpdated",
} as const;

export const PolicySchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/SetpointPolicy",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      setpoint: "#/components/schemas/SetpointPolicy",
    },
  },
} as const;

export const Pqube3RegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "pqube-3",
      title: "Type",
      default: "pqube-3",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  title: "Pqube3Registers",
} as const;

export const ProfileSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ChargingProfile",
    },
    {
      $ref: "#/components/schemas/GridProfile",
    },
  ],
} as const;

export const ProfileApplyToSchema = {
  properties: {
    driver_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Driver Ids",
      description: "The identifiers of the drivers this profile applies to.",
      examples: [["driver-1"]],
    },
    charger_asset_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Charger Asset Ids",
      description:
        "The asset identifiers of the chargers (AC or DC) this profile applies to.",
      examples: [["LR34_001"]],
    },
  },
  type: "object",
  title: "ProfileApplyTo",
} as const;

export const PysimofSiteConfigurationCheckSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    validation_errors: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Validation Errors",
    },
  },
  type: "object",
  title: "PysimofSiteConfigurationCheck",
} as const;

export const ReceivingMeasurementsSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    not_receiving_data_from: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Not Receiving Data From",
      default: [],
      examples: [["charger-A1"]],
    },
    all_assets: {
      type: "boolean",
      title: "All Assets",
      default: false,
    },
  },
  type: "object",
  title: "ReceivingMeasurements",
} as const;

export const RegisterSiteOwnerDTOSchema = {
  properties: {
    client_id: {
      type: "string",
      minLength: 3,
      title: "Client Id",
    },
    client_secret: {
      type: "string",
      minLength: 6,
      title: "Client Secret",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      minItems: 1,
      title: "Site Ids",
    },
    partner_id: {
      type: "string",
      minLength: 3,
      title: "Partner Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    type: {
      type: "string",
      const: "site_owner",
      title: "Type",
      default: "site_owner",
    },
  },
  type: "object",
  required: ["client_id", "client_secret", "site_ids", "partner_id"],
  title: "RegisterSiteOwnerDTO",
} as const;

export const RegistersSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/AlfenRegisters",
    },
    {
      $ref: "#/components/schemas/AbbCmsRegisters",
    },
    {
      $ref: "#/components/schemas/Pqube3Registers",
    },
    {
      $ref: "#/components/schemas/AbbEmax2Registers",
    },
    {
      $ref: "#/components/schemas/SiemensPac2200Registers",
    },
    {
      $ref: "#/components/schemas/SocomecCountisRegisters",
    },
    {
      $ref: "#/components/schemas/SungrowEms300cpRegisters",
    },
    {
      $ref: "#/components/schemas/ElecnovaBcqRegisters",
    },
    {
      $ref: "#/components/schemas/JanitzaUmg604ProRegisters",
    },
    {
      $ref: "#/components/schemas/Shelly3EmRegisters",
    },
    {
      $ref: "#/components/schemas/SchneiderPowerTagRegisters",
    },
    {
      $ref: "#/components/schemas/SchneiderPm3200Iem3000Registers",
    },
    {
      $ref: "#/components/schemas/SchneiderPm5100Registers",
    },
    {
      $ref: "#/components/schemas/PhoenixContactEmproRegisters",
    },
    {
      $ref: "#/components/schemas/PhoenixContactEmproXmRegisters",
    },
    {
      $ref: "#/components/schemas/CarloGavazziEm24Registers",
    },
    {
      $ref: "#/components/schemas/AlgodueUpm209Registers",
    },
    {
      $ref: "#/components/schemas/XemexSmartConnectRegisters",
    },
    {
      $ref: "#/components/schemas/AlpitronixHyperchargerRegisters",
    },
    {
      $ref: "#/components/schemas/SungrowIdc480EcRegisters",
    },
    {
      $ref: "#/components/schemas/PluonDcRegisters",
    },
    {
      $ref: "#/components/schemas/AutelRegisters",
    },
    {
      $ref: "#/components/schemas/CharxRegisters",
    },
    {
      $ref: "#/components/schemas/EtrelInchRegisters",
    },
    {
      $ref: "#/components/schemas/MennekesEcuRegisters",
    },
    {
      $ref: "#/components/schemas/KempowerRegisters",
    },
    {
      $ref: "#/components/schemas/HuaweiSmartLoggerRegisters",
    },
    {
      $ref: "#/components/schemas/SmaDataManagerRegisters",
    },
    {
      $ref: "#/components/schemas/SmaSunnyTripowerCore2Registers",
    },
    {
      $ref: "#/components/schemas/FroniusInverterRegisters",
    },
    {
      $ref: "#/components/schemas/FroniusSmartMeterRegisters",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "abb-cms": "#/components/schemas/AbbCmsRegisters",
      "abb-emax2": "#/components/schemas/AbbEmax2Registers",
      alfen: "#/components/schemas/AlfenRegisters",
      "algodue-upm209": "#/components/schemas/AlgodueUpm209Registers",
      "alpitronix-hypercharger":
        "#/components/schemas/AlpitronixHyperchargerRegisters",
      autel: "#/components/schemas/AutelRegisters",
      "carlo-gavazzi-em24": "#/components/schemas/CarloGavazziEm24Registers",
      charx: "#/components/schemas/CharxRegisters",
      "elecnova-bcq": "#/components/schemas/ElecnovaBcqRegisters",
      "etrel-inch": "#/components/schemas/EtrelInchRegisters",
      "fronius-inverter": "#/components/schemas/FroniusInverterRegisters",
      "fronius-smart-meter": "#/components/schemas/FroniusSmartMeterRegisters",
      "huawei-smart-logger": "#/components/schemas/HuaweiSmartLoggerRegisters",
      "janitza-umg604pro": "#/components/schemas/JanitzaUmg604ProRegisters",
      kempower: "#/components/schemas/KempowerRegisters",
      "mennekes-ecu": "#/components/schemas/MennekesEcuRegisters",
      "phoenix-contact-empro":
        "#/components/schemas/PhoenixContactEmproRegisters",
      "phoenix-contact-empro-xm":
        "#/components/schemas/PhoenixContactEmproXmRegisters",
      "pluon-dc": "#/components/schemas/PluonDcRegisters",
      "pqube-3": "#/components/schemas/Pqube3Registers",
      "schneider-pm3200-iem3000":
        "#/components/schemas/SchneiderPm3200Iem3000Registers",
      "schneider-pm5100": "#/components/schemas/SchneiderPm5100Registers",
      "schneider-powertag": "#/components/schemas/SchneiderPowerTagRegisters",
      "shelly-3em": "#/components/schemas/Shelly3EmRegisters",
      "siemens-pac2200": "#/components/schemas/SiemensPac2200Registers",
      "sma-data-manager": "#/components/schemas/SmaDataManagerRegisters",
      "sma-sunny-tripower-core2":
        "#/components/schemas/SmaSunnyTripowerCore2Registers",
      "socomec-countis": "#/components/schemas/SocomecCountisRegisters",
      "sungrow-ems300cp": "#/components/schemas/SungrowEms300cpRegisters",
      "sungrow-idc480e-c": "#/components/schemas/SungrowIdc480EcRegisters",
      "xemex-smart-connect": "#/components/schemas/XemexSmartConnectRegisters",
    },
  },
} as const;

export const RequestMagicLinkDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
  },
  type: "object",
  required: ["email"],
  title: "RequestMagicLinkDTO",
} as const;

export const RequestPasswordResetDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
  },
  type: "object",
  required: ["email"],
  title: "RequestPasswordResetDTO",
} as const;

export const ResaDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "RESA",
      title: "Dso",
    },
    region: {
      type: "string",
      const: "All",
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "T-MT avec terme capacitaire",
        "T-MT sans terme capacitaire",
        "MT avec terme capacitaire",
        "MT sans terme capacitaire",
        "T-BT avec terme capacitaire",
        "T-BT sans terme capacitaire",
        "BT>56kVA - heures normales",
        "BT>56kVA - heures pleines/creuses",
        "BT - heures normales",
        "BT - heures pleines/creuses",
        "BT - heures incitative",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "ResaDSOConnection",
} as const;

export const ResetPasswordDTOSchema = {
  properties: {
    reset_token: {
      type: "string",
      title: "Reset Token",
    },
    password: {
      type: "string",
      minLength: 8,
      title: "Password",
    },
  },
  type: "object",
  required: ["reset_token", "password"],
  title: "ResetPasswordDTO",
} as const;

export const RevenueConfigurationSchema = {
  properties: {
    revenue_per_kwh_ac_charged: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Revenue Per Kwh Ac Charged",
      description: "Revenue per kWh charged by AC chargers in EUR.",
      examples: [0.25],
    },
    revenue_per_kwh_dc_charged: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Revenue Per Kwh Dc Charged",
      description: "Revenue per kWh charged by DC chargers in EUR.",
      examples: [0.55],
    },
  },
  type: "object",
  title: "RevenueConfiguration",
} as const;

export const RewDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "REW",
      title: "Dso",
    },
    region: {
      type: "string",
      const: "All",
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "T-MT avec terme capacitaire",
        "T-MT sans terme capacitaire",
        "MT avec terme capacitaire",
        "MT sans terme capacitaire",
        "T-BT avec terme capacitaire",
        "T-BT sans terme capacitaire",
        "BT>56kVA - heures normales",
        "BT>56kVA - heures pleines/creuses",
        "BT - heures normales",
        "BT - heures pleines/creuses",
        "BT - heures incitative",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "RewDSOConnection",
} as const;

export const Schedule_InputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/WeeklySchedule",
    },
    {
      $ref: "#/components/schemas/DateSchedule",
    },
    {
      $ref: "#/components/schemas/ContinuousSchedule",
    },
  ],
  discriminator: {
    propertyName: "frequency",
    mapping: {
      continuous: "#/components/schemas/ContinuousSchedule",
      once: "#/components/schemas/DateSchedule",
      weekly: "#/components/schemas/WeeklySchedule",
    },
  },
} as const;

export const Schedule_OutputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/WeeklySchedule",
    },
    {
      $ref: "#/components/schemas/DateSchedule",
    },
    {
      $ref: "#/components/schemas/ContinuousSchedule",
    },
  ],
  discriminator: {
    propertyName: "frequency",
    mapping: {
      continuous: "#/components/schemas/ContinuousSchedule",
      once: "#/components/schemas/DateSchedule",
      weekly: "#/components/schemas/WeeklySchedule",
    },
  },
} as const;

export const ScheduledBessPolicy_InputSchema = {
  properties: {
    type: {
      type: "string",
      const: "schedule",
      title: "Type",
      default: "schedule",
    },
    schedule: {
      $ref: "#/components/schemas/Schedule-Input",
      description:
        "The schedule defining when the state of charge should be between minimum_state_of_charge and maximum_state_of_charge.",
    },
    minimum_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Minimum State Of Charge",
      description:
        "The minimum state of charge to reach at the scheduled time. At each timestamp in the schedule, the state of charge will be between minimum_state_of_charge and maximum_state_of_charge.",
      examples: [20],
    },
    maximum_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Maximum State Of Charge",
      description:
        "The maximum state of charge to reach at the scheduled time. At each timestamp in the schedule, the state of charge will be between minimum_state_of_charge and maximum_state_of_charge.",
      examples: [80],
    },
    violation_price_euros_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Violation Price Euros Per Mwh",
      description:
        "Soft-constraint penalty in euros per MWh of state-of-charge band violation. The default acts as a near-hard constraint; lower values let the optimiser cross the band when the expected revenue justifies it.",
      default: 3000000,
      examples: [3000000],
    },
  },
  type: "object",
  required: ["schedule", "minimum_state_of_charge", "maximum_state_of_charge"],
  title: "ScheduledBessPolicy",
} as const;

export const ScheduledBessPolicy_OutputSchema = {
  properties: {
    type: {
      type: "string",
      const: "schedule",
      title: "Type",
      default: "schedule",
    },
    schedule: {
      $ref: "#/components/schemas/Schedule-Output",
      description:
        "The schedule defining when the state of charge should be between minimum_state_of_charge and maximum_state_of_charge.",
    },
    minimum_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Minimum State Of Charge",
      description:
        "The minimum state of charge to reach at the scheduled time. At each timestamp in the schedule, the state of charge will be between minimum_state_of_charge and maximum_state_of_charge.",
      examples: [20],
    },
    maximum_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "Maximum State Of Charge",
      description:
        "The maximum state of charge to reach at the scheduled time. At each timestamp in the schedule, the state of charge will be between minimum_state_of_charge and maximum_state_of_charge.",
      examples: [80],
    },
    violation_price_euros_per_mwh: {
      type: "number",
      minimum: 0,
      title: "Violation Price Euros Per Mwh",
      description:
        "Soft-constraint penalty in euros per MWh of state-of-charge band violation. The default acts as a near-hard constraint; lower values let the optimiser cross the band when the expected revenue justifies it.",
      default: 3000000,
      examples: [3000000],
    },
  },
  type: "object",
  required: ["schedule", "minimum_state_of_charge", "maximum_state_of_charge"],
  title: "ScheduledBessPolicy",
} as const;

export const SchneiderPm3200Iem3000RegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "schneider-pm3200-iem3000",
      title: "Type",
      default: "schneider-pm3200-iem3000",
    },
    slave_id: {
      type: "integer",
      maximum: 247,
      minimum: 1,
      title: "Modbus address",
      description:
        "The meter's Modbus address, set on its display. Behind a Panel Server, use the Virtual server ID the meter has under Settings > Modbus devices: it is the meter's own address unless another device already held that number.",
    },
  },
  type: "object",
  required: ["reference_frame", "slave_id"],
  title: "SchneiderPm3200Iem3000Registers",
} as const;

export const SchneiderPm5100RegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "schneider-pm5100",
      title: "Type",
      default: "schneider-pm5100",
    },
    slave_id: {
      type: "integer",
      maximum: 247,
      minimum: 1,
      title: "Modbus address",
      description:
        "The meter's Modbus address, set under Maint > Setup > Comm on its display. Behind a Panel Server, use the Virtual server ID the meter has under Settings > Modbus devices: it is the meter's own address unless another device already held that number.",
    },
  },
  type: "object",
  required: ["reference_frame", "slave_id"],
  title: "SchneiderPm5100Registers",
} as const;

export const SchneiderPowerTagRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "schneider-powertag",
      title: "Type",
      default: "schneider-powertag",
    },
    slave_id: {
      type: "integer",
      maximum: 247,
      minimum: 1,
      title: "Modbus address",
      description:
        "The PowerTag's Virtual server ID on its Panel Server (Settings > Wireless devices > Modbus virtual). The Panel Server assigns 100 upwards in pairing order; pin it there so re-pairing a sensor cannot shift it.",
    },
  },
  type: "object",
  required: ["reference_frame", "slave_id"],
  title: "SchneiderPowerTagRegisters",
} as const;

export const SerialNumbersSchema = {
  properties: {
    hostname: {
      type: "string",
      minLength: 1,
      title: "Hostname",
    },
    device_tree_firmware: {
      type: "string",
      minLength: 1,
      title: "Device Tree Firmware",
    },
    tpm_hash: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Tpm Hash",
    },
    mac_eth0: {
      type: "string",
      minLength: 1,
      title: "Mac Eth0",
    },
    mac_eth1: {
      anyOf: [
        {
          type: "string",
          minLength: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Mac Eth1",
    },
  },
  type: "object",
  required: [
    "hostname",
    "device_tree_firmware",
    "tpm_hash",
    "mac_eth0",
    "mac_eth1",
  ],
  title: "SerialNumbers",
} as const;

export const SetDriverCarCustomDTOSchema = {
  properties: {
    type: {
      type: "string",
      const: "custom",
      title: "Type",
    },
    make: {
      type: "string",
      title: "Make",
    },
    model: {
      type: "string",
      title: "Model",
    },
    year: {
      type: "integer",
      title: "Year",
    },
    trim: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Trim",
    },
    variant: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Variant",
    },
    ac_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ac Max Power Kw",
    },
    dc_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Dc Max Power Kw",
    },
    battery_capacity_kwh_gross: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Gross",
    },
    battery_capacity_kwh_net: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Net",
    },
    range_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Range Km",
    },
    allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Allow Zero Current",
    },
  },
  type: "object",
  required: ["type", "make", "model", "year"],
  title: "SetDriverCarCustomDTO",
} as const;

export const SetDriverCarFromDatasetDTOSchema = {
  properties: {
    type: {
      type: "string",
      const: "dataset",
      title: "Type",
    },
    unique_code: {
      type: "string",
      title: "Unique Code",
    },
    ac_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ac Max Power Kw",
    },
    dc_max_power_kw: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Dc Max Power Kw",
    },
    battery_capacity_kwh_gross: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Gross",
    },
    battery_capacity_kwh_net: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Battery Capacity Kwh Net",
    },
    range_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Range Km",
    },
    allow_zero_current: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Allow Zero Current",
    },
  },
  type: "object",
  required: ["type", "unique_code"],
  title: "SetDriverCarFromDatasetDTO",
} as const;

export const SetIdentityReadOnlyDTOSchema = {
  properties: {
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
    },
  },
  type: "object",
  required: ["is_viewer"],
  title: "SetIdentityReadOnlyDTO",
} as const;

export const SetLogLevelRequestSchema = {
  properties: {
    filter: {
      type: "string",
      minLength: 1,
      title: "Filter",
    },
  },
  type: "object",
  required: ["filter"],
  title: "SetLogLevelRequest",
} as const;

export const SetPasswordDTOSchema = {
  properties: {
    password: {
      type: "string",
      minLength: 8,
      title: "Password",
    },
    current_password: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Current Password",
    },
  },
  type: "object",
  required: ["password"],
  title: "SetPasswordDTO",
} as const;

export const SetpointPolicySchema = {
  properties: {
    type: {
      type: "string",
      const: "setpoint",
      title: "Type",
      default: "setpoint",
    },
    apply_from: {
      type: "string",
      format: "date-time",
      title: "Apply From",
    },
    min_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Current",
      description:
        "Lower bound per phase in ampere, present only while a dynamic limit applies. Held by every means the controller has, curtailing production included.",
      examples: [-400],
    },
    min_current_consumption_only: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Current Consumption Only",
      description:
        "Lower bound per phase in ampere the controller only raises consumption to reach: it never curtails production for this one, so injection below it is accepted once there is nothing left to consume it. Sits at or above `min_current`.",
      examples: [0],
    },
    desired_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Desired Current",
      description:
        "Setpoint per phase in ampere, absent when the controller is free to pick within the bounds.",
      examples: [10.43],
    },
    max_current: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Current",
      description:
        "Upper bound per phase in ampere, present only while a dynamic limit applies.",
      examples: [400],
    },
  },
  type: "object",
  required: ["apply_from"],
  title: "SetpointPolicy",
} as const;

export const SetpointsSchema = {
  properties: {
    confirmed: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Confirmed",
    },
    desired: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Desired",
    },
    effective: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Effective",
    },
  },
  type: "object",
  title: "Setpoints",
} as const;

export const Shelly3EmRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "shelly-3em",
      title: "Type",
      default: "shelly-3em",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "Shelly3EmRegisters",
} as const;

export const SibelgaDSOConnectionSchema = {
  properties: {
    dso: {
      type: "string",
      const: "Sibelga",
      title: "Dso",
    },
    region: {
      type: "string",
      const: "Brussels Capital Region",
      title: "Region",
    },
    connection_type: {
      type: "string",
      enum: [
        "MT - aliment. principale",
        "MT - aliment. secours",
        "BT - avec mesure de pointe",
        "BT - sans mesure de pointe <=13kVA",
        "BT - sans mesure de pointe >13kVA",
        "BT - sans comptage <=13kVA",
        "BT - sans comptage >13kVA",
      ],
      title: "Connection Type",
    },
  },
  type: "object",
  required: ["dso", "region", "connection_type"],
  title: "SibelgaDSOConnection",
} as const;

export const SiemensPac2200RegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "siemens-pac2200",
      title: "Type",
      default: "siemens-pac2200",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "SiemensPac2200Registers",
} as const;

export const SiteSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Partner Id",
    },
    site_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Site Id",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["Brussels Charging Hub"],
    },
    location: {
      $ref: "#/components/schemas/Location",
    },
    country: {
      type: "string",
      title: "Country",
      examples: ["BE"],
    },
    status: {
      $ref: "#/components/schemas/SiteOperatingStatus",
      description:
        "Inactive sites run nothing, shadow sites run forecasting and optimization without sending schedules to the controller, active sites run everything.",
      default: "inactive",
    },
    validation_status: {
      anyOf: [
        {
          $ref: "#/components/schemas/ValidationStatus-Output",
        },
        {
          type: "null",
        },
      ],
    },
    configurations: {
      anyOf: [
        {
          $ref: "#/components/schemas/ConfigurationBuilder-Output",
        },
        {
          type: "null",
        },
      ],
    },
    driver_email_notifications_enabled: {
      type: "boolean",
      title: "Driver Email Notifications Enabled",
      default: true,
    },
    active: {
      type: "boolean",
      title: "Active",
      readOnly: true,
    },
    connections: {
      anyOf: [
        {
          $ref: "#/components/schemas/pleevi_domain__pleevi_management__Site__Connection",
        },
        {
          type: "null",
        },
      ],
      readOnly: true,
    },
  },
  type: "object",
  required: [
    "partner_id",
    "site_id",
    "name",
    "location",
    "country",
    "active",
    "connections",
  ],
  title: "Site",
} as const;

export const SiteBillingReportSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    site_name: {
      type: "string",
      title: "Site Name",
    },
    nb_assets: {
      $ref: "#/components/schemas/NumberOfAssets",
    },
    included_assets: {
      $ref: "#/components/schemas/NumberOfAssets",
      readOnly: true,
    },
    size: {
      type: "string",
      enum: ["small", "medium", "large", "extra_large", "custom"],
      title: "Size",
      readOnly: true,
    },
  },
  type: "object",
  required: ["site_id", "site_name", "nb_assets", "included_assets", "size"],
  title: "SiteBillingReport",
} as const;

export const SiteConfiguration_InputSchema = {
  properties: {
    device_list: {
      items: {
        $ref: "#/components/schemas/Device-Input",
      },
      type: "array",
      title: "Device List",
    },
    collector_list: {
      items: {
        $ref: "#/components/schemas/Collector-Input",
      },
      type: "array",
      maxItems: 1,
      title: "Collector List",
      description:
        "The site's root collector, its grid connection. A site has exactly one; collectors below the grid connection belong in its `children`.",
    },
    grid_connection: {
      anyOf: [
        {
          $ref: "#/components/schemas/GridConnection",
        },
        {
          type: "null",
        },
      ],
      description:
        "What the DSO connection allows the site to take from and inject into the grid. The limits the grid connection is steered and tripped at are derived from it; they only ever narrow the root collector's own `line_current`, `safe_line_current` and `min_phase_current`. Left out, the site's grid connection follows its grid collector's own ratings.",
    },
  },
  type: "object",
  required: ["device_list", "collector_list"],
  title: "SiteConfiguration",
} as const;

export const SiteConfiguration_OutputSchema = {
  properties: {
    device_list: {
      items: {
        $ref: "#/components/schemas/Device-Output",
      },
      type: "array",
      title: "Device List",
    },
    collector_list: {
      items: {
        $ref: "#/components/schemas/Collector-Output",
      },
      type: "array",
      maxItems: 1,
      title: "Collector List",
      description:
        "The site's root collector, its grid connection. A site has exactly one; collectors below the grid connection belong in its `children`.",
    },
    grid_connection: {
      anyOf: [
        {
          $ref: "#/components/schemas/GridConnection",
        },
        {
          type: "null",
        },
      ],
      description:
        "What the DSO connection allows the site to take from and inject into the grid. The limits the grid connection is steered and tripped at are derived from it; they only ever narrow the root collector's own `line_current`, `safe_line_current` and `min_phase_current`. Left out, the site's grid connection follows its grid collector's own ratings.",
    },
  },
  type: "object",
  required: ["device_list", "collector_list"],
  title: "SiteConfiguration",
} as const;

export const SiteConfigurationStatus_InputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    configuration_added: {
      $ref: "#/components/schemas/ConfigurationAdded",
      default: {
        status: "UNKNOWN",
      },
    },
    configuration_complete: {
      $ref: "#/components/schemas/ConfigurationComplete",
      default: {
        status: "OK",
        missing_assets: [],
      },
    },
    valid_for_optimization: {
      $ref: "#/components/schemas/PysimofSiteConfigurationCheck",
      default: {
        status: "OK",
      },
    },
  },
  type: "object",
  title: "SiteConfigurationStatus",
} as const;

export const SiteConfigurationStatus_OutputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    configuration_added: {
      $ref: "#/components/schemas/ConfigurationAdded",
      default: {
        status: "UNKNOWN",
      },
    },
    configuration_complete: {
      $ref: "#/components/schemas/ConfigurationComplete",
      default: {
        status: "OK",
        missing_assets: [],
      },
    },
    valid_for_optimization: {
      $ref: "#/components/schemas/PysimofSiteConfigurationCheck",
      default: {
        status: "OK",
      },
    },
  },
  type: "object",
  title: "SiteConfigurationStatus",
} as const;

export const SiteCreateDTOSchema = {
  properties: {
    site_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Site Id",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["Brussels Charging Hub"],
    },
    location: {
      $ref: "#/components/schemas/Location",
    },
    country: {
      type: "string",
      title: "Country",
      examples: ["BE"],
    },
    active: {
      type: "boolean",
      title: "Active",
      default: false,
      deprecated: true,
    },
    status: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteOperatingStatus",
        },
        {
          type: "null",
        },
      ],
    },
    configurations: {
      anyOf: [
        {
          $ref: "#/components/schemas/ConfigurationBuilder-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["site_id", "name", "location", "country"],
  title: "SiteCreateDTO",
} as const;

export const SiteEnergyBucketSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    consumed_wh: {
      type: "number",
      title: "Consumed Wh",
    },
    produced_wh: {
      type: "number",
      title: "Produced Wh",
    },
    imported_wh: {
      type: "number",
      title: "Imported Wh",
    },
    exported_wh: {
      type: "number",
      title: "Exported Wh",
    },
    net_grid_wh: {
      type: "number",
      title: "Net Grid Wh",
    },
    battery_charged_wh: {
      type: "number",
      title: "Battery Charged Wh",
    },
    battery_discharged_wh: {
      type: "number",
      title: "Battery Discharged Wh",
    },
    self_consumption_rate: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Self Consumption Rate",
    },
    self_sufficiency_rate: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Self Sufficiency Rate",
    },
  },
  type: "object",
  required: [
    "timestamp",
    "consumed_wh",
    "produced_wh",
    "imported_wh",
    "exported_wh",
    "net_grid_wh",
    "battery_charged_wh",
    "battery_discharged_wh",
    "self_consumption_rate",
    "self_sufficiency_rate",
  ],
  title: "SiteEnergyBucket",
} as const;

export const SiteFilterSchema = {
  properties: {
    type: {
      $ref: "#/components/schemas/SiteFilterType",
      examples: ["FILTERED"],
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
      default: [],
      examples: [["site-1", "site-2"]],
    },
  },
  type: "object",
  required: ["type"],
  title: "SiteFilter",
} as const;

export const SiteFilterTypeSchema = {
  type: "string",
  enum: ["FILTERED", "ALL_SITES"],
  title: "SiteFilterType",
} as const;

export const SiteForecastSchema = {
  properties: {
    key: {
      additionalProperties: true,
      type: "object",
      title: "Key",
    },
    forecast_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/DeviceForecastType",
        },
        {
          type: "null",
        },
      ],
    },
    forecasted_at: {
      type: "string",
      format: "date-time",
      title: "Forecasted At",
    },
    time_window: {
      $ref: "#/components/schemas/TimeWindow",
    },
    forecast: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        format: "date-time",
      },
      type: "object",
      title: "Forecast",
    },
  },
  type: "object",
  required: [
    "key",
    "forecast_type",
    "forecasted_at",
    "time_window",
    "forecast",
  ],
  title: "SiteForecast",
} as const;

export const SiteIOConfigurationSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    asset_io_config: {
      items: {
        $ref: "#/components/schemas/AssetIOConfig-Output",
      },
      type: "array",
      title: "Asset Io Config",
    },
    controller_mode: {
      type: "string",
      enum: ["read_only", "active"],
      title: "Controller Mode",
      default: "read_only",
    },
    phase_permutation_mode: {
      type: "string",
      enum: ["worst_case", "use_topology"],
      title: "Phase Permutation Mode",
      default: "worst_case",
    },
    site_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Site Id",
    },
    partner_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Partner Id",
    },
  },
  type: "object",
  required: ["asset_io_config", "site_id", "partner_id"],
  title: "SiteIOConfiguration",
} as const;

export const SiteIOConfigurationDTOSchema = {
  properties: {
    asset_io_config: {
      items: {
        $ref: "#/components/schemas/PendingAssetIOConfig",
      },
      type: "array",
      title: "Asset Io Config",
    },
    controller_mode: {
      type: "string",
      enum: ["read_only", "active"],
      title: "Controller Mode",
      default: "read_only",
    },
    phase_permutation_mode: {
      type: "string",
      enum: ["worst_case", "use_topology"],
      title: "Phase Permutation Mode",
      default: "worst_case",
    },
  },
  type: "object",
  required: ["asset_io_config"],
  title: "SiteIOConfigurationDTO",
  description: `Request body for creating or replacing a site's IO configuration. Mirrors the
persisted \`SiteIOConfiguration\` minus the server-owned identity fields (\`site_id\`,
\`partner_id\`), with each register's \`type\` left optional — the backend derives the
register driver from every asset's brand/model (see \`_populate_register_types\`). The
create route binds it directly, so a malformed body is rejected by FastAPI with a 422;
business rules the derived config still has to satisfy stay 400s raised by the service.`,
} as const;

export const SiteIngressValidationConfig_InputSchema = {
  properties: {
    main_collector_expected_measurement_interval: {
      anyOf: [
        {
          type: "string",
          format: "duration",
        },
        {
          type: "null",
        },
      ],
      title: "Main Collector Expected Measurement Interval",
      description:
        "Expected measurement interval applied to every collector on the site. When null, collectors are always considered valid. Note: the UCL calculation requires grid measurements at least every 5 minutes to produce accurate results, so the main collector should not exceed a 5-minute interval.",
    },
    asset: {
      $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
      description:
        "Default ingress validation for assets. Used when an asset has no `ingress_validation` override and no `per_asset_type` entry matches.",
    },
    per_asset_type: {
      additionalProperties: {
        $ref: "#/components/schemas/AssetIngressValidationConfig-Input",
      },
      propertyNames: {
        $ref: "#/components/schemas/DeviceType",
      },
      type: "object",
      title: "Per Asset Type",
      description:
        "Per-asset-type defaults that override the site-level asset defaults. An asset without its own `ingress_validation` falls back to the per-type config (if present) before falling back to `asset`.",
    },
  },
  type: "object",
  title: "SiteIngressValidationConfig",
} as const;

export const SiteIngressValidationConfig_OutputSchema = {
  properties: {
    main_collector_expected_measurement_interval: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Main Collector Expected Measurement Interval",
      description:
        "Expected measurement interval applied to every collector on the site. When null, collectors are always considered valid. Note: the UCL calculation requires grid measurements at least every 5 minutes to produce accurate results, so the main collector should not exceed a 5-minute interval.",
    },
    asset: {
      $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
      description:
        "Default ingress validation for assets. Used when an asset has no `ingress_validation` override and no `per_asset_type` entry matches.",
    },
    per_asset_type: {
      additionalProperties: {
        $ref: "#/components/schemas/AssetIngressValidationConfig-Output",
      },
      propertyNames: {
        $ref: "#/components/schemas/DeviceType",
      },
      type: "object",
      title: "Per Asset Type",
      description:
        "Per-asset-type defaults that override the site-level asset defaults. An asset without its own `ingress_validation` falls back to the per-type config (if present) before falling back to `asset`.",
    },
  },
  type: "object",
  title: "SiteIngressValidationConfig",
} as const;

export const SiteInvoicingReportSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    site_name: {
      type: "string",
      title: "Site Name",
    },
    activated_at: {
      items: {
        type: "string",
        format: "date-time",
      },
      type: "array",
      title: "Activated At",
    },
    nb_ac_charging_stations: {
      type: "integer",
      title: "Nb Ac Charging Stations",
    },
    nb_dc_charging_stations: {
      type: "integer",
      title: "Nb Dc Charging Stations",
    },
    nb_pv_forecasters: {
      type: "integer",
      title: "Nb Pv Forecasters",
    },
    nb_ucl_forecasters: {
      type: "integer",
      title: "Nb Ucl Forecasters",
    },
    variable_time_horizon_active: {
      type: "boolean",
      title: "Variable Time Horizon Active",
    },
    ac_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["small", "medium", "large", "extra_large", "custom"],
        },
        {
          type: "null",
        },
      ],
      title: "Ac Tier",
    },
    dc_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["small", "medium", "large", "extra_large", "custom"],
        },
        {
          type: "null",
        },
      ],
      title: "Dc Tier",
    },
    monthly_fee: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Monthly Fee",
    },
    variable_time_horizon_addon: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Variable Time Horizon Addon",
    },
    has_ocpp_config: {
      type: "boolean",
      title: "Has Ocpp Config",
    },
    ocpp_broker_fee: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Ocpp Broker Fee",
    },
    has_drivers: {
      type: "boolean",
      title: "Has Drivers",
    },
    driver_app_fee: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Driver App Fee",
    },
    total_monthly_price: {
      type: "string",
      pattern: "^(?!^[-+.]*$)[+-]?0*\\d*\\.?\\d*$",
      title: "Total Monthly Price",
    },
  },
  type: "object",
  required: [
    "site_id",
    "site_name",
    "activated_at",
    "nb_ac_charging_stations",
    "nb_dc_charging_stations",
    "nb_pv_forecasters",
    "nb_ucl_forecasters",
    "variable_time_horizon_active",
    "ac_tier",
    "dc_tier",
    "monthly_fee",
    "variable_time_horizon_addon",
    "has_ocpp_config",
    "ocpp_broker_fee",
    "has_drivers",
    "driver_app_fee",
    "total_monthly_price",
  ],
  title: "SiteInvoicingReport",
} as const;

export const SiteKPIsSchema = {
  properties: {
    offtake_kwh: {
      type: "number",
      title: "Offtake Kwh",
    },
    injection_kwh: {
      type: "number",
      title: "Injection Kwh",
    },
    avg_month_peak_kw: {
      type: "number",
      title: "Avg Month Peak Kw",
    },
    max_month_peak_kw: {
      type: "number",
      title: "Max Month Peak Kw",
    },
    offtake_cost: {
      type: "number",
      title: "Offtake Cost",
    },
    injection_revenue: {
      type: "number",
      title: "Injection Revenue",
    },
    energy_cost: {
      type: "number",
      title: "Energy Cost",
    },
    peak_consumed_cost: {
      type: "number",
      title: "Peak Consumed Cost",
    },
    peak_reservation_cost: {
      type: "number",
      title: "Peak Reservation Cost",
    },
    total_peak_cost: {
      type: "number",
      title: "Total Peak Cost",
    },
    total_cost: {
      type: "number",
      title: "Total Cost",
    },
    total_energy_peak_cost: {
      type: "number",
      title: "Total Energy Peak Cost",
    },
    nb_charging_sessions: {
      type: "integer",
      title: "Nb Charging Sessions",
    },
    total_energy_charged_mwh: {
      type: "number",
      title: "Total Energy Charged Mwh",
    },
    avg_energy_charged_kwh: {
      type: "number",
      title: "Avg Energy Charged Kwh",
    },
    avg_duration_hours: {
      type: "number",
      title: "Avg Duration Hours",
    },
    avg_pct_required: {
      type: "number",
      title: "Avg Pct Required",
    },
    charging_revenue: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Charging Revenue",
    },
  },
  type: "object",
  required: [
    "offtake_kwh",
    "injection_kwh",
    "avg_month_peak_kw",
    "max_month_peak_kw",
    "offtake_cost",
    "injection_revenue",
    "energy_cost",
    "peak_consumed_cost",
    "peak_reservation_cost",
    "total_peak_cost",
    "total_cost",
    "total_energy_peak_cost",
    "nb_charging_sessions",
    "total_energy_charged_mwh",
    "avg_energy_charged_kwh",
    "avg_duration_hours",
    "avg_pct_required",
  ],
  title: "SiteKPIs",
} as const;

export const SiteOperatingStatusSchema = {
  type: "string",
  enum: ["inactive", "active", "shadow"],
  title: "SiteOperatingStatus",
} as const;

export const SiteOwnerSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    site_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Site Ids",
    },
    oauth_clients: {
      items: {
        $ref: "#/components/schemas/OAuthCredentials",
      },
      type: "array",
      title: "Oauth Clients",
    },
    one_time_token: {
      anyOf: [
        {
          $ref: "#/components/schemas/OneTimeToken",
        },
        {
          type: "null",
        },
      ],
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
    type: {
      type: "string",
      const: "site_owner",
      title: "Type",
      default: "site_owner",
    },
  },
  type: "object",
  required: ["site_ids", "oauth_clients", "partner_id"],
  title: "SiteOwner",
} as const;

export const SiteScheduleSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    siteId: {
      type: "string",
      title: "Siteid",
      examples: ["site-1"],
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
      examples: ["partner-1"],
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    schedules: {
      items: {
        $ref: "#/components/schemas/AssetSchedule",
      },
      type: "array",
      title: "Schedules",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
  },
  type: "object",
  required: ["siteId", "partner_id", "timestamp", "schedules"],
  title: "SiteSchedule",
} as const;

export const SiteUpdateDTOSchema = {
  properties: {
    site_id: {
      type: "string",
      pattern: "^[a-zA-Z0-9_-]{1,64}$",
      title: "Site Id",
    },
    name: {
      type: "string",
      title: "Name",
      examples: ["Brussels Charging Hub"],
    },
    location: {
      $ref: "#/components/schemas/Location",
    },
    country: {
      type: "string",
      title: "Country",
      examples: ["BE"],
    },
    configurations: {
      anyOf: [
        {
          $ref: "#/components/schemas/ConfigurationBuilder-Input",
        },
        {
          type: "null",
        },
      ],
    },
    validation_status: {
      anyOf: [
        {
          $ref: "#/components/schemas/ValidationStatus-Input",
        },
        {
          type: "null",
        },
      ],
    },
    driver_email_notifications_enabled: {
      type: "boolean",
      title: "Driver Email Notifications Enabled",
      default: true,
    },
    status: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteOperatingStatus",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["site_id", "name", "location", "country"],
  title: "SiteUpdateDTO",
} as const;

export const SmaDataManagerRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "sma-data-manager",
      title: "Type",
      default: "sma-data-manager",
    },
  },
  type: "object",
  title: "SmaDataManagerRegisters",
} as const;

export const SmaSunnyTripowerCore2RegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "sma-sunny-tripower-core2",
      title: "Type",
      default: "sma-sunny-tripower-core2",
    },
  },
  type: "object",
  title: "SmaSunnyTripowerCore2Registers",
} as const;

export const SocketMappingSuggestionSchema = {
  properties: {
    socket_id: {
      type: "string",
      title: "Socket Id",
    },
    connectors: {
      items: {
        $ref: "#/components/schemas/ConnectorAssetMapping",
      },
      type: "array",
      title: "Connectors",
    },
  },
  type: "object",
  required: ["socket_id", "connectors"],
  title: "SocketMappingSuggestion",
} as const;

export const SocomecCountisRegistersSchema = {
  properties: {
    reference_frame: {
      type: "string",
      enum: ["consumer", "producer"],
      title: "Reference Frame",
      description:
        "Sign convention of the meter's raw registers, set by CT polarity at install time. `consumer` means positive = consumption; `producer` means positive = production",
    },
    type: {
      type: "string",
      const: "socomec-countis",
      title: "Type",
      default: "socomec-countis",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  required: ["reference_frame"],
  title: "SocomecCountisRegisters",
} as const;

export const SolarPowerFlashMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "solarPower.flash:1",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    availableActivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
    "activePower",
    "availableActivePower",
  ],
  title: "SolarPowerFlashMessage",
} as const;

export const SolarPowerMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "solarPower:3",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    reactivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Reactivepower",
    },
    powerFactor: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Powerfactor",
    },
    generatedEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Generatedenergy",
    },
    availableActivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    alarms: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Alarms",
    },
    inverters: {
      anyOf: [
        {
          items: {
            additionalProperties: {
              type: "number",
            },
            type: "object",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Inverters",
    },
    environmentalSensors: {
      anyOf: [
        {
          items: {
            additionalProperties: {
              type: "number",
            },
            type: "object",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Environmentalsensors",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "SolarPowerMessage",
} as const;

export const StartLoginDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
  },
  type: "object",
  required: ["email"],
  title: "StartLoginDTO",
} as const;

export const StartLoginResponseSchema = {
  properties: {
    has_password: {
      type: "boolean",
      title: "Has Password",
    },
    has_sent_magic_link: {
      type: "boolean",
      title: "Has Sent Magic Link",
    },
  },
  type: "object",
  required: ["has_password", "has_sent_magic_link"],
  title: "StartLoginResponse",
} as const;

export const StationSchema = {
  properties: {
    identifier: {
      type: "string",
      title: "Identifier",
    },
    errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Errors",
    },
    points: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/ChargingPoint",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Points",
    },
  },
  type: "object",
  required: ["identifier"],
  title: "Station",
} as const;

export const StatusSchema = {
  type: "string",
  enum: [
    "PENDING",
    "STARTED",
    "DONE",
    "FAILED",
    "CANCELLED",
    "TIMEOUT",
    "SKIPPED",
  ],
  title: "Status",
} as const;

export const StoredIoConfig_InputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/StoredModbusTcpIoConfig-Input",
    },
    {
      $ref: "#/components/schemas/P1MeterIoConfig",
    },
    {
      $ref: "#/components/schemas/VirtualIoConfig",
    },
    {
      $ref: "#/components/schemas/OcppIoConfig-Input",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "modbus-tcp": "#/components/schemas/StoredModbusTcpIoConfig-Input",
      ocpp: "#/components/schemas/OcppIoConfig-Input",
      "p1-meter": "#/components/schemas/P1MeterIoConfig",
      virtual: "#/components/schemas/VirtualIoConfig",
    },
  },
} as const;

export const StoredIoConfig_OutputSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/StoredModbusTcpIoConfig-Output",
    },
    {
      $ref: "#/components/schemas/P1MeterIoConfig",
    },
    {
      $ref: "#/components/schemas/VirtualIoConfig",
    },
    {
      $ref: "#/components/schemas/OcppIoConfig-Output",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "modbus-tcp": "#/components/schemas/StoredModbusTcpIoConfig-Output",
      ocpp: "#/components/schemas/OcppIoConfig-Output",
      "p1-meter": "#/components/schemas/P1MeterIoConfig",
      virtual: "#/components/schemas/VirtualIoConfig",
    },
  },
} as const;

export const StoredModbusTcpIoConfig_InputSchema = {
  properties: {
    type: {
      type: "string",
      const: "modbus-tcp",
      title: "Type",
      default: "modbus-tcp",
    },
    ip: {
      type: "string",
      format: "ipvanyaddress",
      title: "Ip",
    },
    port: {
      type: "integer",
      maximum: 65535,
      minimum: 0,
      title: "Port",
    },
    registers: {
      $ref: "#/components/schemas/StoredRegisters",
    },
  },
  type: "object",
  required: ["ip", "port", "registers"],
  title: "StoredModbusTcpIoConfig",
  description: `A Modbus device as it is persisted, which may still be waiting on a register
template — narrowed to \`ModbusTcpIoConfig\` when the controller configuration is built.`,
} as const;

export const StoredModbusTcpIoConfig_OutputSchema = {
  properties: {
    type: {
      type: "string",
      const: "modbus-tcp",
      title: "Type",
      default: "modbus-tcp",
    },
    ip: {
      type: "string",
      format: "ipvanyaddress",
      title: "Ip",
    },
    port: {
      type: "integer",
      maximum: 65535,
      minimum: 0,
      title: "Port",
    },
    registers: {
      $ref: "#/components/schemas/StoredRegisters",
    },
  },
  type: "object",
  required: ["ip", "port", "registers"],
  title: "StoredModbusTcpIoConfig",
  description: `A Modbus device as it is persisted, which may still be waiting on a register
template — narrowed to \`ModbusTcpIoConfig\` when the controller configuration is built.`,
} as const;

export const StoredRegistersSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/AlfenRegisters",
    },
    {
      $ref: "#/components/schemas/AbbCmsRegisters",
    },
    {
      $ref: "#/components/schemas/Pqube3Registers",
    },
    {
      $ref: "#/components/schemas/AbbEmax2Registers",
    },
    {
      $ref: "#/components/schemas/SiemensPac2200Registers",
    },
    {
      $ref: "#/components/schemas/SocomecCountisRegisters",
    },
    {
      $ref: "#/components/schemas/SungrowEms300cpRegisters",
    },
    {
      $ref: "#/components/schemas/ElecnovaBcqRegisters",
    },
    {
      $ref: "#/components/schemas/JanitzaUmg604ProRegisters",
    },
    {
      $ref: "#/components/schemas/Shelly3EmRegisters",
    },
    {
      $ref: "#/components/schemas/SchneiderPowerTagRegisters",
    },
    {
      $ref: "#/components/schemas/SchneiderPm3200Iem3000Registers",
    },
    {
      $ref: "#/components/schemas/SchneiderPm5100Registers",
    },
    {
      $ref: "#/components/schemas/PhoenixContactEmproRegisters",
    },
    {
      $ref: "#/components/schemas/PhoenixContactEmproXmRegisters",
    },
    {
      $ref: "#/components/schemas/CarloGavazziEm24Registers",
    },
    {
      $ref: "#/components/schemas/AlgodueUpm209Registers",
    },
    {
      $ref: "#/components/schemas/XemexSmartConnectRegisters",
    },
    {
      $ref: "#/components/schemas/AlpitronixHyperchargerRegisters",
    },
    {
      $ref: "#/components/schemas/SungrowIdc480EcRegisters",
    },
    {
      $ref: "#/components/schemas/PluonDcRegisters",
    },
    {
      $ref: "#/components/schemas/AutelRegisters",
    },
    {
      $ref: "#/components/schemas/CharxRegisters",
    },
    {
      $ref: "#/components/schemas/EtrelInchRegisters",
    },
    {
      $ref: "#/components/schemas/MennekesEcuRegisters",
    },
    {
      $ref: "#/components/schemas/KempowerRegisters",
    },
    {
      $ref: "#/components/schemas/HuaweiSmartLoggerRegisters",
    },
    {
      $ref: "#/components/schemas/SmaDataManagerRegisters",
    },
    {
      $ref: "#/components/schemas/SmaSunnyTripowerCore2Registers",
    },
    {
      $ref: "#/components/schemas/FroniusInverterRegisters",
    },
    {
      $ref: "#/components/schemas/FroniusSmartMeterRegisters",
    },
    {
      $ref: "#/components/schemas/UnsupportedRegisters",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      "abb-cms": "#/components/schemas/AbbCmsRegisters",
      "abb-emax2": "#/components/schemas/AbbEmax2Registers",
      alfen: "#/components/schemas/AlfenRegisters",
      "algodue-upm209": "#/components/schemas/AlgodueUpm209Registers",
      "alpitronix-hypercharger":
        "#/components/schemas/AlpitronixHyperchargerRegisters",
      autel: "#/components/schemas/AutelRegisters",
      "carlo-gavazzi-em24": "#/components/schemas/CarloGavazziEm24Registers",
      charx: "#/components/schemas/CharxRegisters",
      "elecnova-bcq": "#/components/schemas/ElecnovaBcqRegisters",
      "etrel-inch": "#/components/schemas/EtrelInchRegisters",
      "fronius-inverter": "#/components/schemas/FroniusInverterRegisters",
      "fronius-smart-meter": "#/components/schemas/FroniusSmartMeterRegisters",
      "huawei-smart-logger": "#/components/schemas/HuaweiSmartLoggerRegisters",
      "janitza-umg604pro": "#/components/schemas/JanitzaUmg604ProRegisters",
      kempower: "#/components/schemas/KempowerRegisters",
      "mennekes-ecu": "#/components/schemas/MennekesEcuRegisters",
      "phoenix-contact-empro":
        "#/components/schemas/PhoenixContactEmproRegisters",
      "phoenix-contact-empro-xm":
        "#/components/schemas/PhoenixContactEmproXmRegisters",
      "pluon-dc": "#/components/schemas/PluonDcRegisters",
      "pqube-3": "#/components/schemas/Pqube3Registers",
      "schneider-pm3200-iem3000":
        "#/components/schemas/SchneiderPm3200Iem3000Registers",
      "schneider-pm5100": "#/components/schemas/SchneiderPm5100Registers",
      "schneider-powertag": "#/components/schemas/SchneiderPowerTagRegisters",
      "shelly-3em": "#/components/schemas/Shelly3EmRegisters",
      "siemens-pac2200": "#/components/schemas/SiemensPac2200Registers",
      "sma-data-manager": "#/components/schemas/SmaDataManagerRegisters",
      "sma-sunny-tripower-core2":
        "#/components/schemas/SmaSunnyTripowerCore2Registers",
      "socomec-countis": "#/components/schemas/SocomecCountisRegisters",
      "sungrow-ems300cp": "#/components/schemas/SungrowEms300cpRegisters",
      "sungrow-idc480e-c": "#/components/schemas/SungrowIdc480EcRegisters",
      unsupported: "#/components/schemas/UnsupportedRegisters",
      "xemex-smart-connect": "#/components/schemas/XemexSmartConnectRegisters",
    },
  },
} as const;

export const SungrowEms300cpRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "sungrow-ems300cp",
      title: "Type",
      default: "sungrow-ems300cp",
    },
  },
  type: "object",
  title: "SungrowEms300cpRegisters",
} as const;

export const SungrowIdc480EcRegistersSchema = {
  properties: {
    connector_id: {
      type: "integer",
      maximum: 255,
      minimum: 1,
      title: "Connector Id",
      description:
        "Modbus connector index of the charging pole on the charger.",
    },
    type: {
      type: "string",
      const: "sungrow-idc480e-c",
      title: "Type",
      default: "sungrow-idc480e-c",
    },
  },
  type: "object",
  required: ["connector_id"],
  title: "SungrowIdc480EcRegisters",
} as const;

export const TaskSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    task_type: {
      type: "string",
      title: "Task Type",
    },
    task_id: {
      type: "string",
      title: "Task Id",
    },
    status: {
      $ref: "#/components/schemas/Status",
    },
    scheduled_at: {
      type: "string",
      format: "date-time",
      title: "Scheduled At",
    },
    started_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Started At",
    },
    completed_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Completed At",
    },
    error_message: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Message",
    },
    error_context: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Error Context",
    },
    retries: {
      type: "integer",
      title: "Retries",
      default: 0,
    },
    response: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Response",
    },
    estimated_execution_time: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Execution Time",
    },
    interval: {
      anyOf: [
        {
          type: "string",
          pattern: "^P(T?\\d+.*)$",
        },
        {
          type: "null",
        },
      ],
      title: "Interval",
    },
    parameters: {
      anyOf: [
        {
          $ref: "#/components/schemas/BaseModel",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "partner_id",
    "task_type",
    "task_id",
    "status",
    "scheduled_at",
    "parameters",
  ],
  title: "Task",
} as const;

export const TaskListItemDTOSchema = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    task_type: {
      type: "string",
      title: "Task Type",
    },
    task_id: {
      type: "string",
      title: "Task Id",
    },
    status: {
      $ref: "#/components/schemas/Status",
    },
    scheduled_at: {
      type: "string",
      format: "date-time",
      title: "Scheduled At",
    },
  },
  type: "object",
  required: [
    "id",
    "partner_id",
    "task_type",
    "task_id",
    "status",
    "scheduled_at",
  ],
  title: "TaskListItemDTO",
} as const;

export const TelegrafFieldsSchema = {
  properties: {
    value: {
      type: "string",
      title: "Value",
    },
  },
  type: "object",
  required: ["value"],
  title: "TelegrafFields",
} as const;

export const TimeSeriesPointSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    value: {
      type: "number",
      title: "Value",
    },
  },
  type: "object",
  required: ["timestamp", "value"],
  title: "TimeSeriesPoint",
} as const;

export const TimeWindowSchema = {
  properties: {
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
      examples: ["2024-01-01T00:00:00+01:00"],
    },
    end_time: {
      type: "string",
      format: "date-time",
      title: "End Time",
      examples: ["2024-01-02T00:00:00+01:00"],
    },
    sample_size: {
      type: "number",
      title: "Sample Size",
      default: 900,
      examples: [900],
    },
    nb_of_samples: {
      type: "integer",
      title: "Nb Of Samples",
      readOnly: true,
    },
  },
  type: "object",
  required: ["start_time", "end_time", "nb_of_samples"],
  title: "TimeWindow",
} as const;

export const TransactionSchema = {
  anyOf: [
    {
      $ref: "#/components/schemas/AcTransaction",
    },
    {
      $ref: "#/components/schemas/DcTransaction",
    },
  ],
} as const;

export const TransactionEventViewDTOSchema = {
  properties: {
    event_name: {
      type: "string",
      title: "Event Name",
    },
    event_detail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Event Detail",
    },
    received_at: {
      type: "string",
      format: "date-time",
      title: "Received At",
    },
    transaction_state: {
      $ref: "#/components/schemas/TransactionState",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    estimated_departure_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Departure Time",
    },
    stop_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stop Time",
    },
    requested_min_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min Energy",
    },
    max_power: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Power",
    },
    profile_id: {
      type: "string",
      title: "Profile Id",
    },
    badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Id",
    },
  },
  type: "object",
  required: [
    "event_name",
    "received_at",
    "transaction_state",
    "started_at",
    "estimated_departure_time",
    "stop_time",
    "requested_min_energy",
    "max_power",
    "profile_id",
    "badge_id",
  ],
  title: "TransactionEventViewDTO",
} as const;

export const TransactionLinkingDiagnosisSchema = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    transaction_id: {
      type: "string",
      title: "Transaction Id",
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    started_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Started At",
    },
    mqtt_badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Mqtt Badge Id",
      description: "The badge id the transaction itself reported, if any.",
    },
    linked_ocpp_start: {
      anyOf: [
        {
          $ref: "#/components/schemas/LinkedOcppStart",
        },
        {
          type: "null",
        },
      ],
    },
    broker_mode: {
      $ref: "#/components/schemas/OcppBrokerMode",
    },
    mapped_connectors: {
      items: {
        $ref: "#/components/schemas/MappedConnector",
      },
      type: "array",
      title: "Mapped Connectors",
      description:
        "The OCPP connectors that the socket-to-asset map links to this transaction's asset.",
    },
    match_window_seconds: {
      type: "number",
      title: "Match Window Seconds",
    },
    search_window_seconds: {
      type: "number",
      title: "Search Window Seconds",
    },
    problems: {
      items: {
        $ref: "#/components/schemas/TransactionLinkingProblem",
      },
      type: "array",
      title: "Problems",
    },
    candidates: {
      items: {
        $ref: "#/components/schemas/OcppStartCandidate",
      },
      type: "array",
      title: "Candidates",
    },
  },
  type: "object",
  required: [
    "site_id",
    "transaction_id",
    "asset_id",
    "started_at",
    "mqtt_badge_id",
    "linked_ocpp_start",
    "broker_mode",
    "mapped_connectors",
    "match_window_seconds",
    "search_window_seconds",
    "problems",
    "candidates",
  ],
  title: "TransactionLinkingDiagnosis",
} as const;

export const TransactionLinkingProblemSchema = {
  type: "string",
  enum: [
    "broker_not_in_linking_mode",
    "transaction_start_unknown",
    "asset_not_mapped",
    "no_ocpp_start_found",
  ],
  title: "TransactionLinkingProblem",
} as const;

export const TransactionMeasurementSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    power_value: {
      type: "number",
      title: "Power Value",
    },
  },
  type: "object",
  required: ["timestamp", "power_value"],
  title: "TransactionMeasurement",
} as const;

export const TransactionMeasurementsResponseSchema = {
  properties: {
    measurements: {
      items: {
        $ref: "#/components/schemas/TransactionMeasurement",
      },
      type: "array",
      title: "Measurements",
    },
  },
  type: "object",
  required: ["measurements"],
  title: "TransactionMeasurementsResponse",
} as const;

export const TransactionStartSchema = {
  properties: {
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
    evse_id: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Evse Id",
    },
  },
  type: "object",
  required: ["timestamp"],
  title: "TransactionStart",
} as const;

export const TransactionStateSchema = {
  type: "string",
  enum: ["Started", "Updated", "SuspendedEV", "Ended"],
  title: "TransactionState",
} as const;

export const TransactionStatsSchema = {
  properties: {
    transaction_id: {
      type: "string",
      title: "Transaction Id",
    },
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Id",
    },
    driver_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Id",
    },
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
    },
    stop_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stop Time",
    },
    was_suspended: {
      type: "boolean",
      title: "Was Suspended",
    },
    ended_while_suspended: {
      type: "boolean",
      title: "Ended While Suspended",
    },
    requested_energy_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Energy Wh",
    },
    delivered_energy_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Delivered Energy Wh",
    },
    missed_energy: {
      anyOf: [
        {
          $ref: "#/components/schemas/MissedEnergy",
        },
        {
          type: "null",
        },
      ],
    },
    duration_hours: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Duration Hours",
    },
    requested_duration_hours: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Duration Hours",
    },
    flexibility: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Flexibility",
    },
    driver_comfort_score: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Driver Comfort Score",
    },
    net_driver_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Net Driver Score",
    },
  },
  type: "object",
  required: [
    "transaction_id",
    "asset_id",
    "badge_id",
    "driver_id",
    "start_time",
    "stop_time",
    "was_suspended",
    "ended_while_suspended",
    "requested_energy_wh",
    "delivered_energy_wh",
    "missed_energy",
    "duration_hours",
    "requested_duration_hours",
    "flexibility",
    "driver_comfort_score",
    "net_driver_score",
  ],
  title: "TransactionStats",
} as const;

export const TransactionSummarySchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    timestamp: {
      type: "string",
      format: "date-time",
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["asset_id", "timestamp"],
  title: "TransactionSummary",
} as const;

export const TransactionTypeSchema = {
  type: "string",
  enum: ["ac", "dc"],
  title: "TransactionType",
} as const;

export const TransactionViewDTOSchema = {
  properties: {
    asset_id: {
      type: "string",
      title: "Asset Id",
    },
    transaction_id: {
      type: "string",
      title: "Transaction Id",
    },
    transaction_state: {
      $ref: "#/components/schemas/TransactionState",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    estimated_departure_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Estimated Departure Time",
    },
    stop_time: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Stop Time",
    },
    requested_min_energy: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Requested Min Energy",
    },
    max_power: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Power",
    },
    profile_id: {
      type: "string",
      title: "Profile Id",
    },
    badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Id",
    },
    event_count: {
      type: "integer",
      title: "Event Count",
    },
    latest_event_name: {
      type: "string",
      title: "Latest Event Name",
    },
    latest_event_received_at: {
      type: "string",
      format: "date-time",
      title: "Latest Event Received At",
    },
    events: {
      items: {
        $ref: "#/components/schemas/TransactionEventViewDTO",
      },
      type: "array",
      title: "Events",
    },
    calculated_amount_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Calculated Amount Wh",
    },
  },
  type: "object",
  required: [
    "asset_id",
    "transaction_id",
    "transaction_state",
    "started_at",
    "estimated_departure_time",
    "stop_time",
    "requested_min_energy",
    "max_power",
    "profile_id",
    "badge_id",
    "event_count",
    "latest_event_name",
    "latest_event_received_at",
    "events",
  ],
  title: "TransactionViewDTO",
} as const;

export const UnsupportedRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "unsupported",
      title: "Type",
      default: "unsupported",
    },
    slave_id: {
      anyOf: [
        {
          type: "integer",
          maximum: 255,
          minimum: 1,
        },
        {
          type: "null",
        },
      ],
      title: "Modbus address",
      description:
        "The Modbus address (unit id) the device answers on. Leave it empty when the device has an IP address of its own, so it is read on its default address; behind a Modbus TCP gateway, use the address the gateway forwards to this device. Devices sharing an IP address each need one of their own.",
    },
  },
  type: "object",
  title: "UnsupportedRegisters",
  description: `Register placeholder for an edge device the controller has no register template
for yet.

The dashboard lets operators pick hardware that is not (yet) supported by the
controller, so this is persisted (see \`StoredRegisters\`) to let the topology be saved
while the brand/model are recorded for mapping to a real register later. It is
deliberately absent from \`Registers\`: an asset carrying it is left out of the
controller's configuration entirely, because the controller has no way to read it.`,
} as const;

export const UpdateDriverEmailDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
  },
  type: "object",
  required: ["email"],
  title: "UpdateDriverEmailDTO",
} as const;

export const UpdateEmailNotificationsDTOSchema = {
  properties: {
    email_notifications_enabled: {
      type: "boolean",
      title: "Email Notifications Enabled",
    },
  },
  type: "object",
  required: ["email_notifications_enabled"],
  title: "UpdateEmailNotificationsDTO",
} as const;

export const UpdateOcppConfigurationDTOSchema = {
  properties: {
    forward_url: {
      type: "string",
      title: "Forward Url",
    },
    mode: {
      $ref: "#/components/schemas/OcppBrokerMode",
    },
    forward_url_overrides: {
      items: {
        $ref: "#/components/schemas/ForwardUrlOverride",
      },
      type: "array",
      title: "Forward Url Overrides",
    },
  },
  type: "object",
  required: ["forward_url", "mode"],
  title: "UpdateOcppConfigurationDTO",
} as const;

export const UpdateProfileDTOSchema = {
  properties: {
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ac: {
      anyOf: [
        {
          $ref: "#/components/schemas/AcChargingProfile-Input",
        },
        {
          type: "null",
        },
      ],
    },
    dc: {
      anyOf: [
        {
          $ref: "#/components/schemas/DcChargingProfile-Input",
        },
        {
          type: "null",
        },
      ],
    },
    override_transaction_input: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Override Transaction Input",
    },
    apply_to: {
      anyOf: [
        {
          $ref: "#/components/schemas/ProfileApplyTo",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "UpdateProfileDTO",
} as const;

export const UpdateSiteConfigurationDTOSchema = {
  properties: {
    site_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteConfiguration-Input",
        },
        {
          type: "null",
        },
      ],
    },
    optimization_configuration: {
      anyOf: [
        {
          $ref: "#/components/schemas/OptimizationConfiguration",
        },
        {
          type: "null",
        },
      ],
    },
    energy_contract: {
      anyOf: [
        {
          $ref: "#/components/schemas/EnergyProviderContract-Input",
        },
        {
          type: "null",
        },
      ],
    },
    dso_connection: {
      anyOf: [
        {
          $ref: "#/components/schemas/DSOConnection",
        },
        {
          type: "null",
        },
      ],
    },
    ingress_validation: {
      anyOf: [
        {
          $ref: "#/components/schemas/SiteIngressValidationConfig-Input",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "UpdateSiteConfigurationDTO",
} as const;

export const UpdateSocketToAssetMapDTOSchema = {
  properties: {
    sockets_to_delete: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Sockets To Delete",
    },
    sockets_to_upsert: {
      additionalProperties: {
        items: {
          type: "string",
        },
        type: "array",
      },
      type: "object",
      title: "Sockets To Upsert",
    },
  },
  type: "object",
  title: "UpdateSocketToAssetMapDTO",
} as const;

export const UserSchema = {
  properties: {
    _id: {
      type: "string",
      title: "Id",
      example: "5eb7cf5a86d9755df3a6c593",
    },
    partner_id: {
      type: "string",
      title: "Partner Id",
    },
    oauth_clients: {
      items: {
        $ref: "#/components/schemas/OAuthCredentials",
      },
      type: "array",
      title: "Oauth Clients",
    },
    one_time_token: {
      anyOf: [
        {
          $ref: "#/components/schemas/OneTimeToken",
        },
        {
          type: "null",
        },
      ],
    },
    is_viewer: {
      type: "boolean",
      title: "Is Viewer",
      default: false,
    },
    token_version: {
      type: "integer",
      title: "Token Version",
      default: 0,
    },
    type: {
      type: "string",
      const: "user",
      title: "Type",
      default: "user",
    },
  },
  type: "object",
  required: ["partner_id", "oauth_clients"],
  title: "User",
} as const;

export const ValidationErrorSchema = {
  properties: {
    loc: {
      items: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
        ],
      },
      type: "array",
      title: "Location",
    },
    msg: {
      type: "string",
      title: "Message",
    },
    type: {
      type: "string",
      title: "Error Type",
    },
  },
  type: "object",
  required: ["loc", "msg", "type"],
  title: "ValidationError",
} as const;

export const ValidationEventFilterSchema = {
  type: "string",
  enum: ["MISSING_ASSETS", "NOT_RECEIVING_DATA"],
  title: "ValidationEventFilter",
} as const;

export const ValidationStatus_InputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    site_configuration_status: {
      $ref: "#/components/schemas/SiteConfigurationStatus-Input",
      default: {
        status: "UNKNOWN",
        configuration_added: {
          status: "UNKNOWN",
        },
        configuration_complete: {
          missing_assets: [],
          status: "OK",
        },
        valid_for_optimization: {
          status: "OK",
        },
      },
    },
    optimization_configuration_status: {
      $ref: "#/components/schemas/ConfigurationAdded",
      default: {
        status: "UNKNOWN",
      },
    },
    ingress_status: {
      $ref: "#/components/schemas/IngressStatus-Input",
      default: {
        status: "OK",
        receiving_measurement_data: {
          all_assets: false,
          not_receiving_data_from: [],
          status: "OK",
        },
      },
    },
    last_validation: {
      type: "string",
      format: "date-time",
      title: "Last Validation",
    },
  },
  type: "object",
  title: "ValidationStatus",
} as const;

export const ValidationStatus_OutputSchema = {
  properties: {
    status: {
      $ref: "#/components/schemas/ValidationStatusEnum",
      default: "UNKNOWN",
    },
    site_configuration_status: {
      $ref: "#/components/schemas/SiteConfigurationStatus-Output",
      default: {
        status: "UNKNOWN",
        configuration_added: {
          status: "UNKNOWN",
        },
        configuration_complete: {
          missing_assets: [],
          status: "OK",
        },
        valid_for_optimization: {
          status: "OK",
        },
      },
    },
    optimization_configuration_status: {
      $ref: "#/components/schemas/ConfigurationAdded",
      default: {
        status: "UNKNOWN",
      },
    },
    ingress_status: {
      $ref: "#/components/schemas/IngressStatus-Output",
      default: {
        status: "OK",
        receiving_measurement_data: {
          all_assets: false,
          not_receiving_data_from: [],
          status: "OK",
        },
      },
    },
    last_validation: {
      type: "string",
      format: "date-time",
      title: "Last Validation",
    },
  },
  type: "object",
  title: "ValidationStatus",
} as const;

export const ValidationStatusEnumSchema = {
  type: "string",
  enum: ["ERROR", "WARNING", "OK", "UNKNOWN"],
  title: "ValidationStatusEnum",
} as const;

export const VerifyMagicLinkDTOSchema = {
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "Email",
    },
    token: {
      type: "string",
      maxLength: 6,
      minLength: 6,
      title: "Token",
    },
  },
  type: "object",
  required: ["email", "token"],
  title: "VerifyMagicLinkDTO",
} as const;

export const VerifyMagicLinkTokenDTOSchema = {
  properties: {
    token: {
      type: "string",
      minLength: 1,
      title: "Token",
    },
  },
  type: "object",
  required: ["token"],
  title: "VerifyMagicLinkTokenDTO",
} as const;

export const VirtualIoConfigSchema = {
  properties: {
    type: {
      type: "string",
      const: "virtual",
      title: "Type",
      default: "virtual",
    },
    failsafe_when_a_child_stops_reporting: {
      type: "boolean",
      title: "Failsafe When A Child Stops Reporting",
      description:
        "Whether a child that stops reporting takes this collector down with it. When true, the derived measurement is only trusted while every child reports, so one silent child makes the collector unhealthy and the controller steers its whole subtree to 0 A. When false, the collector keeps deriving from what it last knew and never goes unhealthy on its children: a silent child still counts for the current it last reported, which the metered collectors above it book as uncontrollable load, and the rest of the subtree keeps being steered. Turn it off only where a silent child cannot push this collector's own line past its rating.",
      default: true,
    },
  },
  type: "object",
  title: "VirtualIoConfig",
  description:
    "A collector the controller derives by summing its children instead of measuring it.",
} as const;

export const WeeklyScheduleSchema = {
  properties: {
    frequency: {
      type: "string",
      const: "weekly",
      title: "Frequency",
      default: "weekly",
    },
    day_of_week: {
      items: {
        $ref: "#/components/schemas/DayOfWeek",
      },
      type: "array",
      minItems: 1,
      title: "Day Of Week",
      description: "Days of week when the schedule runs",
      examples: [["monday", "friday"], ["saturday"]],
    },
    time: {
      type: "string",
      pattern: "^([0-1][0-9]|2[0-3]):[0-5][0-9]$",
      title: "Time",
      description: "Time in HH:MM format (24-hour)",
      examples: ["09:00", "14:30", "23:59"],
    },
    timezone: {
      type: "string",
      title: "Timezone",
      description: "IANA timezone identifier",
      examples: ["America/New_York", "Europe/London", "UTC"],
    },
  },
  type: "object",
  required: ["day_of_week", "time", "timezone"],
  title: "WeeklySchedule",
  description:
    "Schedule that runs on specific days of the week at a specific time.",
} as const;

export const WindPowerFlashMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "windPower.flash:1",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    availableActivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "WindPowerFlashMessage",
} as const;

export const WindPowerMessageSchema = {
  properties: {
    type: {
      type: "string",
      const: "windPower:3",
      title: "Type",
    },
    teleportHashId: {
      type: "string",
      title: "Teleporthashid",
    },
    assetIdentifier: {
      type: "string",
      title: "Assetidentifier",
    },
    attempt: {
      type: "integer",
      title: "Attempt",
    },
    measuredAt: {
      type: "string",
      format: "date-time",
      title: "Measuredat",
    },
    scheduled: {
      type: "boolean",
      title: "Scheduled",
    },
    cellularSignalQuality: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Cellularsignalquality",
    },
    activePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Activepower",
    },
    reactivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Reactivepower",
    },
    powerFactor: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Powerfactor",
    },
    windSpeed: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Windspeed",
    },
    availableActivePower: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Availableactivepower",
    },
    constrainedAvailableActivePower: {
      anyOf: [
        {
          additionalProperties: {
            type: "number",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Constrainedavailableactivepower",
    },
    converters: {
      anyOf: [
        {
          items: {
            additionalProperties: true,
            type: "object",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Converters",
    },
    setpoints: {
      anyOf: [
        {
          $ref: "#/components/schemas/Setpoints",
        },
        {
          type: "null",
        },
      ],
    },
    generatedEnergy: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Generatedenergy",
    },
  },
  type: "object",
  required: [
    "type",
    "teleportHashId",
    "assetIdentifier",
    "attempt",
    "measuredAt",
    "scheduled",
  ],
  title: "WindPowerMessage",
} as const;

export const WorkloadIdentityTokenResponseModelSchema = {
  properties: {
    access_token: {
      type: "string",
      title: "Access Token",
    },
    expires_in: {
      type: "integer",
      title: "Expires In",
    },
  },
  type: "object",
  required: ["access_token", "expires_in"],
  title: "WorkloadIdentityTokenResponseModel",
} as const;

export const XemexSmartConnectRegistersSchema = {
  properties: {
    type: {
      type: "string",
      const: "xemex-smart-connect",
      title: "Type",
      default: "xemex-smart-connect",
    },
  },
  type: "object",
  title: "XemexSmartConnectRegisters",
} as const;

export const YearMonthSchema = {
  properties: {
    year: {
      type: "integer",
      title: "Year",
    },
    month: {
      type: "integer",
      title: "Month",
    },
  },
  type: "object",
  required: ["year", "month"],
  title: "YearMonth",
} as const;

export const _BatteryCapacityMeasuredEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "battery_capacity_measured",
      title: "Kind",
    },
    energy_wh: {
      type: "number",
      title: "Energy Wh",
    },
    from_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "From State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
    to_state_of_charge: {
      type: "number",
      maximum: 100,
      minimum: 0,
      title: "To State Of Charge",
      description: "State of Charge in percentage (0-100%)",
      examples: [85.49],
    },
  },
  type: "object",
  required: ["kind", "energy_wh", "from_state_of_charge", "to_state_of_charge"],
  title: "_BatteryCapacityMeasuredEvent",
} as const;

export const _EndedEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "ended",
      title: "Kind",
    },
  },
  type: "object",
  required: ["kind"],
  title: "_EndedEvent",
} as const;

export const _MeasuredChargingDetailsEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "measured_charging_details",
      title: "Kind",
    },
    max_power_w: {
      type: "number",
      title: "Max Power W",
    },
    used_charging_pins: {
      items: {
        type: "string",
        enum: ["pin1", "pin2", "pin3"],
      },
      type: "array",
      title: "Used Charging Pins",
    },
  },
  type: "object",
  required: ["kind", "max_power_w", "used_charging_pins"],
  title: "_MeasuredChargingDetailsEvent",
} as const;

export const _RestartedChargingEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "restarted_charging",
      title: "Kind",
    },
  },
  type: "object",
  required: ["kind"],
  title: "_RestartedChargingEvent",
} as const;

export const _StartedEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "started",
      title: "Kind",
    },
    initial_energy_wh: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Initial Energy Wh",
    },
    badge_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Badge Id",
      description:
        "The RFID badge / idTag of the card presented to start the session",
    },
    vehicle_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vehicle Id",
      description:
        "The identifier the vehicle reported to the charger at the start of the session, e.g. its EVCCID",
    },
  },
  type: "object",
  required: ["kind"],
  title: "_StartedEvent",
} as const;

export const _SuspendedEvEventSchema = {
  properties: {
    kind: {
      type: "string",
      const: "suspended_ev",
      title: "Kind",
    },
  },
  type: "object",
  required: ["kind"],
  title: "_SuspendedEvEvent",
} as const;

export const pleevi_domain__pleevi_management__Site__ConnectionSchema = {
  properties: {
    mqtt: {
      $ref: "#/components/schemas/pleevi_domain__pleevi_management__Site__MQTTConfig",
    },
  },
  type: "object",
  required: ["mqtt"],
  title: "Connection",
} as const;

export const pleevi_domain__pleevi_management__Site__MQTTConfigSchema = {
  properties: {
    cluster: {
      type: "string",
      title: "Cluster",
      default: "mqtt.pleevi.ai",
    },
    energy_measurement_topic: {
      type: "string",
      title: "Energy Measurement Topic",
      examples: [
        "pleevi/v2/partner-1/site-1/asset/<asset_id>/energyMeasurement",
      ],
    },
    transaction_topic: {
      type: "string",
      title: "Transaction Topic",
      examples: ["pleevi/v2/partner-1/site-1/asset/<asset_id>/transaction"],
    },
    advice_topic: {
      type: "string",
      title: "Advice Topic",
      examples: ["pleevi/v2/partner-1/site-1/asset/<asset_id>/advice"],
    },
    notification_topic: {
      type: "string",
      title: "Notification Topic",
      examples: ["pleevi/v2/partner-1/site-1/notification/<event_name>"],
    },
  },
  type: "object",
  required: [
    "energy_measurement_topic",
    "transaction_topic",
    "advice_topic",
    "notification_topic",
  ],
  title: "MQTTConfig",
} as const;

export const pleevi_identity__models__Partner__Connection_OutputSchema = {
  properties: {
    mqtt: {
      anyOf: [
        {
          $ref: "#/components/schemas/pleevi_identity__models__Partner__MQTTConfig",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "Connection",
} as const;

export const pleevi_identity__models__Partner__MQTTConfigSchema = {
  properties: {
    host: {
      type: "string",
      title: "Host",
    },
    topic: {
      type: "integer",
      title: "Topic",
    },
    username: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Username",
    },
    password: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Password",
    },
    tls: {
      type: "boolean",
      title: "Tls",
      default: false,
    },
    client_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Id",
    },
  },
  type: "object",
  required: ["host", "topic"],
  title: "MQTTConfig",
} as const;
